
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7651"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7651"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("383do", function(module, exports) {
module.exports = import.meta.resolve("3KBHD");

});

parcelRegister("i2qrx", function(module, exports) {
module.exports = import.meta.resolve("3A1rP");

});

parcelRegister("IoThy", function(module, exports) {
module.exports = import.meta.resolve("lBmry");

});

parcelRegister("gMKnz", function(module, exports) {
module.exports = import.meta.resolve("cQ1uH");

});

parcelRegister("8PAWz", function(module, exports) {

$parcel$export(module.exports, "getLoginToken", () => $9e7ee0b2974913c0$export$b154f1a67bb7b5d9);
$parcel$export(module.exports, "setLoginToken", () => $9e7ee0b2974913c0$export$4dbcba3b4ea11a19);
$parcel$export(module.exports, "getApiBaseUrl", () => $9e7ee0b2974913c0$export$4d28219d42798a75);
$parcel$export(module.exports, "updateMe", () => $9e7ee0b2974913c0$export$8ddaddf355aae59c);
$parcel$export(module.exports, "uploadMeAvatar", () => $9e7ee0b2974913c0$export$e5f48a70142e06bf);
$parcel$export(module.exports, "resetApiToken", () => $9e7ee0b2974913c0$export$c5eea955a88464ec);
$parcel$export(module.exports, "resetLoginToken", () => $9e7ee0b2974913c0$export$c2a104aacbacefaa);
$parcel$export(module.exports, "newbieStart", () => $9e7ee0b2974913c0$export$ea49889f7616fcf2);
$parcel$export(module.exports, "newbieNew", () => $9e7ee0b2974913c0$export$92756d14cbd5cc30);
$parcel$export(module.exports, "guobiaoNewbieStart", () => $9e7ee0b2974913c0$export$109dfbde830570f5);
$parcel$export(module.exports, "guobiaoNewbieNew", () => $9e7ee0b2974913c0$export$dd05c0c1494fd830);
$parcel$export(module.exports, "bindActiveChatgptGame", () => $9e7ee0b2974913c0$export$3342556cc7b4714a);
$parcel$export(module.exports, "createChatgptOAuthAuthorizeRedirect", () => $9e7ee0b2974913c0$export$f1f66155db049887);
$parcel$export(module.exports, "fetchActiveGame", () => $9e7ee0b2974913c0$export$2e1b665d364d6930);
$parcel$export(module.exports, "abandonActiveGame", () => $9e7ee0b2974913c0$export$8c656dddbbc2d2ef);
$parcel$export(module.exports, "fetchTrusteeStatus", () => $9e7ee0b2974913c0$export$82bc2c03e989df27);
$parcel$export(module.exports, "disableTrustee", () => $9e7ee0b2974913c0$export$76eb5b5e3bdae2de);
$parcel$export(module.exports, "ensureUser", () => $9e7ee0b2974913c0$export$497e1c057f8b78d1);
$parcel$export(module.exports, "fetchMeWithToken", () => $9e7ee0b2974913c0$export$348031c3192ccb78);
$parcel$export(module.exports, "fetchMatchPointsInfo", () => $9e7ee0b2974913c0$export$2841f326108dece9);
$parcel$export(module.exports, "fetchMatchPointsInfoWithToken", () => $9e7ee0b2974913c0$export$d2f7ba77b6258c18);
$parcel$export(module.exports, "claimDailyMatchPoints", () => $9e7ee0b2974913c0$export$9f47f53f8aa750c6);

var $iRbTC = parcelRequire("iRbTC");

var $2glTM = parcelRequire("2glTM");
const $9e7ee0b2974913c0$var$LOGIN_TOKEN_KEY = 'mjlab_login_token';
const $9e7ee0b2974913c0$var$LEGACY_LOGIN_TOKEN_KEY = 'autotable_login_token';
let $9e7ee0b2974913c0$var$ensureUserInFlightDefault = null;
let $9e7ee0b2974913c0$var$ensureUserInFlightStrict = null;
function $9e7ee0b2974913c0$export$b154f1a67bb7b5d9() {
    try {
        const current = localStorage.getItem($9e7ee0b2974913c0$var$LOGIN_TOKEN_KEY);
        if (current) return current;
        const legacy = localStorage.getItem($9e7ee0b2974913c0$var$LEGACY_LOGIN_TOKEN_KEY);
        if (legacy) {
            localStorage.setItem($9e7ee0b2974913c0$var$LOGIN_TOKEN_KEY, legacy);
            return legacy;
        }
        return null;
    } catch  {
        return null;
    }
}
function $9e7ee0b2974913c0$export$4dbcba3b4ea11a19(token) {
    try {
        if (token) localStorage.setItem($9e7ee0b2974913c0$var$LOGIN_TOKEN_KEY, token);
        else localStorage.removeItem($9e7ee0b2974913c0$var$LOGIN_TOKEN_KEY);
        // Keep legacy key cleared to avoid confusion.
        if (!token) localStorage.removeItem($9e7ee0b2974913c0$var$LEGACY_LOGIN_TOKEN_KEY);
    } catch  {
    // ignore
    }
}
function $9e7ee0b2974913c0$export$4d28219d42798a75() {
    // @ts-ignore
    const env = "production";
    if (env !== 'production') return 'http://localhost:1235/api';
    const basePath = (0, $iRbTC.getBasePath)();
    return `${window.location.origin}${basePath}api`;
}
async function $9e7ee0b2974913c0$export$12d407bce29ab995() {
    return $9e7ee0b2974913c0$var$apiJson('/auth/anonymous', {
        method: 'POST'
    });
}
async function $9e7ee0b2974913c0$export$2962cbb731e8b886() {
    return $9e7ee0b2974913c0$var$apiJson('/me', {
        method: 'GET',
        auth: true
    });
}
async function $9e7ee0b2974913c0$export$8ddaddf355aae59c(patch) {
    return $9e7ee0b2974913c0$var$apiJson('/me', {
        method: 'PATCH',
        auth: true,
        body: patch
    });
}
async function $9e7ee0b2974913c0$export$e5f48a70142e06bf(dataUrl) {
    return $9e7ee0b2974913c0$var$apiJson('/me/avatar', {
        method: 'POST',
        auth: true,
        body: {
            dataUrl: dataUrl
        }
    });
}
async function $9e7ee0b2974913c0$export$c5eea955a88464ec() {
    return $9e7ee0b2974913c0$var$apiJson('/me/reset-api-token', {
        method: 'POST',
        auth: true
    });
}
async function $9e7ee0b2974913c0$export$c2a104aacbacefaa() {
    return $9e7ee0b2974913c0$var$apiJson('/me/reset-login-token', {
        method: 'POST',
        auth: true
    });
}
async function $9e7ee0b2974913c0$export$ea49889f7616fcf2(options = {}) {
    return $9e7ee0b2974913c0$var$apiJson('/newbie/start', {
        method: 'POST',
        auth: true,
        body: options.chatgptHand ? {
            chatgptHand: true
        } : undefined
    });
}
async function $9e7ee0b2974913c0$export$92756d14cbd5cc30() {
    return $9e7ee0b2974913c0$var$apiJson('/newbie/new', {
        method: 'POST',
        auth: true
    });
}
async function $9e7ee0b2974913c0$export$109dfbde830570f5(options = {}) {
    return $9e7ee0b2974913c0$var$apiJson('/guobiao/newbie/start', {
        method: 'POST',
        auth: true,
        body: {
            guobiaoConfig: (0, $2glTM.guobiaoConfigForSeat)(0),
            ...options.chatgptHand ? {
                chatgptHand: true
            } : {}
        }
    });
}
async function $9e7ee0b2974913c0$export$dd05c0c1494fd830() {
    return $9e7ee0b2974913c0$var$apiJson('/guobiao/newbie/new', {
        method: 'POST',
        auth: true,
        body: {
            guobiaoConfig: (0, $2glTM.guobiaoConfigForSeat)(0)
        }
    });
}
async function $9e7ee0b2974913c0$export$3342556cc7b4714a(gameId) {
    return $9e7ee0b2974913c0$var$apiJson('/chatgpt-hand/active', {
        method: 'POST',
        auth: true,
        body: {
            gameId: gameId
        }
    });
}
async function $9e7ee0b2974913c0$export$f1f66155db049887(params) {
    return $9e7ee0b2974913c0$var$apiJson('/chatgpt-oauth/authorize', {
        method: 'POST',
        auth: true,
        body: params
    });
}
async function $9e7ee0b2974913c0$export$2e1b665d364d6930() {
    return $9e7ee0b2974913c0$var$apiJson('/me/active-game', {
        method: 'GET',
        auth: true
    });
}
async function $9e7ee0b2974913c0$export$8c656dddbbc2d2ef(gameId) {
    const normalized = typeof gameId === 'string' ? gameId.trim() : '';
    const body = normalized ? {
        gameId: normalized
    } : undefined;
    return $9e7ee0b2974913c0$var$apiJson('/me/active-game/abandon', {
        method: 'POST',
        auth: true,
        body: body
    });
}
async function $9e7ee0b2974913c0$export$82bc2c03e989df27(gameId) {
    const normalized = String(gameId ?? '').trim();
    if (!normalized) throw new Error('missing gameId');
    return $9e7ee0b2974913c0$var$apiJson(`/me/trustee-status?gameId=${encodeURIComponent(normalized)}`, {
        method: 'GET',
        auth: true
    });
}
async function $9e7ee0b2974913c0$export$76eb5b5e3bdae2de(gameId) {
    const normalized = String(gameId ?? '').trim();
    if (!normalized) throw new Error('missing gameId');
    return $9e7ee0b2974913c0$var$apiJson('/me/trustee/disable', {
        method: 'POST',
        auth: true,
        body: {
            gameId: normalized
        }
    });
}
async function $9e7ee0b2974913c0$export$497e1c057f8b78d1(options) {
    const strict = options?.strictExistingToken === true;
    const inFlight = strict ? $9e7ee0b2974913c0$var$ensureUserInFlightStrict : $9e7ee0b2974913c0$var$ensureUserInFlightDefault;
    if (inFlight) return inFlight;
    const loader = (async ()=>{
        const existing = $9e7ee0b2974913c0$export$b154f1a67bb7b5d9();
        if (existing) try {
            const { user: user } = await $9e7ee0b2974913c0$export$2962cbb731e8b886();
            return {
                created: false,
                loginToken: existing,
                apiToken: null,
                user: user
            };
        } catch (err) {
            const msg = String(err?.message ?? err);
            // Existing token is invalid.
            if (msg.toLowerCase().includes('unauthorized') || msg.startsWith('401')) {
                $9e7ee0b2974913c0$export$4dbcba3b4ea11a19(null);
                if (strict) throw new Error('unauthorized');
            } else throw err;
        }
        const { loginToken: loginToken, apiToken: apiToken, user: user } = await $9e7ee0b2974913c0$export$12d407bce29ab995();
        $9e7ee0b2974913c0$export$4dbcba3b4ea11a19(loginToken);
        return {
            created: true,
            loginToken: loginToken,
            apiToken: apiToken,
            user: user
        };
    })();
    if (strict) $9e7ee0b2974913c0$var$ensureUserInFlightStrict = loader;
    else $9e7ee0b2974913c0$var$ensureUserInFlightDefault = loader;
    try {
        return await loader;
    } finally{
        if (strict) $9e7ee0b2974913c0$var$ensureUserInFlightStrict = null;
        else $9e7ee0b2974913c0$var$ensureUserInFlightDefault = null;
    }
}
async function $9e7ee0b2974913c0$var$apiJson(path, options) {
    const url = `${$9e7ee0b2974913c0$export$4d28219d42798a75()}${path.startsWith('/') ? '' : '/'}${path}`;
    const headers = {
        'Content-Type': 'application/json'
    };
    const needsAuth = options.auth || typeof options.authToken === 'string';
    if (needsAuth) {
        const loginToken = options.authToken ?? $9e7ee0b2974913c0$export$b154f1a67bb7b5d9();
        if (!loginToken) throw new Error('missing login token');
        headers['Authorization'] = `Bearer ${loginToken}`;
    }
    const resp = await fetch(url, {
        method: options.method,
        headers: headers,
        body: options.body !== undefined ? JSON.stringify(options.body) : undefined
    });
    const text = await resp.text();
    let json = null;
    try {
        json = text ? JSON.parse(text) : null;
    } catch  {
        json = null;
    }
    if (!resp.ok) {
        const msg = json?.error ? String(json.error) : `${resp.status} ${resp.statusText}`;
        const error = new Error(msg);
        error.status = resp.status;
        error.data = json;
        throw error;
    }
    return json;
}
async function $9e7ee0b2974913c0$export$348031c3192ccb78(loginToken) {
    return $9e7ee0b2974913c0$var$apiJson('/me', {
        method: 'GET',
        authToken: loginToken
    });
}
async function $9e7ee0b2974913c0$export$2841f326108dece9() {
    return $9e7ee0b2974913c0$var$apiJson('/me/match-points', {
        method: 'GET',
        auth: true
    });
}
async function $9e7ee0b2974913c0$export$d2f7ba77b6258c18(loginToken) {
    return $9e7ee0b2974913c0$var$apiJson('/me/match-points', {
        method: 'GET',
        authToken: loginToken
    });
}
async function $9e7ee0b2974913c0$export$9f47f53f8aa750c6() {
    return $9e7ee0b2974913c0$var$apiJson('/me/match-points/claim', {
        method: 'POST',
        auth: true
    });
}

});
parcelRegister("iRbTC", function(module, exports) {

$parcel$export(module.exports, "getBasePath", () => $efba685e62bb2577$export$9099264ed9b1c55a);
$parcel$export(module.exports, "getWsUrl", () => $efba685e62bb2577$export$28999b747e987c5);
function $efba685e62bb2577$export$9099264ed9b1c55a() {
    // In development we assume everything is served from root.
    // @ts-ignore
    const env = "production";
    if (env !== 'production') return '/';
    let pathname = window.location.pathname;
    // Normalize to a directory path.
    if (!pathname.endsWith('/')) pathname = pathname.substring(0, pathname.lastIndexOf('/') + 1);
    // The app can be hosted under a subpath (e.g. /mjlab/).
    // Resolve that base path by stripping known entry route prefixes.
    const markers = [
        'oauth',
        'chatgpt-hand',
        'coach',
        'hand',
        'mobile',
        'computer',
        'me',
        'practice',
        'calc',
        'evplus',
        'ev'
    ];
    for (const m of markers){
        const idx = pathname.indexOf(`/${m}/`);
        if (idx >= 0) return pathname.slice(0, idx + 1);
    }
    return pathname;
}
function $efba685e62bb2577$export$28999b747e987c5() {
    // @ts-ignore
    const env = "production";
    if (env !== 'production') return 'ws://localhost:1235';
    const wsProtocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    const wsHost = window.location.host;
    const basePath = $efba685e62bb2577$export$9099264ed9b1c55a();
    return `${wsProtocol}//${wsHost}${basePath}ws`;
}

});

parcelRegister("2glTM", function(module, exports) {

$parcel$export(module.exports, "readGuobiaoAutoBuhuaPreference", () => $84cff88e5d7cc0f3$export$41bad8cd9b7182b5);
$parcel$export(module.exports, "writeGuobiaoAutoBuhuaPreference", () => $84cff88e5d7cc0f3$export$60d720d3114ad562);
$parcel$export(module.exports, "guobiaoConfigForCurrentPlayer", () => $84cff88e5d7cc0f3$export$d1f81d8a01b9b24f);
$parcel$export(module.exports, "guobiaoConfigForSeat", () => $84cff88e5d7cc0f3$export$32ee3f124acfe185);
const $84cff88e5d7cc0f3$var$AUTO_BUHUA_KEY = 'mjlab.guobiao.autoBuhua';
function $84cff88e5d7cc0f3$export$41bad8cd9b7182b5() {
    try {
        const raw = localStorage.getItem($84cff88e5d7cc0f3$var$AUTO_BUHUA_KEY);
        if (raw === 'false') return false;
        if (raw === 'true') return true;
    } catch  {
    // ignore storage errors and keep the production default.
    }
    return true;
}
function $84cff88e5d7cc0f3$export$60d720d3114ad562(enabled) {
    try {
        localStorage.setItem($84cff88e5d7cc0f3$var$AUTO_BUHUA_KEY, enabled ? 'true' : 'false');
    } catch  {
    // The current hand state still updates through the server even if storage is unavailable.
    }
}
function $84cff88e5d7cc0f3$export$d1f81d8a01b9b24f() {
    return {
        autoBuhua: $84cff88e5d7cc0f3$export$41bad8cd9b7182b5()
    };
}
function $84cff88e5d7cc0f3$export$32ee3f124acfe185(seat) {
    const autoBuhua = $84cff88e5d7cc0f3$export$41bad8cd9b7182b5();
    return {
        autoBuhua: autoBuhua,
        autoBuhuaBySeat: {
            [seat]: autoBuhua
        }
    };
}

});


parcelRegister("dru5x", function(module, exports) {

$parcel$export(module.exports, "listPracticeRecords", () => $21b91484b6bce6fa$export$61eeeaa21c1200b5);
$parcel$export(module.exports, "enterPracticeRecord", () => $21b91484b6bce6fa$export$7f8b21074c5ee448);
$parcel$export(module.exports, "deletePracticeRecord", () => $21b91484b6bce6fa$export$3a53e5f8ca862e15);
$parcel$export(module.exports, "sharePracticeRecord", () => $21b91484b6bce6fa$export$2aeba272b9fd2f82);
$parcel$export(module.exports, "patchPracticeRecord", () => $21b91484b6bce6fa$export$577330f8f9a6a30f);
$parcel$export(module.exports, "openPracticeShare", () => $21b91484b6bce6fa$export$6943d57637b43422);

var $8PAWz = parcelRequire("8PAWz");
async function $21b91484b6bce6fa$var$apiJson(path, params) {
    const token = (0, $8PAWz.getLoginToken)();
    if (!token) throw new Error('missing login token');
    const resp = await fetch(`${(0, $8PAWz.getApiBaseUrl)()}${path.startsWith('/') ? '' : '/'}${path}`, {
        method: params.method,
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
        },
        body: params.body !== undefined ? JSON.stringify(params.body) : undefined
    });
    const text = await resp.text();
    let json = null;
    try {
        json = text ? JSON.parse(text) : null;
    } catch  {
        json = null;
    }
    if (!resp.ok) {
        const error = new Error(String(json?.error ?? `${resp.status} ${resp.statusText}`));
        error.status = resp.status;
        error.data = json;
        throw error;
    }
    return json;
}
async function $21b91484b6bce6fa$export$61eeeaa21c1200b5() {
    return $21b91484b6bce6fa$var$apiJson('/me/practice-records', {
        method: 'GET'
    });
}
async function $21b91484b6bce6fa$export$7f8b21074c5ee448(recordId) {
    const id = String(recordId ?? '').trim();
    if (!id) throw new Error('missing recordId');
    return $21b91484b6bce6fa$var$apiJson(`/practice-records/${encodeURIComponent(id)}/enter`, {
        method: 'POST'
    });
}
async function $21b91484b6bce6fa$export$3a53e5f8ca862e15(recordId) {
    const id = String(recordId ?? '').trim();
    if (!id) throw new Error('missing recordId');
    return $21b91484b6bce6fa$var$apiJson(`/practice-records/${encodeURIComponent(id)}/delete`, {
        method: 'POST'
    });
}
async function $21b91484b6bce6fa$export$2aeba272b9fd2f82(recordId) {
    const id = String(recordId ?? '').trim();
    if (!id) throw new Error('missing recordId');
    return $21b91484b6bce6fa$var$apiJson(`/practice-records/${encodeURIComponent(id)}/share`, {
        method: 'POST'
    });
}
async function $21b91484b6bce6fa$export$577330f8f9a6a30f(recordId, params) {
    const id = String(recordId ?? '').trim();
    if (!id) throw new Error('missing recordId');
    return $21b91484b6bce6fa$var$apiJson(`/practice-records/${encodeURIComponent(id)}`, {
        method: 'PATCH',
        body: {
            title: params.title ?? null,
            note: params.note ?? null
        }
    });
}
async function $21b91484b6bce6fa$export$6943d57637b43422(shareId) {
    const id = String(shareId ?? '').trim();
    if (!id) throw new Error('missing shareId');
    return $21b91484b6bce6fa$var$apiJson(`/practice-shares/${encodeURIComponent(id)}/open`, {
        method: 'POST'
    });
}

});

parcelRegister("bmHMf", function(module, exports) {

$parcel$export(module.exports, "listMyPaipus", () => $73e26df09ac07ebd$export$3121e707e5a87774);
$parcel$export(module.exports, "fetchMyPaipu", () => $73e26df09ac07ebd$export$3e3cf8311231d779);
$parcel$export(module.exports, "createPaipuShare", () => $73e26df09ac07ebd$export$de07b9a12a1031a1);
$parcel$export(module.exports, "deletePaipu", () => $73e26df09ac07ebd$export$e33993e7a5042d1f);
$parcel$export(module.exports, "openPaipuShare", () => $73e26df09ac07ebd$export$9771c96081600123);
$parcel$export(module.exports, "fetchAiTemplates", () => $73e26df09ac07ebd$export$8abcc0450cc34364);
$parcel$export(module.exports, "requestPaipuAiRecommend", () => $73e26df09ac07ebd$export$db9d4a52a5a4e91d);

var $8PAWz = parcelRequire("8PAWz");
async function $73e26df09ac07ebd$var$apiJson(path, params) {
    const headers = {
        'Content-Type': 'application/json'
    };
    if (params.auth) {
        const token = (0, $8PAWz.getLoginToken)();
        if (!token) throw new Error('missing login token');
        headers.Authorization = `Bearer ${token}`;
    }
    const resp = await fetch(`${(0, $8PAWz.getApiBaseUrl)()}${path.startsWith('/') ? '' : '/'}${path}`, {
        method: params.method,
        headers: headers,
        body: params.body !== undefined ? JSON.stringify(params.body) : undefined
    });
    const text = await resp.text();
    let json = null;
    try {
        json = text ? JSON.parse(text) : null;
    } catch  {
        json = null;
    }
    if (!resp.ok) {
        const error = new Error(String(json?.error ?? `${resp.status} ${resp.statusText}`));
        error.status = resp.status;
        error.data = json;
        throw error;
    }
    return json;
}
async function $73e26df09ac07ebd$export$3121e707e5a87774(params) {
    const sp = new URLSearchParams();
    const roomType = typeof params?.roomType === 'string' ? params.roomType.trim() : '';
    const variant = typeof params?.variant === 'string' ? params.variant.trim() : '';
    const shared = typeof params?.shared === 'string' ? params.shared.trim() : '';
    if (roomType) sp.set('roomType', roomType);
    if (variant) sp.set('variant', variant);
    if (shared === 'shared' || shared === 'unshared') sp.set('shared', shared);
    const query = sp.toString();
    return $73e26df09ac07ebd$var$apiJson(`/me/replays${query ? `?${query}` : ''}`, {
        method: 'GET',
        auth: true
    });
}
async function $73e26df09ac07ebd$export$3e3cf8311231d779(gameId) {
    const id = String(gameId ?? '').trim();
    if (!id) throw new Error('missing gameId');
    return $73e26df09ac07ebd$var$apiJson(`/me/replays/${encodeURIComponent(id)}`, {
        method: 'GET',
        auth: true
    });
}
async function $73e26df09ac07ebd$export$de07b9a12a1031a1(gameId) {
    const id = String(gameId ?? '').trim();
    if (!id) throw new Error('missing gameId');
    return $73e26df09ac07ebd$var$apiJson(`/me/replays/${encodeURIComponent(id)}/share`, {
        method: 'POST',
        auth: true
    });
}
async function $73e26df09ac07ebd$export$e33993e7a5042d1f(gameId) {
    const id = String(gameId ?? '').trim();
    if (!id) throw new Error('missing gameId');
    return $73e26df09ac07ebd$var$apiJson(`/me/replays/${encodeURIComponent(id)}`, {
        method: 'DELETE',
        auth: true
    });
}
async function $73e26df09ac07ebd$export$9771c96081600123(shareId) {
    const id = String(shareId ?? '').trim();
    if (!id) throw new Error('missing shareId');
    return $73e26df09ac07ebd$var$apiJson(`/replay-shares/${encodeURIComponent(id)}`, {
        method: 'GET',
        auth: true
    });
}
async function $73e26df09ac07ebd$export$8abcc0450cc34364() {
    return $73e26df09ac07ebd$var$apiJson('/ai/templates', {
        method: 'GET',
        auth: true
    });
}
async function $73e26df09ac07ebd$export$db9d4a52a5a4e91d(params) {
    const gameId = String(params.gameId ?? '').trim();
    const shareId = String(params.shareId ?? '').trim();
    if (!gameId && !shareId) throw new Error('missing replay target');
    const path = shareId ? `/replay-shares/${encodeURIComponent(shareId)}/ai/recommend` : `/me/replays/${encodeURIComponent(gameId)}/ai/recommend`;
    return $73e26df09ac07ebd$var$apiJson(path, {
        method: 'POST',
        auth: true,
        body: {
            scene: params.scene,
            prompt: params.prompt,
            templateId: params.templateId ?? null,
            snapshot: params.snapshot,
            eventIndex: Number.isFinite(params.eventIndex) ? Math.trunc(params.eventIndex) : null
        }
    });
}

});

parcelRegister("7xapJ", function(module, exports) {

$parcel$export(module.exports, "resolveEffectiveAiModelLabel", () => $ae21ecba7b491fe1$export$62c7db646ace6bb2);
$parcel$export(module.exports, "fetchAiSettings", () => $ae21ecba7b491fe1$export$88f732a027222bf0);
$parcel$export(module.exports, "fetchAiBilling", () => $ae21ecba7b491fe1$export$ba67ecd391472d77);
$parcel$export(module.exports, "fetchPayConfig", () => $ae21ecba7b491fe1$export$1d5a2b6fca290861);
$parcel$export(module.exports, "createPayOrder", () => $ae21ecba7b491fe1$export$c07290c372468ee);
$parcel$export(module.exports, "fetchPayOrder", () => $ae21ecba7b491fe1$export$d214bc807cb71b06);
$parcel$export(module.exports, "fetchAiRules", () => $ae21ecba7b491fe1$export$807b0f7fbe45bf36);
$parcel$export(module.exports, "setAiRules", () => $ae21ecba7b491fe1$export$40f37203db415ad1);
$parcel$export(module.exports, "setAiDefault", () => $ae21ecba7b491fe1$export$63809827fe048728);
$parcel$export(module.exports, "setAiOfficialModel", () => $ae21ecba7b491fe1$export$c4e2cd30c2194a44);

var $8PAWz = parcelRequire("8PAWz");
function $ae21ecba7b491fe1$export$62c7db646ace6bb2(params) {
    const effective = params.effective ?? null;
    const profiles = Array.isArray(params.profiles) ? params.profiles : [];
    const officialModel = typeof params.officialModel === 'string' ? params.officialModel.trim() : '';
    if (effective?.source === 'profile') {
        const pid = effective.profileId ?? null;
        const prof = pid ? profiles.find((p)=>p.id === pid) ?? null : null;
        if (prof?.model) return prof.model;
    }
    return officialModel || null;
}
async function $ae21ecba7b491fe1$export$88f732a027222bf0(params) {
    const qs = params?.gameId ? `?gameId=${encodeURIComponent(params.gameId)}` : '';
    return $ae21ecba7b491fe1$var$apiJson(`/ai/settings${qs}`, {
        method: 'GET'
    });
}
async function $ae21ecba7b491fe1$export$ba67ecd391472d77(params) {
    const qs = new URLSearchParams();
    if (typeof params?.limit === 'number') qs.set('limit', String(Math.trunc(params.limit)));
    if (typeof params?.offset === 'number') qs.set('offset', String(Math.trunc(params.offset)));
    const suffix = qs.toString() ? `?${qs.toString()}` : '';
    return $ae21ecba7b491fe1$var$apiJson(`/ai/billing${suffix}`, {
        method: 'GET'
    });
}
async function $ae21ecba7b491fe1$export$1d5a2b6fca290861() {
    return $ae21ecba7b491fe1$var$apiJson('/pay/config', {
        method: 'GET'
    });
}
async function $ae21ecba7b491fe1$export$c07290c372468ee(params) {
    return $ae21ecba7b491fe1$var$apiJson('/pay/order/create', {
        method: 'POST',
        body: params
    });
}
async function $ae21ecba7b491fe1$export$d214bc807cb71b06(orderId) {
    const id = String(orderId ?? '').trim();
    if (!id) throw new Error('missing order id');
    return $ae21ecba7b491fe1$var$apiJson(`/pay/order/${encodeURIComponent(id)}`, {
        method: 'GET'
    });
}
async function $ae21ecba7b491fe1$export$807b0f7fbe45bf36() {
    return $ae21ecba7b491fe1$var$apiJson('/ai/rules', {
        method: 'GET'
    });
}
async function $ae21ecba7b491fe1$export$40f37203db415ad1(rules) {
    return $ae21ecba7b491fe1$var$apiJson('/ai/rules', {
        method: 'PATCH',
        body: {
            rules: rules
        }
    });
}
async function $ae21ecba7b491fe1$export$63809827fe048728(pref) {
    return $ae21ecba7b491fe1$var$apiJson('/ai/default', {
        method: 'PATCH',
        body: pref
    });
}
async function $ae21ecba7b491fe1$export$c4e2cd30c2194a44(params) {
    return $ae21ecba7b491fe1$var$apiJson('/ai/official-model', {
        method: 'PATCH',
        body: params
    });
}
async function $ae21ecba7b491fe1$export$59c698e0e630ecfa(params) {
    return $ae21ecba7b491fe1$var$apiJson('/ai/profiles', {
        method: 'POST',
        body: params
    });
}
async function $ae21ecba7b491fe1$export$79897ae94666163f(profileId, patch) {
    return $ae21ecba7b491fe1$var$apiJson(`/ai/profiles/${encodeURIComponent(profileId)}`, {
        method: 'PATCH',
        body: patch
    });
}
async function $ae21ecba7b491fe1$export$875bdc668995c7b7(profileId) {
    return $ae21ecba7b491fe1$var$apiJson(`/ai/profiles/${encodeURIComponent(profileId)}`, {
        method: 'DELETE'
    });
}
async function $ae21ecba7b491fe1$export$dddb084ea5ecb6aa(params) {
    return $ae21ecba7b491fe1$var$apiJson('/ai/test', {
        method: 'POST',
        body: params
    });
}
async function $ae21ecba7b491fe1$export$d8d156bfd127736c(profileId, params) {
    return $ae21ecba7b491fe1$var$apiJson(`/ai/profiles/${encodeURIComponent(profileId)}/test`, {
        method: 'POST',
        body: params ?? {}
    });
}
async function $ae21ecba7b491fe1$export$717bf31557b85b99(gameId, pref) {
    return $ae21ecba7b491fe1$var$apiJson(`/ai/rooms/${encodeURIComponent(gameId)}`, {
        method: 'PATCH',
        body: pref
    });
}
const $ae21ecba7b491fe1$var$DEFAULT_API_TIMEOUT_MS = 30000;
const $ae21ecba7b491fe1$var$MIN_API_TIMEOUT_MS = 1000;
const $ae21ecba7b491fe1$var$MAX_API_TIMEOUT_MS = 120000;
async function $ae21ecba7b491fe1$var$apiJson(path, options) {
    const base = (0, $8PAWz.getApiBaseUrl)();
    const url = `${base}${path.startsWith('/') ? '' : '/'}${path}`;
    const token = (0, $8PAWz.getLoginToken)();
    if (!token) throw new Error('missing login token');
    const timeoutMs = $ae21ecba7b491fe1$var$normalizeTimeoutMs(options.timeoutMs ?? $ae21ecba7b491fe1$var$DEFAULT_API_TIMEOUT_MS);
    const controller = new AbortController();
    const timeoutHandle = window.setTimeout(()=>controller.abort(), timeoutMs);
    let resp;
    try {
        resp = await fetch(url, {
            method: options.method,
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: options.body !== undefined ? JSON.stringify(options.body) : undefined,
            signal: controller.signal
        });
    } catch (err) {
        if ($ae21ecba7b491fe1$var$isAbortError(err)) throw new Error("\u8BF7\u6C42\u8D85\u65F6\uFF0C\u8BF7\u68C0\u67E5\u7F51\u7EDC\u540E\u91CD\u8BD5");
        throw err;
    } finally{
        window.clearTimeout(timeoutHandle);
    }
    const text = await resp.text();
    const json = $ae21ecba7b491fe1$var$safeParse(text);
    if (!resp.ok) throw new Error(String(json?.error ?? `${resp.status} ${resp.statusText}`));
    return json;
}
function $ae21ecba7b491fe1$var$safeParse(text) {
    try {
        return text ? JSON.parse(text) : null;
    } catch  {
        return null;
    }
}
function $ae21ecba7b491fe1$var$normalizeTimeoutMs(raw) {
    const n = Number(raw);
    if (!Number.isFinite(n)) return $ae21ecba7b491fe1$var$DEFAULT_API_TIMEOUT_MS;
    const i = Math.trunc(n);
    if (i < $ae21ecba7b491fe1$var$MIN_API_TIMEOUT_MS) return $ae21ecba7b491fe1$var$MIN_API_TIMEOUT_MS;
    if (i > $ae21ecba7b491fe1$var$MAX_API_TIMEOUT_MS) return $ae21ecba7b491fe1$var$MAX_API_TIMEOUT_MS;
    return i;
}
function $ae21ecba7b491fe1$var$isAbortError(err) {
    if (!err) return false;
    if (typeof DOMException !== 'undefined' && err instanceof DOMException && err.name === 'AbortError') return true;
    const name = typeof err?.name === 'string' ? String(err.name) : '';
    return name === 'AbortError';
}

});

parcelRegister("5GesS", function(module, exports) {

$parcel$export(module.exports, "setupDesignCanvasScale", () => $30ad9517c4f59dd4$export$a5619a110a20bd09);
function $30ad9517c4f59dd4$export$a5619a110a20bd09(opts) {
    const root = opts.root;
    const wrap = opts.wrap;
    const canvas = opts.canvas;
    if (!root || !wrap || !canvas) return null;
    const designWidth = opts.designWidth ?? 720;
    const maxWidth = opts.maxWidth ?? 1440;
    let rafId = null;
    let resizeObserver = null;
    const apply = ()=>{
        const viewportWidth = document.documentElement.clientWidth || window.innerWidth;
        let mode = 'scroll';
        let targetWidth = designWidth;
        if (viewportWidth < designWidth) {
            mode = 'fit';
            targetWidth = viewportWidth;
        } else if (viewportWidth > maxWidth) {
            mode = 'clamp';
            targetWidth = maxWidth;
        } else {
            mode = 'fit';
            targetWidth = viewportWidth;
        }
        const scale = targetWidth / designWidth;
        root.dataset.mode = mode;
        canvas.style.setProperty('--mj-scale', `${scale}`);
        const baseHeight = canvas.offsetHeight;
        wrap.style.width = `${targetWidth}px`;
        wrap.style.height = `${baseHeight * scale}px`;
        opts.onAfterApply?.({
            viewportWidth: viewportWidth,
            mode: mode,
            targetWidth: targetWidth,
            scale: scale,
            baseHeight: baseHeight,
            designWidth: designWidth,
            maxWidth: maxWidth
        });
    };
    const schedule = ()=>{
        if (rafId !== null) return;
        rafId = window.requestAnimationFrame(()=>{
            rafId = null;
            apply();
        });
    };
    window.addEventListener('resize', schedule, {
        passive: true
    });
    if (typeof ResizeObserver !== 'undefined') {
        resizeObserver = new ResizeObserver(schedule);
        resizeObserver.observe(canvas);
    }
    schedule();
    const destroy = ()=>{
        if (rafId !== null) {
            window.cancelAnimationFrame(rafId);
            rafId = null;
        }
        window.removeEventListener('resize', schedule);
        resizeObserver?.disconnect();
        resizeObserver = null;
    };
    return {
        schedule: schedule,
        destroy: destroy
    };
}

});

parcelRegister("9wRj8", function(module, exports) {

$parcel$export(module.exports, "ensurePwaManifestLink", () => $188bcd54012ffe39$export$26668c9cb513cf4a);

var $iRbTC = parcelRequire("iRbTC");
function $188bcd54012ffe39$export$26668c9cb513cf4a() {
    if (typeof document === 'undefined') return;
    const basePath = (0, $iRbTC.getBasePath)();
    const normalizedBase = basePath.endsWith('/') ? basePath : `${basePath}/`;
    const href = `${normalizedBase}manifest.webmanifest`;
    const absoluteHref = new URL(href, window.location.origin).toString();
    const existing = document.querySelector('link[rel="manifest"]');
    const link = existing ?? document.createElement('link');
    if (!existing) {
        link.rel = 'manifest';
        document.head.appendChild(link);
    }
    if (link.href !== absoluteHref) link.href = href;
}

});

// @ts-ignore

var $383do = parcelRequire("383do");

var $i2qrx = parcelRequire("i2qrx");

var $IoThy = parcelRequire("IoThy");

var $gMKnz = parcelRequire("gMKnz");

var $8PAWz = parcelRequire("8PAWz");

var $dru5x = parcelRequire("dru5x");

var $bmHMf = parcelRequire("bmHMf");

var $7xapJ = parcelRequire("7xapJ");
function $43f1258e3bca17c3$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $43f1258e3bca17c3$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $43f1258e3bca17c3$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $43f1258e3bca17c3$var$_arrayLikeToArray(o, minLen);
}
function $43f1258e3bca17c3$var$_createForOfIteratorHelper(r, e) {
    var t = typeof Symbol !== "undefined" && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $43f1258e3bca17c3$var$_unsupportedIterableToArray(r)) || e && r && typeof r.length === "number") {
            if (t) r = t;
            var _n = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (_n >= r.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: r[_n++]
                    };
                },
                e: function e(err) {
                    throw err;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o;
    var a = true;
    var u = false;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var result = t.next();
            a = result.done;
            return result;
        },
        e: function e(err) {
            u = true;
            o = err;
        },
        f: function f() {
            try {
                if (!a && t["return"] != null) t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $43f1258e3bca17c3$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $43f1258e3bca17c3$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $43f1258e3bca17c3$var$_toPropertyKey(arg) {
    var key = $43f1258e3bca17c3$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $43f1258e3bca17c3$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $43f1258e3bca17c3$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $43f1258e3bca17c3$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $43f1258e3bca17c3$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $43f1258e3bca17c3$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $43f1258e3bca17c3$var$_defineProperty(obj, key, value) {
    key = $43f1258e3bca17c3$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $43f1258e3bca17c3$var$_class, $43f1258e3bca17c3$var$_class2;
// Copyright (c) Project Nayuki. (MIT License)
// https://www.nayuki.io/page/qr-code-generator-library
// Modification with code reorder and prettier
// --------------------------------------------
// Appends the given number of low-order bits of the given value
// to the given buffer. Requires 0 <= len <= 31 and 0 <= val < 2^len.
function $43f1258e3bca17c3$var$appendBits(val, len, bb) {
    if (len < 0 || len > 31 || val >>> len != 0) throw new RangeError('Value out of range');
    for(var i = len - 1; i >= 0; i-- // Append bit by bit
    )bb.push(val >>> i & 1);
}
// Returns true iff the i'th bit of x is set to 1.
function $43f1258e3bca17c3$var$getBit(x, i) {
    return (x >>> i & 1) != 0;
}
// Throws an exception if the given condition is false.
function $43f1258e3bca17c3$var$assert(cond) {
    if (!cond) throw new Error('Assertion error');
}
var $43f1258e3bca17c3$export$9484bbecc3c49a2e = /*#__PURE__*/ function() {
    function Mode(modeBits, numBitsCharCount) {
        $43f1258e3bca17c3$var$_classCallCheck(this, Mode);
        /*-- Constructor and fields --*/ // The mode indicator bits, which is a unumber4 value (range 0 to 15).
        $43f1258e3bca17c3$var$_defineProperty(this, "modeBits", void 0);
        // Number of character count bits for three different version ranges.
        $43f1258e3bca17c3$var$_defineProperty(this, "numBitsCharCount", void 0);
        this.modeBits = modeBits;
        this.numBitsCharCount = numBitsCharCount;
    }
    /*-- Method --*/ // (Package-private) Returns the bit width of the character count field for a segment in
    // this mode in a QR Code at the given version number. The result is in the range [0, 16].
    $43f1258e3bca17c3$var$_createClass(Mode, [
        {
            key: "numCharCountBits",
            value: function numCharCountBits(ver) {
                return this.numBitsCharCount[Math.floor((ver + 7) / 17)];
            }
        }
    ]);
    return Mode;
}();
/*---- Public helper enumeration ----*/ /*
 * The error correction level in a QR Code symbol. Immutable.
 */ $43f1258e3bca17c3$var$_class = $43f1258e3bca17c3$export$9484bbecc3c49a2e;
/*-- Constants --*/ $43f1258e3bca17c3$var$_defineProperty($43f1258e3bca17c3$export$9484bbecc3c49a2e, "NUMERIC", new $43f1258e3bca17c3$var$_class(0x1, [
    10,
    12,
    14
]));
$43f1258e3bca17c3$var$_defineProperty($43f1258e3bca17c3$export$9484bbecc3c49a2e, "ALPHANUMERIC", new $43f1258e3bca17c3$var$_class(0x2, [
    9,
    11,
    13
]));
$43f1258e3bca17c3$var$_defineProperty($43f1258e3bca17c3$export$9484bbecc3c49a2e, "BYTE", new $43f1258e3bca17c3$var$_class(0x4, [
    8,
    16,
    16
]));
$43f1258e3bca17c3$var$_defineProperty($43f1258e3bca17c3$export$9484bbecc3c49a2e, "KANJI", new $43f1258e3bca17c3$var$_class(0x8, [
    8,
    10,
    12
]));
$43f1258e3bca17c3$var$_defineProperty($43f1258e3bca17c3$export$9484bbecc3c49a2e, "ECI", new $43f1258e3bca17c3$var$_class(0x7, [
    0,
    0,
    0
]));
var $43f1258e3bca17c3$export$a92359712a79a565 = /*#__PURE__*/ $43f1258e3bca17c3$var$_createClass(function Ecc(ordinal, formatBits) {
    $43f1258e3bca17c3$var$_classCallCheck(this, Ecc);
    // The QR Code can tolerate about 30% erroneous codewords
    /*-- Constructor and fields --*/ // In the range 0 to 3 (unsigned 2-bit numbereger).
    $43f1258e3bca17c3$var$_defineProperty(this, "ordinal", void 0);
    // (Package-private) In the range 0 to 3 (unsigned 2-bit numbereger).
    $43f1258e3bca17c3$var$_defineProperty(this, "formatBits", void 0);
    this.ordinal = ordinal;
    this.formatBits = formatBits;
});
/*
 * A segment of character/binary/control data in a QR Code symbol.
 * Instances of this class are immutable.
 * The mid-level way to create a segment is to take the payload data
 * and call a static factory function such as QrSegment.makeNumeric().
 * The low-level way to create a segment is to custom-make the bit buffer
 * and call the QrSegment() constructor with appropriate values.
 * This segment class imposes no length restrictions, but QR Codes have restrictions.
 * Even in the most favorable conditions, a QR Code can only hold 7089 characters of data.
 * Any segment longer than this is meaningless for the purpose of generating QR Codes.
 */ $43f1258e3bca17c3$var$_class2 = $43f1258e3bca17c3$export$a92359712a79a565;
/*-- Constants --*/ $43f1258e3bca17c3$var$_defineProperty($43f1258e3bca17c3$export$a92359712a79a565, "LOW", new $43f1258e3bca17c3$var$_class2(0, 1));
// The QR Code can tolerate about  7% erroneous codewords
$43f1258e3bca17c3$var$_defineProperty($43f1258e3bca17c3$export$a92359712a79a565, "MEDIUM", new $43f1258e3bca17c3$var$_class2(1, 0));
// The QR Code can tolerate about 15% erroneous codewords
$43f1258e3bca17c3$var$_defineProperty($43f1258e3bca17c3$export$a92359712a79a565, "QUARTILE", new $43f1258e3bca17c3$var$_class2(2, 3));
// The QR Code can tolerate about 25% erroneous codewords
$43f1258e3bca17c3$var$_defineProperty($43f1258e3bca17c3$export$a92359712a79a565, "HIGH", new $43f1258e3bca17c3$var$_class2(3, 2));
var $43f1258e3bca17c3$export$135a856fd1c8c9fb = /*#__PURE__*/ function() {
    // Creates a new QR Code segment with the given attributes and data.
    // The character count (numChars) must agree with the mode and the bit buffer length,
    // but the constranumber isn't checked. The given bit buffer is cloned and stored.
    function QrSegment(mode, numChars, bitData) {
        $43f1258e3bca17c3$var$_classCallCheck(this, QrSegment);
        /*-- Constructor (low level) and fields --*/ // The mode indicator of this segment.
        $43f1258e3bca17c3$var$_defineProperty(this, "mode", void 0);
        // The length of this segment's unencoded data. Measured in characters for
        // numeric/alphanumeric/kanji mode, bytes for byte mode, and 0 for ECI mode.
        // Always zero or positive. Not the same as the data's bit length.
        $43f1258e3bca17c3$var$_defineProperty(this, "numChars", void 0);
        // The data bits of this segment. Accessed through getData().
        $43f1258e3bca17c3$var$_defineProperty(this, "bitData", void 0);
        this.mode = mode;
        this.numChars = numChars;
        this.bitData = bitData;
        if (numChars < 0) throw new RangeError('Invalid argument');
        this.bitData = bitData.slice(); // Make defensive copy
    }
    /*-- Methods --*/ // Returns a new copy of the data bits of this segment.
    $43f1258e3bca17c3$var$_createClass(QrSegment, [
        {
            key: "getData",
            value: function getData() {
                return this.bitData.slice(); // Make defensive copy
            }
        }
    ], [
        {
            key: "makeBytes",
            value: /*-- Static factory functions (mid level) --*/ // Returns a segment representing the given binary data encoded in
            // byte mode. All input byte arrays are acceptable. Any text string
            // can be converted to UTF-8 bytes and encoded as a byte mode segment.
            function makeBytes(data) {
                var bb = [];
                var _iterator = $43f1258e3bca17c3$var$_createForOfIteratorHelper(data), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var b = _step.value;
                        $43f1258e3bca17c3$var$appendBits(b, 8, bb);
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
                return new QrSegment($43f1258e3bca17c3$export$9484bbecc3c49a2e.BYTE, data.length, bb);
            }
        },
        {
            key: "makeNumeric",
            value: function makeNumeric(digits) {
                if (!QrSegment.isNumeric(digits)) throw new RangeError('String contains non-numeric characters');
                var bb = [];
                for(var i = 0; i < digits.length;){
                    // Consume up to 3 digits per iteration
                    var n = Math.min(digits.length - i, 3);
                    $43f1258e3bca17c3$var$appendBits(parseInt(digits.substring(i, i + n), 10), n * 3 + 1, bb);
                    i += n;
                }
                return new QrSegment($43f1258e3bca17c3$export$9484bbecc3c49a2e.NUMERIC, digits.length, bb);
            }
        },
        {
            key: "makeAlphanumeric",
            value: function makeAlphanumeric(text) {
                if (!QrSegment.isAlphanumeric(text)) throw new RangeError('String contains unencodable characters in alphanumeric mode');
                var bb = [];
                var i;
                for(i = 0; i + 2 <= text.length; i += 2){
                    // Process groups of 2
                    var temp = QrSegment.ALPHANUMERIC_CHARSET.indexOf(text.charAt(i)) * 45;
                    temp += QrSegment.ALPHANUMERIC_CHARSET.indexOf(text.charAt(i + 1));
                    $43f1258e3bca17c3$var$appendBits(temp, 11, bb);
                }
                if (i < text.length) // 1 character remaining
                $43f1258e3bca17c3$var$appendBits(QrSegment.ALPHANUMERIC_CHARSET.indexOf(text.charAt(i)), 6, bb);
                return new QrSegment($43f1258e3bca17c3$export$9484bbecc3c49a2e.ALPHANUMERIC, text.length, bb);
            }
        },
        {
            key: "makeSegments",
            value: function makeSegments(text) {
                // Select the most efficient segment encoding automatically
                if (text == '') return [];
                else if (QrSegment.isNumeric(text)) return [
                    QrSegment.makeNumeric(text)
                ];
                else if (QrSegment.isAlphanumeric(text)) return [
                    QrSegment.makeAlphanumeric(text)
                ];
                else return [
                    QrSegment.makeBytes(QrSegment.toUtf8ByteArray(text))
                ];
            }
        },
        {
            key: "makeEci",
            value: function makeEci(assignVal) {
                var bb = [];
                if (assignVal < 0) throw new RangeError('ECI assignment value out of range');
                else if (assignVal < 128) $43f1258e3bca17c3$var$appendBits(assignVal, 8, bb);
                else if (assignVal < 16384) {
                    $43f1258e3bca17c3$var$appendBits(2, 2, bb);
                    $43f1258e3bca17c3$var$appendBits(assignVal, 14, bb);
                } else if (assignVal < 1000000) {
                    $43f1258e3bca17c3$var$appendBits(6, 3, bb);
                    $43f1258e3bca17c3$var$appendBits(assignVal, 21, bb);
                } else throw new RangeError('ECI assignment value out of range');
                return new QrSegment($43f1258e3bca17c3$export$9484bbecc3c49a2e.ECI, 0, bb);
            }
        },
        {
            key: "isNumeric",
            value: function isNumeric(text) {
                return QrSegment.NUMERIC_REGEX.test(text);
            }
        },
        {
            key: "isAlphanumeric",
            value: function isAlphanumeric(text) {
                return QrSegment.ALPHANUMERIC_REGEX.test(text);
            }
        },
        {
            key: "getTotalBits",
            value: function getTotalBits(segs, version) {
                var result = 0;
                var _iterator2 = $43f1258e3bca17c3$var$_createForOfIteratorHelper(segs), _step2;
                try {
                    for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                        var seg = _step2.value;
                        var ccbits = seg.mode.numCharCountBits(version);
                        if (seg.numChars >= 1 << ccbits) return Infinity; // The segment's length doesn't fit the field's bit width
                        result += 4 + ccbits + seg.bitData.length;
                    }
                } catch (err) {
                    _iterator2.e(err);
                } finally{
                    _iterator2.f();
                }
                return result;
            }
        },
        {
            key: "toUtf8ByteArray",
            value: function toUtf8ByteArray(input) {
                var str = encodeURI(input);
                var result = [];
                for(var i = 0; i < str.length; i++)if (str.charAt(i) != '%') result.push(str.charCodeAt(i));
                else {
                    result.push(parseInt(str.substring(i + 1, i + 3), 16));
                    i += 2;
                }
                return result;
            }
        }
    ]);
    return QrSegment;
}();
/*
 * A QR Code symbol, which is a type of two-dimension barcode.
 * Invented by Denso Wave and described in the ISO/IEC 18004 standard.
 * Instances of this class represent an immutable square grid of dark and light cells.
 * The class provides static factory functions to create a QR Code from text or binary data.
 * The class covers the QR Code Model 2 specification, supporting all versions (sizes)
 * from 1 to 40, all 4 error correction levels, and 4 character encoding modes.
 *
 * Ways to create a QR Code object:
 * - High level: Take the payload data and call QrCode.encodeText() or QrCode.encodeBinary().
 * - Mid level: Custom-make the list of segments and call QrCode.encodeSegments().
 * - Low level: Custom-make the array of data codeword bytes (including
 *   segment headers and final padding, excluding error correction codewords),
 *   supply the appropriate version number, and call the QrCode() constructor.
 * (Note that all ways require supplying the desired error correction level.)
 */ $43f1258e3bca17c3$var$_defineProperty($43f1258e3bca17c3$export$135a856fd1c8c9fb, "NUMERIC_REGEX", /^[0-9]*$/);
// Describes precisely all strings that are encodable in alphanumeric mode.
$43f1258e3bca17c3$var$_defineProperty($43f1258e3bca17c3$export$135a856fd1c8c9fb, "ALPHANUMERIC_REGEX", /^[A-Z0-9 $%*+.\/:-]*$/);
// The set of all legal characters in alphanumeric mode,
// where each character value maps to the index in the string.
$43f1258e3bca17c3$var$_defineProperty($43f1258e3bca17c3$export$135a856fd1c8c9fb, "ALPHANUMERIC_CHARSET", '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:');
var $43f1258e3bca17c3$export$e3b6b80dd4f481c3 = /*#__PURE__*/ function() {
    // Creates a new QR Code with the given version number,
    // error correction level, data codeword bytes, and mask number.
    // This is a low-level API that most users should not use directly.
    // A mid-level API is the encodeSegments() function.
    function QrCode(// The version number of this QR Code, which is between 1 and 40 (inclusive).
    // This determines the size of this barcode.
    version, // The error correction level used in this QR Code.
    errorCorrectionLevel, dataCodewords, oriMsk) {
        $43f1258e3bca17c3$var$_classCallCheck(this, QrCode);
        /*-- Fields --*/ // The width and height of this QR Code, measured in modules, between
        // 21 and 177 (inclusive). This is equal to version * 4 + 17.
        $43f1258e3bca17c3$var$_defineProperty(this, "size", void 0);
        // The index of the mask pattern used in this QR Code, which is between 0 and 7 (inclusive).
        // Even if a QR Code is created with automatic masking requested (mask = -1),
        // the resulting object still has a mask value between 0 and 7.
        $43f1258e3bca17c3$var$_defineProperty(this, "mask", void 0);
        // The modules of this QR Code (false = light, true = dark).
        // Immutable after constructor finishes. Accessed through getModule().
        $43f1258e3bca17c3$var$_defineProperty(this, "modules", []);
        // Indicates function modules that are not subjected to masking. Discarded when constructor finishes.
        $43f1258e3bca17c3$var$_defineProperty(this, "isFunction", []);
        /*-- Constructor (low level) and fields --*/ // The version number of this QR Code, which is between 1 and 40 (inclusive).
        // This determines the size of this barcode.
        $43f1258e3bca17c3$var$_defineProperty(this, "version", void 0);
        // The error correction level used in this QR Code.
        $43f1258e3bca17c3$var$_defineProperty(this, "errorCorrectionLevel", void 0);
        var msk = oriMsk;
        this.version = version;
        this.errorCorrectionLevel = errorCorrectionLevel;
        // Check scalar arguments
        if (version < QrCode.MIN_VERSION || version > QrCode.MAX_VERSION) throw new RangeError('Version value out of range');
        if (msk < -1 || msk > 7) throw new RangeError('Mask value out of range');
        this.size = version * 4 + 17;
        // Initialize both grids to be size*size arrays of Boolean false
        var row = [];
        for(var i = 0; i < this.size; i++)row.push(false);
        for(var _i = 0; _i < this.size; _i++){
            this.modules.push(row.slice()); // Initially all light
            this.isFunction.push(row.slice());
        }
        // Compute ECC, draw modules
        this.drawFunctionPatterns();
        var allCodewords = this.addEccAndInterleave(dataCodewords);
        this.drawCodewords(allCodewords);
        // Do masking
        if (msk == -1) {
            // Automatically choose best mask
            var minPenalty = 1000000000;
            for(var _i2 = 0; _i2 < 8; _i2++){
                this.applyMask(_i2);
                this.drawFormatBits(_i2);
                var penalty = this.getPenaltyScore();
                if (penalty < minPenalty) {
                    msk = _i2;
                    minPenalty = penalty;
                }
                this.applyMask(_i2); // Undoes the mask due to XOR
            }
        }
        $43f1258e3bca17c3$var$assert(0 <= msk && msk <= 7);
        this.mask = msk;
        this.applyMask(msk); // Apply the final choice of mask
        this.drawFormatBits(msk); // Overwrite old format bits
        this.isFunction = [];
    }
    /*-- Accessor methods --*/ // Returns the color of the module (pixel) at the given coordinates, which is false
    // for light or true for dark. The top left corner has the coordinates (x=0, y=0).
    // If the given coordinates are out of bounds, then false (light) is returned.
    $43f1258e3bca17c3$var$_createClass(QrCode, [
        {
            key: "getModule",
            value: function getModule(x, y) {
                return 0 <= x && x < this.size && 0 <= y && y < this.size && this.modules[y][x];
            }
        },
        {
            key: "getModules",
            value: function getModules() {
                return this.modules;
            }
        },
        {
            key: "drawFunctionPatterns",
            value: function drawFunctionPatterns() {
                // Draw horizontal and vertical timing patterns
                for(var i = 0; i < this.size; i++){
                    this.setFunctionModule(6, i, i % 2 == 0);
                    this.setFunctionModule(i, 6, i % 2 == 0);
                }
                // Draw 3 finder patterns (all corners except bottom right; overwrites some timing modules)
                this.drawFinderPattern(3, 3);
                this.drawFinderPattern(this.size - 4, 3);
                this.drawFinderPattern(3, this.size - 4);
                // Draw numerous alignment patterns
                var alignPatPos = this.getAlignmentPatternPositions();
                var numAlign = alignPatPos.length;
                for(var _i3 = 0; _i3 < numAlign; _i3++){
                    for(var j = 0; j < numAlign; j++)// Don't draw on the three finder corners
                    if (!(_i3 == 0 && j == 0 || _i3 == 0 && j == numAlign - 1 || _i3 == numAlign - 1 && j == 0)) this.drawAlignmentPattern(alignPatPos[_i3], alignPatPos[j]);
                }
                // Draw configuration data
                this.drawFormatBits(0); // Dummy mask value; overwritten later in the constructor
                this.drawVersion();
            }
        },
        {
            key: "drawFormatBits",
            value: function drawFormatBits(mask) {
                // Calculate error correction code and pack bits
                var data = this.errorCorrectionLevel.formatBits << 3 | mask; // errCorrLvl is unumber2, mask is unumber3
                var rem = data;
                for(var i = 0; i < 10; i++)rem = rem << 1 ^ (rem >>> 9) * 0x537;
                var bits = (data << 10 | rem) ^ 0x5412; // unumber15
                $43f1258e3bca17c3$var$assert(bits >>> 15 == 0);
                // Draw first copy
                for(var _i4 = 0; _i4 <= 5; _i4++)this.setFunctionModule(8, _i4, $43f1258e3bca17c3$var$getBit(bits, _i4));
                this.setFunctionModule(8, 7, $43f1258e3bca17c3$var$getBit(bits, 6));
                this.setFunctionModule(8, 8, $43f1258e3bca17c3$var$getBit(bits, 7));
                this.setFunctionModule(7, 8, $43f1258e3bca17c3$var$getBit(bits, 8));
                for(var _i5 = 9; _i5 < 15; _i5++)this.setFunctionModule(14 - _i5, 8, $43f1258e3bca17c3$var$getBit(bits, _i5));
                // Draw second copy
                for(var _i6 = 0; _i6 < 8; _i6++)this.setFunctionModule(this.size - 1 - _i6, 8, $43f1258e3bca17c3$var$getBit(bits, _i6));
                for(var _i7 = 8; _i7 < 15; _i7++)this.setFunctionModule(8, this.size - 15 + _i7, $43f1258e3bca17c3$var$getBit(bits, _i7));
                this.setFunctionModule(8, this.size - 8, true); // Always dark
            }
        },
        {
            key: "drawVersion",
            value: function drawVersion() {
                if (this.version < 7) return;
                // Calculate error correction code and pack bits
                var rem = this.version; // version is unumber6, in the range [7, 40]
                for(var i = 0; i < 12; i++)rem = rem << 1 ^ (rem >>> 11) * 0x1f25;
                var bits = this.version << 12 | rem; // unumber18
                $43f1258e3bca17c3$var$assert(bits >>> 18 == 0);
                // Draw two copies
                for(var _i8 = 0; _i8 < 18; _i8++){
                    var color = $43f1258e3bca17c3$var$getBit(bits, _i8);
                    var a = this.size - 11 + _i8 % 3;
                    var b = Math.floor(_i8 / 3);
                    this.setFunctionModule(a, b, color);
                    this.setFunctionModule(b, a, color);
                }
            }
        },
        {
            key: "drawFinderPattern",
            value: function drawFinderPattern(x, y) {
                for(var dy = -4; dy <= 4; dy++)for(var dx = -4; dx <= 4; dx++){
                    var dist = Math.max(Math.abs(dx), Math.abs(dy)); // Chebyshev/infinity norm
                    var xx = x + dx;
                    var yy = y + dy;
                    if (0 <= xx && xx < this.size && 0 <= yy && yy < this.size) this.setFunctionModule(xx, yy, dist != 2 && dist != 4);
                }
            }
        },
        {
            key: "drawAlignmentPattern",
            value: function drawAlignmentPattern(x, y) {
                for(var dy = -2; dy <= 2; dy++)for(var dx = -2; dx <= 2; dx++)this.setFunctionModule(x + dx, y + dy, Math.max(Math.abs(dx), Math.abs(dy)) != 1);
            }
        },
        {
            key: "setFunctionModule",
            value: function setFunctionModule(x, y, isDark) {
                this.modules[y][x] = isDark;
                this.isFunction[y][x] = true;
            }
        },
        {
            key: "addEccAndInterleave",
            value: function addEccAndInterleave(data) {
                var ver = this.version;
                var ecl = this.errorCorrectionLevel;
                if (data.length != QrCode.getNumDataCodewords(ver, ecl)) throw new RangeError('Invalid argument');
                // Calculate parameter numbers
                var numBlocks = QrCode.NUM_ERROR_CORRECTION_BLOCKS[ecl.ordinal][ver];
                var blockEccLen = QrCode.ECC_CODEWORDS_PER_BLOCK[ecl.ordinal][ver];
                var rawCodewords = Math.floor(QrCode.getNumRawDataModules(ver) / 8);
                var numShortBlocks = numBlocks - rawCodewords % numBlocks;
                var shortBlockLen = Math.floor(rawCodewords / numBlocks);
                // Split data numbero blocks and append ECC to each block
                var blocks = [];
                var rsDiv = QrCode.reedSolomonComputeDivisor(blockEccLen);
                for(var i = 0, k = 0; i < numBlocks; i++){
                    var dat = data.slice(k, k + shortBlockLen - blockEccLen + (i < numShortBlocks ? 0 : 1));
                    k += dat.length;
                    var ecc = QrCode.reedSolomonComputeRemainder(dat, rsDiv);
                    if (i < numShortBlocks) dat.push(0);
                    blocks.push(dat.concat(ecc));
                }
                // Interleave (not concatenate) the bytes from every block numbero a single sequence
                var result = [];
                var _loop = function _loop(_i9) {
                    blocks.forEach(function(block, j) {
                        // Skip the padding byte in short blocks
                        if (_i9 != shortBlockLen - blockEccLen || j >= numShortBlocks) result.push(block[_i9]);
                    });
                };
                for(var _i9 = 0; _i9 < blocks[0].length; _i9++)_loop(_i9);
                $43f1258e3bca17c3$var$assert(result.length == rawCodewords);
                return result;
            }
        },
        {
            key: "drawCodewords",
            value: function drawCodewords(data) {
                if (data.length != Math.floor(QrCode.getNumRawDataModules(this.version) / 8)) throw new RangeError('Invalid argument');
                var i = 0; // Bit index numbero the data
                // Do the funny zigzag scan
                for(var right = this.size - 1; right >= 1; right -= 2){
                    // Index of right column in each column pair
                    if (right == 6) right = 5;
                    for(var vert = 0; vert < this.size; vert++)// Vertical counter
                    for(var j = 0; j < 2; j++){
                        var x = right - j; // Actual x coordinate
                        var upward = (right + 1 & 2) == 0;
                        var y = upward ? this.size - 1 - vert : vert; // Actual y coordinate
                        if (!this.isFunction[y][x] && i < data.length * 8) {
                            this.modules[y][x] = $43f1258e3bca17c3$var$getBit(data[i >>> 3], 7 - (i & 7));
                            i++;
                        }
                    // If this QR Code has any remainder bits (0 to 7), they were assigned as
                    // 0/false/light by the constructor and are left unchanged by this method
                    }
                }
                $43f1258e3bca17c3$var$assert(i == data.length * 8);
            }
        },
        {
            key: "applyMask",
            value: function applyMask(mask) {
                if (mask < 0 || mask > 7) throw new RangeError('Mask value out of range');
                for(var y = 0; y < this.size; y++)for(var x = 0; x < this.size; x++){
                    var invert = void 0;
                    switch(mask){
                        case 0:
                            invert = (x + y) % 2 == 0;
                            break;
                        case 1:
                            invert = y % 2 == 0;
                            break;
                        case 2:
                            invert = x % 3 == 0;
                            break;
                        case 3:
                            invert = (x + y) % 3 == 0;
                            break;
                        case 4:
                            invert = (Math.floor(x / 3) + Math.floor(y / 2)) % 2 == 0;
                            break;
                        case 5:
                            invert = x * y % 2 + x * y % 3 == 0;
                            break;
                        case 6:
                            invert = (x * y % 2 + x * y % 3) % 2 == 0;
                            break;
                        case 7:
                            invert = ((x + y) % 2 + x * y % 3) % 2 == 0;
                            break;
                        default:
                            throw new Error('Unreachable');
                    }
                    if (!this.isFunction[y][x] && invert) this.modules[y][x] = !this.modules[y][x];
                }
            }
        },
        {
            key: "getPenaltyScore",
            value: function getPenaltyScore() {
                var result = 0;
                // Adjacent modules in row having same color, and finder-like patterns
                for(var y = 0; y < this.size; y++){
                    var runColor = false;
                    var runX = 0;
                    var runHistory = [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ];
                    for(var x = 0; x < this.size; x++)if (this.modules[y][x] == runColor) {
                        runX++;
                        if (runX == 5) result += QrCode.PENALTY_N1;
                        else if (runX > 5) result++;
                    } else {
                        this.finderPenaltyAddHistory(runX, runHistory);
                        if (!runColor) result += this.finderPenaltyCountPatterns(runHistory) * QrCode.PENALTY_N3;
                        runColor = this.modules[y][x];
                        runX = 1;
                    }
                    result += this.finderPenaltyTerminateAndCount(runColor, runX, runHistory) * QrCode.PENALTY_N3;
                }
                // Adjacent modules in column having same color, and finder-like patterns
                for(var _x = 0; _x < this.size; _x++){
                    var _runColor = false;
                    var runY = 0;
                    var _runHistory = [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ];
                    for(var _y = 0; _y < this.size; _y++)if (this.modules[_y][_x] == _runColor) {
                        runY++;
                        if (runY == 5) result += QrCode.PENALTY_N1;
                        else if (runY > 5) result++;
                    } else {
                        this.finderPenaltyAddHistory(runY, _runHistory);
                        if (!_runColor) result += this.finderPenaltyCountPatterns(_runHistory) * QrCode.PENALTY_N3;
                        _runColor = this.modules[_y][_x];
                        runY = 1;
                    }
                    result += this.finderPenaltyTerminateAndCount(_runColor, runY, _runHistory) * QrCode.PENALTY_N3;
                }
                // 2*2 blocks of modules having same color
                for(var _y2 = 0; _y2 < this.size - 1; _y2++)for(var _x2 = 0; _x2 < this.size - 1; _x2++){
                    var color = this.modules[_y2][_x2];
                    if (color == this.modules[_y2][_x2 + 1] && color == this.modules[_y2 + 1][_x2] && color == this.modules[_y2 + 1][_x2 + 1]) result += QrCode.PENALTY_N2;
                }
                // Balance of dark and light modules
                var dark = 0;
                var _iterator3 = $43f1258e3bca17c3$var$_createForOfIteratorHelper(this.modules), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var row = _step3.value;
                        dark = row.reduce(function(sum, color) {
                            return sum + (color ? 1 : 0);
                        }, dark);
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
                var total = this.size * this.size; // Note that size is odd, so dark/total != 1/2
                // Compute the smallest numbereger k >= 0 such that (45-5k)% <= dark/total <= (55+5k)%
                var k = Math.ceil(Math.abs(dark * 20 - total * 10) / total) - 1;
                $43f1258e3bca17c3$var$assert(0 <= k && k <= 9);
                result += k * QrCode.PENALTY_N4;
                $43f1258e3bca17c3$var$assert(0 <= result && result <= 2568888); // Non-tight upper bound based on default values of PENALTY_N1, ..., N4
                return result;
            }
        },
        {
            key: "getAlignmentPatternPositions",
            value: function getAlignmentPatternPositions() {
                if (this.version == 1) return [];
                else {
                    var numAlign = Math.floor(this.version / 7) + 2;
                    var step = this.version == 32 ? 26 : Math.ceil((this.version * 4 + 4) / (numAlign * 2 - 2)) * 2;
                    var result = [
                        6
                    ];
                    for(var pos = this.size - 7; result.length < numAlign; pos -= step)result.splice(1, 0, pos);
                    return result;
                }
            }
        },
        {
            key: "finderPenaltyCountPatterns",
            value: // Can only be called immediately after a light run is added, and
            // returns either 0, 1, or 2. A helper function for getPenaltyScore().
            function finderPenaltyCountPatterns(runHistory) {
                var n = runHistory[1];
                $43f1258e3bca17c3$var$assert(n <= this.size * 3);
                var core = n > 0 && runHistory[2] == n && runHistory[3] == n * 3 && runHistory[4] == n && runHistory[5] == n;
                return (core && runHistory[0] >= n * 4 && runHistory[6] >= n ? 1 : 0) + (core && runHistory[6] >= n * 4 && runHistory[0] >= n ? 1 : 0);
            }
        },
        {
            key: "finderPenaltyTerminateAndCount",
            value: function finderPenaltyTerminateAndCount(currentRunColor, oriCurrentRunLength, runHistory) {
                var currentRunLength = oriCurrentRunLength;
                if (currentRunColor) {
                    // Terminate dark run
                    this.finderPenaltyAddHistory(currentRunLength, runHistory);
                    currentRunLength = 0;
                }
                currentRunLength += this.size; // Add light border to final run
                this.finderPenaltyAddHistory(currentRunLength, runHistory);
                return this.finderPenaltyCountPatterns(runHistory);
            }
        },
        {
            key: "finderPenaltyAddHistory",
            value: function finderPenaltyAddHistory(oriCurrentRunLength, runHistory) {
                var currentRunLength = oriCurrentRunLength;
                if (runHistory[0] == 0) currentRunLength += this.size; // Add light border to initial run
                runHistory.pop();
                runHistory.unshift(currentRunLength);
            }
        }
    ], [
        {
            key: "encodeText",
            value: /*-- Static factory functions (high level) --*/ // Returns a QR Code representing the given Unicode text string at the given error correction level.
            // As a conservative upper bound, this function is guaranteed to succeed for strings that have 738 or fewer
            // Unicode code ponumbers (not UTF-16 code units) if the low error correction level is used. The smallest possible
            // QR Code version is automatically chosen for the output. The ECC level of the result may be higher than the
            // ecl argument if it can be done without increasing the version.
            function encodeText(text, ecl) {
                var segs = $43f1258e3bca17c3$export$135a856fd1c8c9fb.makeSegments(text);
                return QrCode.encodeSegments(segs, ecl);
            }
        },
        {
            key: "encodeBinary",
            value: function encodeBinary(data, ecl) {
                var seg = $43f1258e3bca17c3$export$135a856fd1c8c9fb.makeBytes(data);
                return QrCode.encodeSegments([
                    seg
                ], ecl);
            }
        },
        {
            key: "encodeSegments",
            value: function encodeSegments(segs, oriEcl) {
                var minVersion = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
                var maxVersion = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 40;
                var mask = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : -1;
                var boostEcl = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;
                if (!(QrCode.MIN_VERSION <= minVersion && minVersion <= maxVersion && maxVersion <= QrCode.MAX_VERSION) || mask < -1 || mask > 7) throw new RangeError('Invalid value');
                // Find the minimal version number to use
                var version;
                var dataUsedBits;
                for(version = minVersion;; version++){
                    var _dataCapacityBits = QrCode.getNumDataCodewords(version, oriEcl) * 8; // Number of data bits available
                    var usedBits = $43f1258e3bca17c3$export$135a856fd1c8c9fb.getTotalBits(segs, version);
                    if (usedBits <= _dataCapacityBits) {
                        dataUsedBits = usedBits;
                        break; // This version number is found to be suitable
                    }
                    if (version >= maxVersion) // All versions in the range could not fit the given data
                    throw new RangeError('Data too long');
                }
                var ecl = oriEcl;
                // Increase the error correction level while the data still fits in the current version number
                for(var _i10 = 0, _arr = [
                    $43f1258e3bca17c3$export$a92359712a79a565.MEDIUM,
                    $43f1258e3bca17c3$export$a92359712a79a565.QUARTILE,
                    $43f1258e3bca17c3$export$a92359712a79a565.HIGH
                ]; _i10 < _arr.length; _i10++){
                    var newEcl = _arr[_i10];
                    // From low to high
                    if (boostEcl && dataUsedBits <= QrCode.getNumDataCodewords(version, newEcl) * 8) ecl = newEcl;
                }
                // Concatenate all segments to create the data bit string
                var bb = [];
                var _iterator4 = $43f1258e3bca17c3$var$_createForOfIteratorHelper(segs), _step4;
                try {
                    for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                        var seg = _step4.value;
                        $43f1258e3bca17c3$var$appendBits(seg.mode.modeBits, 4, bb);
                        $43f1258e3bca17c3$var$appendBits(seg.numChars, seg.mode.numCharCountBits(version), bb);
                        var _iterator5 = $43f1258e3bca17c3$var$_createForOfIteratorHelper(seg.getData()), _step5;
                        try {
                            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                                var b = _step5.value;
                                bb.push(b);
                            }
                        } catch (err) {
                            _iterator5.e(err);
                        } finally{
                            _iterator5.f();
                        }
                    }
                } catch (err) {
                    _iterator4.e(err);
                } finally{
                    _iterator4.f();
                }
                $43f1258e3bca17c3$var$assert(bb.length == dataUsedBits);
                // Add terminator and pad up to a byte if applicable
                var dataCapacityBits = QrCode.getNumDataCodewords(version, ecl) * 8;
                $43f1258e3bca17c3$var$assert(bb.length <= dataCapacityBits);
                $43f1258e3bca17c3$var$appendBits(0, Math.min(4, dataCapacityBits - bb.length), bb);
                $43f1258e3bca17c3$var$appendBits(0, (8 - bb.length % 8) % 8, bb);
                $43f1258e3bca17c3$var$assert(bb.length % 8 == 0);
                // Pad with alternating bytes until data capacity is reached
                for(var padByte = 0xec; bb.length < dataCapacityBits; padByte ^= 253)$43f1258e3bca17c3$var$appendBits(padByte, 8, bb);
                // Pack bits numbero bytes in big endian
                var dataCodewords = [];
                while(dataCodewords.length * 8 < bb.length)dataCodewords.push(0);
                bb.forEach(function(b, i) {
                    dataCodewords[i >>> 3] |= b << 7 - (i & 7);
                });
                // Create the QR Code object
                return new QrCode(version, ecl, dataCodewords, mask);
            }
        },
        {
            key: "getNumRawDataModules",
            value: function getNumRawDataModules(ver) {
                if (ver < QrCode.MIN_VERSION || ver > QrCode.MAX_VERSION) throw new RangeError('Version number out of range');
                var result = (16 * ver + 128) * ver + 64;
                if (ver >= 2) {
                    var numAlign = Math.floor(ver / 7) + 2;
                    result -= (25 * numAlign - 10) * numAlign - 55;
                    if (ver >= 7) result -= 36;
                }
                $43f1258e3bca17c3$var$assert(208 <= result && result <= 29648);
                return result;
            }
        },
        {
            key: "getNumDataCodewords",
            value: function getNumDataCodewords(ver, ecl) {
                return Math.floor(QrCode.getNumRawDataModules(ver) / 8) - QrCode.ECC_CODEWORDS_PER_BLOCK[ecl.ordinal][ver] * QrCode.NUM_ERROR_CORRECTION_BLOCKS[ecl.ordinal][ver];
            }
        },
        {
            key: "reedSolomonComputeDivisor",
            value: function reedSolomonComputeDivisor(degree) {
                if (degree < 1 || degree > 255) throw new RangeError('Degree out of range');
                // Polynomial coefficients are stored from highest to lowest power, excluding the leading term which is always 1.
                // For example the polynomial x^3 + 255x^2 + 8x + 93 is stored as the unumber8 array [255, 8, 93].
                var result = [];
                for(var i = 0; i < degree - 1; i++)result.push(0);
                result.push(1); // Start off with the monomial x^0
                // Compute the product polynomial (x - r^0) * (x - r^1) * (x - r^2) * ... * (x - r^{degree-1}),
                // and drop the highest monomial term which is always 1x^degree.
                // Note that r = 0x02, which is a generator element of this field GF(2^8/0x11D).
                var root = 1;
                for(var _i11 = 0; _i11 < degree; _i11++){
                    // Multiply the current product by (x - r^i)
                    for(var j = 0; j < result.length; j++){
                        result[j] = QrCode.reedSolomonMultiply(result[j], root);
                        if (j + 1 < result.length) result[j] ^= result[j + 1];
                    }
                    root = QrCode.reedSolomonMultiply(root, 0x02);
                }
                return result;
            }
        },
        {
            key: "reedSolomonComputeRemainder",
            value: function reedSolomonComputeRemainder(data, divisor) {
                var result = divisor.map(function() {
                    return 0;
                });
                var _iterator6 = $43f1258e3bca17c3$var$_createForOfIteratorHelper(data), _step6;
                try {
                    var _loop2 = function _loop2() {
                        var b = _step6.value;
                        // Polynomial division
                        var factor = b ^ result.shift();
                        result.push(0);
                        divisor.forEach(function(coef, i) {
                            result[i] ^= QrCode.reedSolomonMultiply(coef, factor);
                        });
                    };
                    for(_iterator6.s(); !(_step6 = _iterator6.n()).done;)_loop2();
                } catch (err) {
                    _iterator6.e(err);
                } finally{
                    _iterator6.f();
                }
                return result;
            }
        },
        {
            key: "reedSolomonMultiply",
            value: function reedSolomonMultiply(x, y) {
                if (x >>> 8 != 0 || y >>> 8 != 0) throw new RangeError('Byte out of range');
                // Russian peasant multiplication
                var z = 0;
                for(var i = 7; i >= 0; i--){
                    z = z << 1 ^ (z >>> 7) * 0x11d;
                    z ^= (y >>> i & 1) * x;
                }
                $43f1258e3bca17c3$var$assert(z >>> 8 == 0);
                return z;
            }
        }
    ]);
    return QrCode;
}();
$43f1258e3bca17c3$var$_defineProperty($43f1258e3bca17c3$export$e3b6b80dd4f481c3, "MIN_VERSION", 1);
// The maximum version number supported in the QR Code Model 2 standard.
$43f1258e3bca17c3$var$_defineProperty($43f1258e3bca17c3$export$e3b6b80dd4f481c3, "MAX_VERSION", 40);
// For use in getPenaltyScore(), when evaluating which mask is best.
$43f1258e3bca17c3$var$_defineProperty($43f1258e3bca17c3$export$e3b6b80dd4f481c3, "PENALTY_N1", 3);
$43f1258e3bca17c3$var$_defineProperty($43f1258e3bca17c3$export$e3b6b80dd4f481c3, "PENALTY_N2", 3);
$43f1258e3bca17c3$var$_defineProperty($43f1258e3bca17c3$export$e3b6b80dd4f481c3, "PENALTY_N3", 40);
$43f1258e3bca17c3$var$_defineProperty($43f1258e3bca17c3$export$e3b6b80dd4f481c3, "PENALTY_N4", 10);
$43f1258e3bca17c3$var$_defineProperty($43f1258e3bca17c3$export$e3b6b80dd4f481c3, "ECC_CODEWORDS_PER_BLOCK", [
    // Version: (note that index 0 is for padding, and is set to an illegal value)
    //0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40    Error correction level
    [
        -1,
        7,
        10,
        15,
        20,
        26,
        18,
        20,
        24,
        30,
        18,
        20,
        24,
        26,
        30,
        22,
        24,
        28,
        30,
        28,
        28,
        28,
        28,
        30,
        30,
        26,
        28,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30
    ],
    // Low
    [
        -1,
        10,
        16,
        26,
        18,
        24,
        16,
        18,
        22,
        22,
        26,
        30,
        22,
        22,
        24,
        24,
        28,
        28,
        26,
        26,
        26,
        26,
        28,
        28,
        28,
        28,
        28,
        28,
        28,
        28,
        28,
        28,
        28,
        28,
        28,
        28,
        28,
        28,
        28,
        28,
        28
    ],
    // Medium
    [
        -1,
        13,
        22,
        18,
        26,
        18,
        24,
        18,
        22,
        20,
        24,
        28,
        26,
        24,
        20,
        30,
        24,
        28,
        28,
        26,
        30,
        28,
        30,
        30,
        30,
        30,
        28,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30
    ],
    // Quartile
    [
        -1,
        17,
        28,
        22,
        16,
        22,
        28,
        26,
        26,
        24,
        28,
        24,
        28,
        22,
        24,
        24,
        30,
        28,
        28,
        26,
        28,
        30,
        24,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30
    ] // High
]);
$43f1258e3bca17c3$var$_defineProperty($43f1258e3bca17c3$export$e3b6b80dd4f481c3, "NUM_ERROR_CORRECTION_BLOCKS", [
    // Version: (note that index 0 is for padding, and is set to an illegal value)
    //0, 1, 2, 3, 4, 5, 6, 7, 8, 9,10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40    Error correction level
    [
        -1,
        1,
        1,
        1,
        1,
        1,
        2,
        2,
        2,
        2,
        4,
        4,
        4,
        4,
        4,
        6,
        6,
        6,
        6,
        7,
        8,
        8,
        9,
        9,
        10,
        12,
        12,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        19,
        20,
        21,
        22,
        24,
        25
    ],
    // Low
    [
        -1,
        1,
        1,
        1,
        2,
        2,
        4,
        4,
        4,
        5,
        5,
        5,
        8,
        9,
        9,
        10,
        10,
        11,
        13,
        14,
        16,
        17,
        17,
        18,
        20,
        21,
        23,
        25,
        26,
        28,
        29,
        31,
        33,
        35,
        37,
        38,
        40,
        43,
        45,
        47,
        49
    ],
    // Medium
    [
        -1,
        1,
        1,
        2,
        2,
        4,
        4,
        6,
        6,
        8,
        8,
        8,
        10,
        12,
        16,
        12,
        17,
        16,
        18,
        21,
        20,
        23,
        23,
        25,
        27,
        29,
        34,
        34,
        35,
        38,
        40,
        43,
        45,
        48,
        51,
        53,
        56,
        59,
        62,
        65,
        68
    ],
    // Quartile
    [
        -1,
        1,
        1,
        2,
        4,
        4,
        4,
        5,
        6,
        8,
        8,
        11,
        11,
        16,
        16,
        18,
        16,
        19,
        21,
        25,
        25,
        25,
        34,
        30,
        32,
        35,
        37,
        40,
        42,
        45,
        48,
        51,
        54,
        57,
        60,
        63,
        66,
        70,
        74,
        77,
        81
    ] // High
]);



var $iRbTC = parcelRequire("iRbTC");

var $5GesS = parcelRequire("5GesS");

var $9wRj8 = parcelRequire("9wRj8");
(0, $9wRj8.ensurePwaManifestLink)();
const $9c3d0822d3033a97$var$avatars = [
    (0, (/*@__PURE__*/$parcel$interopDefault($383do))),
    (0, (/*@__PURE__*/$parcel$interopDefault($i2qrx))),
    (0, (/*@__PURE__*/$parcel$interopDefault($IoThy))),
    (0, (/*@__PURE__*/$parcel$interopDefault($gMKnz)))
];
const $9c3d0822d3033a97$var$meRoot = document.getElementById('me-root');
const $9c3d0822d3033a97$var$meCanvasWrap = document.getElementById('me-canvas-wrap');
const $9c3d0822d3033a97$var$meCanvas = document.getElementById('me-canvas');
const $9c3d0822d3033a97$var$meCanvasScale = (0, $5GesS.setupDesignCanvasScale)({
    root: $9c3d0822d3033a97$var$meRoot,
    wrap: $9c3d0822d3033a97$var$meCanvasWrap,
    canvas: $9c3d0822d3033a97$var$meCanvas
});
const $9c3d0822d3033a97$var$meCanvasScaleNeedsManualSchedule = typeof ResizeObserver === 'undefined';
function $9c3d0822d3033a97$var$scheduleMeCanvasScale() {
    if (!$9c3d0822d3033a97$var$meCanvasScaleNeedsManualSchedule) return;
    $9c3d0822d3033a97$var$meCanvasScale?.schedule();
}
window.addEventListener('beforeunload', ()=>{
    $9c3d0822d3033a97$var$meCanvasScale?.destroy();
}, {
    once: true
});
const $9c3d0822d3033a97$var$statusEl = document.getElementById('status');
const $9c3d0822d3033a97$var$contentEl = document.getElementById('content');
const $9c3d0822d3033a97$var$meTabAccountBtn = document.getElementById('me-tab-account');
const $9c3d0822d3033a97$var$meTabPayBtn = document.getElementById('me-tab-pay');
const $9c3d0822d3033a97$var$meTabReplayBtn = document.getElementById('me-tab-replay');
const $9c3d0822d3033a97$var$meTabPracticeBtn = document.getElementById('me-tab-practice');
const $9c3d0822d3033a97$var$meTabSecurityBtn = document.getElementById('me-tab-security');
const $9c3d0822d3033a97$var$mePanelAccountEl = document.getElementById('me-panel-account');
const $9c3d0822d3033a97$var$mePanelPayEl = document.getElementById('me-panel-pay');
const $9c3d0822d3033a97$var$mePanelReplayEl = document.getElementById('me-panel-replay');
const $9c3d0822d3033a97$var$mePanelPracticeEl = document.getElementById('me-panel-practice');
const $9c3d0822d3033a97$var$mePanelSecurityEl = document.getElementById('me-panel-security');
const $9c3d0822d3033a97$var$replayRefreshBtn = document.getElementById('replay-refresh');
const $9c3d0822d3033a97$var$replayListEl = document.getElementById('replay-list');
const $9c3d0822d3033a97$var$replayFilterRoomAllBtn = document.getElementById('replay-filter-room-all');
const $9c3d0822d3033a97$var$replayFilterRoomNewbieBtn = document.getElementById('replay-filter-room-newbie');
const $9c3d0822d3033a97$var$replayFilterRoomFriendBtn = document.getElementById('replay-filter-room-friend');
const $9c3d0822d3033a97$var$replayFilterVariantAllBtn = document.getElementById('replay-filter-variant-all');
const $9c3d0822d3033a97$var$replayFilterVariantXuezhanBtn = document.getElementById('replay-filter-variant-xuezhan');
const $9c3d0822d3033a97$var$replayFilterVariantGuobiaoBtn = document.getElementById('replay-filter-variant-guobiao');
const $9c3d0822d3033a97$var$replayFilterShareAllBtn = document.getElementById('replay-filter-share-all');
const $9c3d0822d3033a97$var$replayFilterShareSharedBtn = document.getElementById('replay-filter-share-shared');
const $9c3d0822d3033a97$var$replayFilterShareUnsharedBtn = document.getElementById('replay-filter-share-unshared');
const $9c3d0822d3033a97$var$practiceRefreshBtn = document.getElementById('practice-refresh');
const $9c3d0822d3033a97$var$practiceListEl = document.getElementById('practice-list');
const $9c3d0822d3033a97$var$nickInput = document.getElementById('nick');
const $9c3d0822d3033a97$var$matchPointsEl = document.getElementById('match-points');
const $9c3d0822d3033a97$var$avatarCurrentImageEl = document.getElementById('avatar-current-image');
const $9c3d0822d3033a97$var$avatarCurrentTitleEl = document.getElementById('avatar-current-title');
const $9c3d0822d3033a97$var$avatarCurrentDescEl = document.getElementById('avatar-current-desc');
const $9c3d0822d3033a97$var$avatarUploadBtn = document.getElementById('avatar-upload-btn');
const $9c3d0822d3033a97$var$avatarUploadInput = document.getElementById('avatar-upload-input');
const $9c3d0822d3033a97$var$bgmEnabledInput = document.getElementById('bgm-enabled');
const $9c3d0822d3033a97$var$sfxEnabledInput = document.getElementById('sfx-enabled');
const $9c3d0822d3033a97$var$saveBtn = document.getElementById('save');
const $9c3d0822d3033a97$var$loginTokenInput = document.getElementById('login-token');
const $9c3d0822d3033a97$var$loginTokenVisibilityBtn = document.getElementById('login-token-visibility');
const $9c3d0822d3033a97$var$copyLoginBtn = document.getElementById('copy-login');
const $9c3d0822d3033a97$var$resetLoginBtn = document.getElementById('reset-login');
const $9c3d0822d3033a97$var$resetApiBtn = document.getElementById('reset-api');
const $9c3d0822d3033a97$var$aiBillingPointsEl = document.getElementById('ai-billing-points');
const $9c3d0822d3033a97$var$aiBillingListEl = document.getElementById('ai-billing-list');
const $9c3d0822d3033a97$var$aiBillingRefreshBtn = document.getElementById('ai-billing-refresh');
const $9c3d0822d3033a97$var$payModeTipEl = document.getElementById('pay-mode-tip');
const $9c3d0822d3033a97$var$payPackageOptionsEl = document.getElementById('pay-package-options');
const $9c3d0822d3033a97$var$payChannelOptionsEl = document.getElementById('pay-channel-options');
const $9c3d0822d3033a97$var$payCreateOrderBtn = document.getElementById('pay-create-order');
const $9c3d0822d3033a97$var$payOrderStatusEl = document.getElementById('pay-order-status');
const $9c3d0822d3033a97$var$payQrPanelEl = document.getElementById('pay-qr-panel');
const $9c3d0822d3033a97$var$payQrTitleEl = document.getElementById('pay-qr-title');
const $9c3d0822d3033a97$var$payQrImageEl = document.getElementById('pay-qr-image');
const $9c3d0822d3033a97$var$payQrTipEl = document.getElementById('pay-qr-tip');
const $9c3d0822d3033a97$var$payActionStatusEl = document.getElementById('pay-action-status');
const $9c3d0822d3033a97$var$payCreateLoadingMaskEl = document.getElementById('pay-create-loading-mask');
const $9c3d0822d3033a97$var$payCreateLoadingTextEl = document.getElementById('pay-create-loading-text');
const $9c3d0822d3033a97$var$aiOfficialHintEl = document.getElementById('ai-official-hint');
const $9c3d0822d3033a97$var$aiOfficialModelOptionsEl = document.getElementById('ai-official-model-options');
const $9c3d0822d3033a97$var$aiRulesSourceEl = document.getElementById('ai-rules-source');
const $9c3d0822d3033a97$var$aiRulesDirtyEl = document.getElementById('ai-rules-dirty');
const $9c3d0822d3033a97$var$aiRulesCountEl = document.getElementById('ai-rules-count');
const $9c3d0822d3033a97$var$aiRulesTextarea = document.getElementById('ai-rules-textarea');
const $9c3d0822d3033a97$var$aiRulesSaveBtn = document.getElementById('ai-rules-save');
const $9c3d0822d3033a97$var$aiRulesResetBtn = document.getElementById('ai-rules-reset');
const $9c3d0822d3033a97$var$modal = document.getElementById('modal');
const $9c3d0822d3033a97$var$modalTitle = document.getElementById('modal-title');
const $9c3d0822d3033a97$var$modalText = document.getElementById('modal-text');
const $9c3d0822d3033a97$var$modalBody = document.getElementById('modal-body');
const $9c3d0822d3033a97$var$modalClose = document.getElementById('modal-close');
let $9c3d0822d3033a97$var$currentUser = null;
let $9c3d0822d3033a97$var$selectedAvatarIndex = 0;
const $9c3d0822d3033a97$var$MAX_AVATAR_FILE_BYTES = 5242880;
let $9c3d0822d3033a97$var$aiOfficialModels = [];
let $9c3d0822d3033a97$var$aiOfficialModelOptions = [];
let $9c3d0822d3033a97$var$aiDefault = {
    source: 'official',
    profileId: null
};
let $9c3d0822d3033a97$var$aiOfficial = {
    model: 'gpt-5.2',
    points: 0,
    enabled: false,
    canUse: false,
    configured: false
};
let $9c3d0822d3033a97$var$aiBillingItems = [];
let $9c3d0822d3033a97$var$payMode = 'manual';
let $9c3d0822d3033a97$var$payPackages = [];
let $9c3d0822d3033a97$var$payChannels = [
    'alipay',
    'wechat_native'
];
let $9c3d0822d3033a97$var$paySelectedPackageId = '';
let $9c3d0822d3033a97$var$paySelectedChannel = 'alipay';
let $9c3d0822d3033a97$var$payCurrentOrder = null;
let $9c3d0822d3033a97$var$payPollingTimer = null;
let $9c3d0822d3033a97$var$payConfigError = null;
const $9c3d0822d3033a97$var$payQrImageCache = new Map();
let $9c3d0822d3033a97$var$uiBusy = false;
let $9c3d0822d3033a97$var$apiOriginCache = null;
let $9c3d0822d3033a97$var$activeTab = 'account';
let $9c3d0822d3033a97$var$aiSettingsLoaded = false;
let $9c3d0822d3033a97$var$payConfigLoaded = false;
let $9c3d0822d3033a97$var$aiBillingLoaded = false;
let $9c3d0822d3033a97$var$aiRulesLoaded = false;
let $9c3d0822d3033a97$var$aiRulesDirty = false;
let $9c3d0822d3033a97$var$payTabLoadPromise = null;
let $9c3d0822d3033a97$var$replayTabLoadPromise = null;
let $9c3d0822d3033a97$var$practiceTabLoadPromise = null;
let $9c3d0822d3033a97$var$securityTabLoadPromise = null;
let $9c3d0822d3033a97$var$tabsInitialized = false;
let $9c3d0822d3033a97$var$replayRecordsLoaded = false;
let $9c3d0822d3033a97$var$replayRecords = [];
let $9c3d0822d3033a97$var$replayRoomFilter = 'all';
let $9c3d0822d3033a97$var$replayVariantFilter = 'all';
let $9c3d0822d3033a97$var$replayShareFilter = 'all';
let $9c3d0822d3033a97$var$practiceRecordsLoaded = false;
let $9c3d0822d3033a97$var$practiceRecordsMine = [];
let $9c3d0822d3033a97$var$practiceRecordsShared = [];
let $9c3d0822d3033a97$var$aiRules = {
    source: 'global',
    global: '',
    user: null
};
let $9c3d0822d3033a97$var$aiRulesSavedText = '';
const $9c3d0822d3033a97$var$EYE_ICON_SVG = '<svg viewBox="0 0 24 24"><path d="M2.06 12C3.08 8.95 6.2 6 12 6s8.92 2.95 9.94 6c-1.02 3.05-4.14 6-9.94 6s-8.92-2.95-9.94-6Z"></path><circle cx="12" cy="12" r="3"></circle></svg>';
const $9c3d0822d3033a97$var$EYE_OFF_ICON_SVG = '<svg viewBox="0 0 24 24"><path d="M10.73 5.08A10.96 10.96 0 0 1 12 5c5.8 0 8.92 2.95 9.94 6a11.87 11.87 0 0 1-2.06 3.36"></path><path d="M14.12 14.12A3 3 0 0 1 9.88 9.88"></path><path d="M17.94 17.94A11.91 11.91 0 0 1 12 19c-5.8 0-8.92-2.95-9.94-6a11.9 11.9 0 0 1 4.24-5.32"></path><path d="m2 2 20 20"></path></svg>';
function $9c3d0822d3033a97$var$openModal(title, text, body) {
    $9c3d0822d3033a97$var$modalTitle.textContent = title;
    $9c3d0822d3033a97$var$modalText.textContent = text;
    $9c3d0822d3033a97$var$modalBody.innerHTML = '';
    $9c3d0822d3033a97$var$modalBody.appendChild(body);
    $9c3d0822d3033a97$var$modal.classList.add('open');
}
function $9c3d0822d3033a97$var$closeModal() {
    $9c3d0822d3033a97$var$modal.classList.remove('open');
}
function $9c3d0822d3033a97$var$parseMeTabFromHash() {
    const raw = String(window.location.hash ?? '').replace(/^#/, '').trim().toLowerCase();
    if (raw === 'pay' || raw === 'ai' || raw === 'billing') return 'pay';
    if (raw === 'replay' || raw === 'paipu' || raw === "\u724C\u8C31") return 'replay';
    if (raw === 'practice' || raw === 'branch' || raw === 'branches') return 'practice';
    if (raw === 'security' || raw === 'safe' || raw === 'advanced') return 'security';
    return 'account';
}
function $9c3d0822d3033a97$var$tabHash(tab) {
    return `#${tab}`;
}
function $9c3d0822d3033a97$var$renderMeTabs(tab) {
    const tabs = [
        {
            key: 'account',
            btn: $9c3d0822d3033a97$var$meTabAccountBtn,
            panel: $9c3d0822d3033a97$var$mePanelAccountEl
        },
        {
            key: 'pay',
            btn: $9c3d0822d3033a97$var$meTabPayBtn,
            panel: $9c3d0822d3033a97$var$mePanelPayEl
        },
        {
            key: 'replay',
            btn: $9c3d0822d3033a97$var$meTabReplayBtn,
            panel: $9c3d0822d3033a97$var$mePanelReplayEl
        },
        {
            key: 'practice',
            btn: $9c3d0822d3033a97$var$meTabPracticeBtn,
            panel: $9c3d0822d3033a97$var$mePanelPracticeEl
        },
        {
            key: 'security',
            btn: $9c3d0822d3033a97$var$meTabSecurityBtn,
            panel: $9c3d0822d3033a97$var$mePanelSecurityEl
        }
    ];
    for (const item of tabs){
        const on = item.key === tab;
        item.btn.classList.toggle('is-active', on);
        item.btn.setAttribute('aria-selected', on ? 'true' : 'false');
        item.btn.tabIndex = on ? 0 : -1;
        item.panel.hidden = !on;
    }
    $9c3d0822d3033a97$var$scheduleMeCanvasScale();
}
function $9c3d0822d3033a97$var$setLoginStatusIfIdle(expected) {
    if (!$9c3d0822d3033a97$var$currentUser) return;
    if ($9c3d0822d3033a97$var$statusEl.textContent === expected) $9c3d0822d3033a97$var$statusEl.textContent = `\u{5DF2}\u{767B}\u{5F55}\u{FF1A}${$9c3d0822d3033a97$var$currentUser.nickname}`;
}
function $9c3d0822d3033a97$var$setPayActionStatus(text) {
    $9c3d0822d3033a97$var$payActionStatusEl.textContent = String(text ?? '').trim();
}
function $9c3d0822d3033a97$var$bindSecretToggle(input, button, label) {
    const sync = ()=>{
        const visible = input.type !== 'password';
        button.classList.toggle('is-visible', visible);
        button.setAttribute('aria-pressed', visible ? 'true' : 'false');
        button.setAttribute('aria-label', `${visible ? "\u9690\u85CF" : "\u663E\u793A"}${label}`);
    };
    input.type = 'password';
    button.onclick = ()=>{
        input.type = input.type === 'password' ? 'text' : 'password';
        sync();
    };
    sync();
}
function $9c3d0822d3033a97$var$createSecretToggleButton(input, label) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'secret-toggle';
    button.innerHTML = `<span class="secret-icon icon-show" aria-hidden="true">${$9c3d0822d3033a97$var$EYE_ICON_SVG}</span><span class="secret-icon icon-hide" aria-hidden="true">${$9c3d0822d3033a97$var$EYE_OFF_ICON_SVG}</span>`;
    $9c3d0822d3033a97$var$bindSecretToggle(input, button, label);
    return button;
}
function $9c3d0822d3033a97$var$setPayCreateLoading(active, text) {
    $9c3d0822d3033a97$var$payCreateLoadingMaskEl.hidden = !active;
    if (text !== undefined) $9c3d0822d3033a97$var$payCreateLoadingTextEl.textContent = String(text ?? '').trim() || "\u6B63\u5728\u521B\u5EFA\u652F\u4ED8\u8BA2\u5355\u2026";
}
function $9c3d0822d3033a97$var$setPayModeTip(text) {
    const tip = String(text ?? '').trim();
    $9c3d0822d3033a97$var$payModeTipEl.textContent = tip;
    $9c3d0822d3033a97$var$payModeTipEl.hidden = !tip;
}
function $9c3d0822d3033a97$var$updateAiRulesDraftMeta() {
    const text = $9c3d0822d3033a97$var$aiRulesTextarea.value ?? '';
    const count = Array.from(text).length;
    $9c3d0822d3033a97$var$aiRulesCountEl.textContent = `${count} \u{5B57}`;
    $9c3d0822d3033a97$var$aiRulesDirty = $9c3d0822d3033a97$var$aiRulesLoaded && text !== $9c3d0822d3033a97$var$aiRulesSavedText;
    $9c3d0822d3033a97$var$aiRulesDirtyEl.textContent = $9c3d0822d3033a97$var$aiRulesDirty ? "\u6709\u672A\u4FDD\u5B58\u4FEE\u6539" : "\u672A\u4FEE\u6539";
    $9c3d0822d3033a97$var$aiRulesDirtyEl.classList.toggle('warn', $9c3d0822d3033a97$var$aiRulesDirty);
    if (!$9c3d0822d3033a97$var$uiBusy) {
        $9c3d0822d3033a97$var$aiRulesSaveBtn.disabled = !$9c3d0822d3033a97$var$aiRulesDirty;
        $9c3d0822d3033a97$var$aiRulesResetBtn.disabled = !$9c3d0822d3033a97$var$aiRules.user;
    }
}
function $9c3d0822d3033a97$var$formatPoints(raw) {
    const n = Number.isFinite(raw) ? Math.trunc(raw) : 0;
    return new Intl.NumberFormat('zh-CN').format(n);
}
function $9c3d0822d3033a97$var$formatTime(raw) {
    const n = Number.isFinite(raw) ? Math.trunc(raw) : 0;
    if (n <= 0) return '-';
    const d = new Date(n);
    const y = d.getFullYear();
    const m = `${d.getMonth() + 1}`.padStart(2, '0');
    const day = `${d.getDate()}`.padStart(2, '0');
    const hh = `${d.getHours()}`.padStart(2, '0');
    const mm = `${d.getMinutes()}`.padStart(2, '0');
    return `${y}-${m}-${day} ${hh}:${mm}`;
}
function $9c3d0822d3033a97$var$formatSigned(raw) {
    if (!Number.isFinite(raw ?? NaN)) return '--';
    const n = Math.trunc(raw);
    if (n > 0) return `+${$9c3d0822d3033a97$var$formatPoints(n)}`;
    if (n < 0) return `-${$9c3d0822d3033a97$var$formatPoints(Math.abs(n))}`;
    return '0';
}
function $9c3d0822d3033a97$var$practiceStatusLabel(item) {
    if (item.templateStatus === 'disabled' && item.status !== 'active') return "\u5DF2\u5931\u6548";
    if (item.status === 'ready') return "\u53EF\u8FDB\u5165";
    if (item.status === 'active') return "\u8FDB\u884C\u4E2D";
    if (item.status === 'done') return "\u5DF2\u5B8C\u6210";
    return "\u9501\u5B9A\u4E2D";
}
function $9c3d0822d3033a97$var$practiceRoomLabel(roomType) {
    if (roomType === 'newbie') return "\u65B0\u624B\u623F";
    if (roomType === 'friend') return "\u597D\u53CB\u623F";
    return "\u5BF9\u5C40";
}
function $9c3d0822d3033a97$var$paipuRoomLabel(roomType) {
    return $9c3d0822d3033a97$var$practiceRoomLabel(roomType);
}
function $9c3d0822d3033a97$var$paipuVariantLabel(variant) {
    if (variant === 'guobiao') return "\u56FD\u9645\u6807\u51C6";
    return "\u8840\u6218\u5230\u5E95";
}
function $9c3d0822d3033a97$var$paipuResultLabel(item) {
    const delta = item.myResult.pointsDelta ?? item.myResult.deltaBeans;
    const parts = [
        `\u{7ED3}\u{679C}\u{FF1A}${$9c3d0822d3033a97$var$formatSigned(delta ?? null)}`
    ];
    if (item.rules?.variant === 'guobiao' && Number.isFinite(item.myResult.ruleScoreDelta ?? NaN)) parts.push(`\u{89C4}\u{5219}\u{5206} ${$9c3d0822d3033a97$var$formatSigned(item.myResult.ruleScoreDelta ?? null)}`);
    if (item.myResult.finalBeans !== null) parts.push(`\u{5F53}\u{524D} ${$9c3d0822d3033a97$var$formatPoints(item.myResult.finalBeans)}`);
    return parts.join(" \xb7 ");
}
function $9c3d0822d3033a97$var$practiceSceneLabel(scene) {
    if (scene === 'turn') return "\u5F03\u724C\u51B3\u7B56";
    if (scene === 'claim') return "\u54CD\u5E94\u51B3\u7B56";
    if (scene === 'swap3') return "\u6362\u4E09\u5F20";
    if (scene === 'dingque') return "\u5B9A\u7F3A";
    return "\u5C40\u9762\u5FEB\u7167";
}
function $9c3d0822d3033a97$var$practiceShareStateLabel(state) {
    return state === 'shared' ? "\u5DF2\u5206\u4EAB" : "\u4EC5\u81EA\u5DF1";
}
function $9c3d0822d3033a97$var$normalizeActiveGame(raw) {
    const gameId = typeof raw?.gameId === 'string' ? raw.gameId.trim() : '';
    if (!gameId) return null;
    const seatRaw = Number(raw?.seat);
    const seat = Number.isFinite(seatRaw) ? Math.trunc(seatRaw) : -1;
    if (seat < 0 || seat > 3) return null;
    const roomType = typeof raw?.roomType === 'string' ? raw.roomType.trim() || null : null;
    return {
        gameId: gameId,
        seat: seat,
        roomType: roomType
    };
}
function $9c3d0822d3033a97$var$practiceActiveGameUrl(active) {
    const basePath = (0, $iRbTC.getBasePath)();
    const room = active.roomType === 'newbie' ? '&room=newbie' : '';
    return `${basePath}hand/?gameId=${encodeURIComponent(active.gameId)}${room}`;
}
function $9c3d0822d3033a97$var$practiceCanEnter(item) {
    if (item.status === 'locked') return false;
    if (item.templateStatus === 'disabled' && item.status !== 'active') return false;
    return true;
}
function $9c3d0822d3033a97$var$practiceEnterLabel(item) {
    if (item.templateStatus === 'disabled' && item.status !== 'active') return "\u5DF2\u5931\u6548";
    if (item.status === 'locked') return "\u672A\u89E3\u9501";
    if (item.status === 'active') return "\u7EE7\u7EED";
    if (item.status === 'done') return "\u518D\u6765\u4E00\u5C40";
    return "\u8FDB\u5165";
}
function $9c3d0822d3033a97$var$practiceCanShare(item) {
    if (item.status === 'locked') return false;
    if (item.templateStatus === 'disabled') return false;
    return true;
}
function $9c3d0822d3033a97$var$buildAppUrl(path) {
    const basePath = (0, $iRbTC.getBasePath)();
    const normalizedBase = basePath.endsWith('/') ? basePath : `${basePath}/`;
    const relative = String(path ?? '').replace(/^\/+/, '');
    return new URL(`${normalizedBase}${relative}`, window.location.origin).toString();
}
function $9c3d0822d3033a97$var$replacePracticeRecord(next) {
    const update = (items)=>{
        let found = false;
        const mapped = items.map((item)=>{
            if (item.recordId !== next.recordId) return item;
            found = true;
            return next;
        });
        return found ? mapped : items;
    };
    if (next.recordOrigin === 'shared_collected') $9c3d0822d3033a97$var$practiceRecordsShared = update($9c3d0822d3033a97$var$practiceRecordsShared);
    else $9c3d0822d3033a97$var$practiceRecordsMine = update($9c3d0822d3033a97$var$practiceRecordsMine);
}
function $9c3d0822d3033a97$var$removePracticeRecord(recordId) {
    $9c3d0822d3033a97$var$practiceRecordsMine = $9c3d0822d3033a97$var$practiceRecordsMine.filter((item)=>item.recordId !== recordId);
    $9c3d0822d3033a97$var$practiceRecordsShared = $9c3d0822d3033a97$var$practiceRecordsShared.filter((item)=>item.recordId !== recordId);
}
function $9c3d0822d3033a97$var$openPracticeActiveGameModal(active) {
    const body = document.createElement('div');
    body.className = 'field';
    const line1 = document.createElement('div');
    line1.className = 'sub';
    line1.textContent = `\u{5F53}\u{524D}\u{6B63}\u{5728}\u{8FDB}\u{884C}\u{FF1A}${$9c3d0822d3033a97$var$practiceRoomLabel(active.roomType)}\u{FF08}\u{5EA7}\u{4F4D} ${active.seat + 1}\u{FF09}\u{3002}`;
    body.appendChild(line1);
    const line2 = document.createElement('div');
    line2.className = 'sub';
    line2.textContent = "\u4E3A\u907F\u514D\u591A\u684C\u5E76\u53D1\uFF0C\u8BF7\u5148\u56DE\u5230\u5F53\u524D\u724C\u5C40\u3002";
    body.appendChild(line2);
    const row = document.createElement('div');
    row.className = 'row';
    const backBtn = document.createElement('a');
    backBtn.className = 'btn-mini primary';
    backBtn.href = $9c3d0822d3033a97$var$practiceActiveGameUrl(active);
    backBtn.textContent = "\u56DE\u5230\u5F53\u524D\u724C\u5C40";
    row.appendChild(backBtn);
    const meBtn = document.createElement('a');
    meBtn.className = 'btn-mini ghost';
    meBtn.href = `${(0, $iRbTC.getBasePath)()}me/#practice`;
    meBtn.textContent = "\u7559\u5728\u7EC3\u4E60\u5217\u8868";
    row.appendChild(meBtn);
    body.appendChild(row);
    $9c3d0822d3033a97$var$openModal("\u65E0\u6CD5\u540C\u65F6\u5F00\u59CB\u591A\u4E2A\u5BF9\u5C40", "\u8BF7\u5148\u5904\u7406\u5F53\u524D\u8FDB\u884C\u4E2D\u7684\u724C\u5C40\u3002", body);
}
function $9c3d0822d3033a97$var$channelLabel(ch) {
    return ch === 'wechat_native' ? "\u5FAE\u4FE1\u626B\u7801" : "\u652F\u4ED8\u5B9D";
}
function $9c3d0822d3033a97$var$isMobileBrowser() {
    if (typeof window === 'undefined') return false;
    const uaDataMobile = navigator?.userAgentData?.mobile;
    if (typeof uaDataMobile === 'boolean') return uaDataMobile;
    const ua = navigator.userAgent || '';
    if (/(Mobi|Android|iPhone|iPad|iPod|Windows Phone|Mobile)/i.test(ua)) return true;
    // iPadOS desktop UA fallback.
    if (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) return true;
    return false;
}
function $9c3d0822d3033a97$var$isDesktopPayView() {
    return !$9c3d0822d3033a97$var$isMobileBrowser();
}
function $9c3d0822d3033a97$var$buildQrPath(modules, margin) {
    const ops = [];
    for(let y = 0; y < modules.length; y++){
        const row = modules[y] ?? [];
        let start = null;
        for(let x = 0; x <= row.length; x++){
            const dark = x < row.length ? Boolean(row[x]) : false;
            if (dark && start === null) {
                start = x;
                continue;
            }
            if (!dark && start !== null) {
                ops.push(`M${start + margin} ${y + margin}h${x - start}v1H${start + margin}z`);
                start = null;
            }
        }
    }
    return ops.join('');
}
function $9c3d0822d3033a97$var$buildQrImageUrl(data) {
    const text = String(data ?? '').trim();
    if (!text) return '';
    const cached = $9c3d0822d3033a97$var$payQrImageCache.get(text);
    if (cached) return cached;
    const qr = (0, $43f1258e3bca17c3$export$e3b6b80dd4f481c3).encodeText(text, (0, $43f1258e3bca17c3$export$a92359712a79a565).MEDIUM);
    const modules = qr.getModules();
    const margin = 2;
    const gridSize = modules.length + margin * 2;
    const path = $9c3d0822d3033a97$var$buildQrPath(modules, margin);
    const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="320" height="320" viewBox="0 0 ${gridSize} ${gridSize}" shape-rendering="crispEdges"><rect width="100%" height="100%" fill="#fff"/><path d="${path}" fill="#000"/></svg>`;
    const image = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
    $9c3d0822d3033a97$var$payQrImageCache.set(text, image);
    return image;
}
function $9c3d0822d3033a97$var$shouldShowPayQrPanel(order) {
    if (!order || !order.payUrl) return false;
    if ($9c3d0822d3033a97$var$isDesktopPayView()) return true;
    return order.channel === 'wechat_native';
}
function $9c3d0822d3033a97$var$renderPayQrPanel(order) {
    if (!$9c3d0822d3033a97$var$payQrPanelEl || !$9c3d0822d3033a97$var$payQrTitleEl || !$9c3d0822d3033a97$var$payQrImageEl || !$9c3d0822d3033a97$var$payQrTipEl) return;
    if (!$9c3d0822d3033a97$var$shouldShowPayQrPanel(order)) {
        $9c3d0822d3033a97$var$payQrPanelEl.hidden = true;
        $9c3d0822d3033a97$var$payQrImageEl.removeAttribute('src');
        $9c3d0822d3033a97$var$payQrImageEl.removeAttribute('data-src');
        return;
    }
    if (!order || !order.payUrl) {
        $9c3d0822d3033a97$var$payQrPanelEl.hidden = true;
        $9c3d0822d3033a97$var$payQrImageEl.removeAttribute('src');
        $9c3d0822d3033a97$var$payQrImageEl.removeAttribute('data-src');
        return;
    }
    const desktop = $9c3d0822d3033a97$var$isDesktopPayView();
    let title = '';
    let tip = '';
    if (order.channel === 'alipay') {
        title = "\u8BF7\u4F7F\u7528\u624B\u673A\u652F\u4ED8\u5B9D\u626B\u7801\u652F\u4ED8";
        tip = `\u{8BA2}\u{5355} ${order.id} \xb7 \u{652F}\u{4ED8}\u{5B9D} \xb7 ${order.amountYuanText} \u{5143}`;
    } else if (desktop) {
        title = "\u8BF7\u4F7F\u7528\u624B\u673A\u5FAE\u4FE1\u626B\u7801\u652F\u4ED8";
        tip = `\u{8BA2}\u{5355} ${order.id} \xb7 \u{5FAE}\u{4FE1}\u{626B}\u{7801} \xb7 ${order.amountYuanText} \u{5143}`;
    } else {
        title = "\u5FAE\u4FE1\u652F\u4ED8\u4E8C\u7EF4\u7801";
        tip = `\u{8BA2}\u{5355} ${order.id} \xb7 \u{5FAE}\u{4FE1} Native \u{5728}\u{624B}\u{673A}\u{540C}\u{673A}\u{901A}\u{5E38}\u{65E0}\u{6CD5}\u{76F4}\u{63A5}\u{652F}\u{4ED8}\u{FF0C}\u{8BF7}\u{7528}\u{53E6}\u{4E00}\u{53F0}\u{8BBE}\u{5907}\u{626B}\u{7801}\u{3002}`;
    }
    $9c3d0822d3033a97$var$payQrTitleEl.textContent = title;
    $9c3d0822d3033a97$var$payQrTipEl.textContent = tip;
    $9c3d0822d3033a97$var$payQrImageEl.src = $9c3d0822d3033a97$var$buildQrImageUrl(order.payUrl);
    $9c3d0822d3033a97$var$payQrImageEl.setAttribute('data-src', order.payUrl);
    $9c3d0822d3033a97$var$payQrPanelEl.hidden = false;
}
function $9c3d0822d3033a97$var$payStatusLabel(status) {
    if (status === 'credited') return "\u5DF2\u5165\u8D26";
    if (status === 'paid') return "\u5DF2\u652F\u4ED8\uFF0C\u7B49\u5F85\u5165\u8D26";
    if (status === 'expired') return "\u5DF2\u8FC7\u671F";
    if (status === 'closed') return "\u5DF2\u5173\u95ED";
    return "\u5F85\u652F\u4ED8";
}
function $9c3d0822d3033a97$var$stopPayPolling() {
    if ($9c3d0822d3033a97$var$payPollingTimer !== null) {
        window.clearInterval($9c3d0822d3033a97$var$payPollingTimer);
        $9c3d0822d3033a97$var$payPollingTimer = null;
    }
}
function $9c3d0822d3033a97$var$isFinalPayStatus(status) {
    return status === 'credited' || status === 'expired' || status === 'closed';
}
$9c3d0822d3033a97$var$modalClose.onclick = $9c3d0822d3033a97$var$closeModal;
$9c3d0822d3033a97$var$modal.onclick = (e)=>{
    if (e.target === $9c3d0822d3033a97$var$modal) $9c3d0822d3033a97$var$closeModal();
};
window.addEventListener('resize', ()=>{
    $9c3d0822d3033a97$var$renderPayQrPanel($9c3d0822d3033a97$var$payCurrentOrder);
});
function $9c3d0822d3033a97$var$normalizePresetAvatarIndex(raw) {
    const n = Number.isFinite(Number(raw)) ? Math.trunc(Number(raw)) : 0;
    return Math.max(0, Math.min($9c3d0822d3033a97$var$avatars.length - 1, n));
}
function $9c3d0822d3033a97$var$resolveCustomAvatarUrl(user) {
    const raw = typeof user?.avatarUrl === 'string' ? user.avatarUrl.trim() : '';
    if (!raw) return null;
    if (/^(?:https?:)?\/\//i.test(raw) || raw.startsWith('data:') || raw.startsWith('blob:')) return raw;
    if (raw.startsWith('/')) {
        const origin = $9c3d0822d3033a97$var$resolveApiOrigin();
        if (origin) return `${origin}${raw}`;
    }
    return raw;
}
function $9c3d0822d3033a97$var$hasCustomAvatar(user) {
    return !!$9c3d0822d3033a97$var$resolveCustomAvatarUrl(user);
}
function $9c3d0822d3033a97$var$resolveApiOrigin() {
    if ($9c3d0822d3033a97$var$apiOriginCache !== null) return $9c3d0822d3033a97$var$apiOriginCache || null;
    try {
        const origin = new URL((0, $8PAWz.getApiBaseUrl)(), window.location.href).origin;
        $9c3d0822d3033a97$var$apiOriginCache = origin || '';
        return origin || null;
    } catch  {
        $9c3d0822d3033a97$var$apiOriginCache = '';
        return null;
    }
}
function $9c3d0822d3033a97$var$currentAvatarSrc(user) {
    const custom = $9c3d0822d3033a97$var$resolveCustomAvatarUrl(user);
    if (custom) return custom;
    const idx = $9c3d0822d3033a97$var$normalizePresetAvatarIndex(user?.avatarIndex ?? $9c3d0822d3033a97$var$selectedAvatarIndex);
    return $9c3d0822d3033a97$var$avatars[idx] ?? $9c3d0822d3033a97$var$avatars[0];
}
function $9c3d0822d3033a97$var$renderAvatarCurrentCard() {
    const custom = $9c3d0822d3033a97$var$hasCustomAvatar($9c3d0822d3033a97$var$currentUser);
    const presetIdx = $9c3d0822d3033a97$var$normalizePresetAvatarIndex($9c3d0822d3033a97$var$selectedAvatarIndex);
    $9c3d0822d3033a97$var$avatarCurrentImageEl.src = $9c3d0822d3033a97$var$currentAvatarSrc($9c3d0822d3033a97$var$currentUser);
    $9c3d0822d3033a97$var$avatarCurrentImageEl.alt = $9c3d0822d3033a97$var$currentUser?.nickname ? `${$9c3d0822d3033a97$var$currentUser.nickname} \u{7684}\u{5934}\u{50CF}` : "\u5F53\u524D\u5934\u50CF";
    $9c3d0822d3033a97$var$avatarCurrentTitleEl.textContent = custom ? "\u5F53\u524D\u5934\u50CF\uFF08\u81EA\u5B9A\u4E49\uFF09" : `\u{5F53}\u{524D}\u{5934}\u{50CF}\u{FF08}\u{9884}\u{5907} ${presetIdx + 1}\u{FF09}`;
    $9c3d0822d3033a97$var$avatarCurrentDescEl.textContent = custom ? "\u4F60\u6B63\u5728\u4F7F\u7528\u81EA\u5B9A\u4E49\u5934\u50CF\u3002\u539F\u56FE\u5C55\u793A\uFF0C\u4E0D\u505A\u81EA\u52A8\u88C1\u526A\u3002" : "\u4F60\u6B63\u5728\u4F7F\u7528\u9884\u5907\u5934\u50CF\u3002\u53EF\u4E0A\u4F20\u81EA\u5B9A\u4E49\u5934\u50CF\u8FDB\u884C\u66FF\u6362\u3002";
}
function $9c3d0822d3033a97$var$renderAvatarSection() {
    $9c3d0822d3033a97$var$renderAvatarCurrentCard();
}
function $9c3d0822d3033a97$var$renderMatchPoints() {
    if (!$9c3d0822d3033a97$var$matchPointsEl) return;
    if (!$9c3d0822d3033a97$var$currentUser) {
        $9c3d0822d3033a97$var$matchPointsEl.textContent = '-';
        return;
    }
    const points = Number.isFinite($9c3d0822d3033a97$var$currentUser.matchPoints) ? Math.max(0, Math.trunc($9c3d0822d3033a97$var$currentUser.matchPoints)) : 0;
    $9c3d0822d3033a97$var$matchPointsEl.textContent = $9c3d0822d3033a97$var$formatPoints(points);
}
function $9c3d0822d3033a97$var$readFileAsDataUrl(file) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onload = ()=>{
            const out = typeof reader.result === 'string' ? reader.result : '';
            if (!out) {
                reject(new Error('read failed'));
                return;
            }
            resolve(out);
        };
        reader.onerror = ()=>reject(new Error('read failed'));
        reader.readAsDataURL(file);
    });
}
async function $9c3d0822d3033a97$var$uploadCustomAvatar(file) {
    const clearAvatarUploadInput = ()=>{
        $9c3d0822d3033a97$var$avatarUploadInput.value = '';
    };
    if (!$9c3d0822d3033a97$var$currentUser) {
        clearAvatarUploadInput();
        return;
    }
    const mime = String(file.type ?? '').toLowerCase();
    if (!mime || ![
        'image/png',
        'image/jpeg',
        'image/webp',
        'image/gif'
    ].includes(mime)) {
        $9c3d0822d3033a97$var$statusEl.textContent = "\u4EC5\u652F\u6301 PNG / JPG / WEBP / GIF \u56FE\u7247\u3002";
        clearAvatarUploadInput();
        return;
    }
    if (file.size <= 0) {
        $9c3d0822d3033a97$var$statusEl.textContent = "\u4E0A\u4F20\u5931\u8D25\uFF1A\u56FE\u7247\u4E3A\u7A7A\u3002";
        clearAvatarUploadInput();
        return;
    }
    if (file.size > $9c3d0822d3033a97$var$MAX_AVATAR_FILE_BYTES) {
        $9c3d0822d3033a97$var$statusEl.textContent = "\u4E0A\u4F20\u5931\u8D25\uFF1A\u56FE\u7247\u4E0D\u80FD\u8D85\u8FC7 5MB\u3002";
        clearAvatarUploadInput();
        return;
    }
    let dataUrl = '';
    try {
        dataUrl = await $9c3d0822d3033a97$var$readFileAsDataUrl(file);
    } catch  {
        $9c3d0822d3033a97$var$statusEl.textContent = "\u4E0A\u4F20\u5931\u8D25\uFF1A\u65E0\u6CD5\u8BFB\u53D6\u56FE\u7247\u3002";
        clearAvatarUploadInput();
        return;
    }
    $9c3d0822d3033a97$var$setUiEnabled(false);
    $9c3d0822d3033a97$var$statusEl.textContent = "\u6B63\u5728\u4E0A\u4F20\u5934\u50CF\u2026";
    try {
        const { user: user } = await (0, $8PAWz.uploadMeAvatar)(dataUrl);
        $9c3d0822d3033a97$var$currentUser = user;
        $9c3d0822d3033a97$var$selectedAvatarIndex = $9c3d0822d3033a97$var$normalizePresetAvatarIndex(user.avatarIndex);
        $9c3d0822d3033a97$var$renderAvatarSection();
        $9c3d0822d3033a97$var$renderMatchPoints();
        $9c3d0822d3033a97$var$statusEl.textContent = "\u5934\u50CF\u5DF2\u66F4\u65B0\u3002";
        window.setTimeout(()=>$9c3d0822d3033a97$var$setLoginStatusIfIdle("\u5934\u50CF\u5DF2\u66F4\u65B0\u3002"), 900);
    } catch (err) {
        $9c3d0822d3033a97$var$statusEl.textContent = `\u{4E0A}\u{4F20}\u{5931}\u{8D25}\u{FF1A}${String(err?.message ?? err)}`;
    } finally{
        clearAvatarUploadInput();
        $9c3d0822d3033a97$var$setUiEnabled(true);
    }
}
function $9c3d0822d3033a97$var$setUiEnabled(enabled) {
    const busy = !enabled;
    $9c3d0822d3033a97$var$uiBusy = busy;
    $9c3d0822d3033a97$var$nickInput.disabled = busy;
    $9c3d0822d3033a97$var$bgmEnabledInput.disabled = busy;
    $9c3d0822d3033a97$var$sfxEnabledInput.disabled = busy;
    $9c3d0822d3033a97$var$saveBtn.disabled = busy;
    $9c3d0822d3033a97$var$avatarUploadBtn.disabled = busy;
    $9c3d0822d3033a97$var$avatarUploadInput.disabled = busy;
    $9c3d0822d3033a97$var$meTabAccountBtn.disabled = busy;
    $9c3d0822d3033a97$var$meTabPayBtn.disabled = busy;
    $9c3d0822d3033a97$var$meTabReplayBtn.disabled = busy;
    $9c3d0822d3033a97$var$meTabPracticeBtn.disabled = busy;
    $9c3d0822d3033a97$var$meTabSecurityBtn.disabled = busy;
    $9c3d0822d3033a97$var$loginTokenVisibilityBtn.disabled = busy;
    $9c3d0822d3033a97$var$copyLoginBtn.disabled = busy;
    $9c3d0822d3033a97$var$resetLoginBtn.disabled = busy;
    $9c3d0822d3033a97$var$resetApiBtn.disabled = busy;
    $9c3d0822d3033a97$var$aiBillingRefreshBtn.disabled = busy;
    $9c3d0822d3033a97$var$replayRefreshBtn.disabled = busy;
    $9c3d0822d3033a97$var$replayFilterRoomAllBtn.disabled = busy;
    $9c3d0822d3033a97$var$replayFilterRoomNewbieBtn.disabled = busy;
    $9c3d0822d3033a97$var$replayFilterRoomFriendBtn.disabled = busy;
    $9c3d0822d3033a97$var$replayFilterVariantAllBtn.disabled = busy;
    $9c3d0822d3033a97$var$replayFilterVariantXuezhanBtn.disabled = busy;
    $9c3d0822d3033a97$var$replayFilterVariantGuobiaoBtn.disabled = busy;
    $9c3d0822d3033a97$var$replayFilterShareAllBtn.disabled = busy;
    $9c3d0822d3033a97$var$replayFilterShareSharedBtn.disabled = busy;
    $9c3d0822d3033a97$var$replayFilterShareUnsharedBtn.disabled = busy;
    $9c3d0822d3033a97$var$practiceRefreshBtn.disabled = busy;
    $9c3d0822d3033a97$var$payCreateOrderBtn.disabled = busy || !!$9c3d0822d3033a97$var$payConfigError || $9c3d0822d3033a97$var$payMode !== 'xorpay' || $9c3d0822d3033a97$var$payPackages.length === 0;
    $9c3d0822d3033a97$var$aiRulesTextarea.disabled = busy;
    $9c3d0822d3033a97$var$aiRulesSaveBtn.disabled = busy;
    $9c3d0822d3033a97$var$aiRulesResetBtn.disabled = busy || !$9c3d0822d3033a97$var$aiRules.user;
    if (!busy) {
        // Re-apply logical disabled states computed from current data,
        // so we don't accidentally enable controls that should remain disabled.
        $9c3d0822d3033a97$var$renderAiSettings();
        $9c3d0822d3033a97$var$updateAiRulesDraftMeta();
        $9c3d0822d3033a97$var$renderPaySection();
        $9c3d0822d3033a97$var$renderReplayRecords();
        $9c3d0822d3033a97$var$renderPracticeRecords();
    } else {
        const modelOptionButtons = $9c3d0822d3033a97$var$aiOfficialModelOptionsEl.querySelectorAll('button');
        modelOptionButtons.forEach((b)=>b.disabled = true);
        const payOptionButtons = $9c3d0822d3033a97$var$mePanelPayEl.querySelectorAll('button[data-pay-option]');
        payOptionButtons.forEach((b)=>b.disabled = true);
        const replayButtons = $9c3d0822d3033a97$var$mePanelReplayEl.querySelectorAll('button');
        replayButtons.forEach((b)=>b.disabled = true);
        const practiceButtons = $9c3d0822d3033a97$var$mePanelPracticeEl.querySelectorAll('button');
        practiceButtons.forEach((b)=>b.disabled = true);
    }
}
$9c3d0822d3033a97$var$saveBtn.onclick = async ()=>{
    if (!$9c3d0822d3033a97$var$currentUser) return;
    $9c3d0822d3033a97$var$setUiEnabled(false);
    $9c3d0822d3033a97$var$statusEl.textContent = "\u6B63\u5728\u4FDD\u5B58\u2026";
    try {
        const nickname = $9c3d0822d3033a97$var$nickInput.value.trim();
        const { user: user } = await (0, $8PAWz.updateMe)({
            nickname: nickname,
            bgmEnabled: !!$9c3d0822d3033a97$var$bgmEnabledInput.checked,
            sfxEnabled: !!$9c3d0822d3033a97$var$sfxEnabledInput.checked
        });
        $9c3d0822d3033a97$var$currentUser = user;
        $9c3d0822d3033a97$var$selectedAvatarIndex = $9c3d0822d3033a97$var$normalizePresetAvatarIndex(user.avatarIndex);
        $9c3d0822d3033a97$var$bgmEnabledInput.checked = user.bgmEnabled !== false;
        $9c3d0822d3033a97$var$sfxEnabledInput.checked = user.sfxEnabled !== false;
        $9c3d0822d3033a97$var$renderAvatarSection();
        $9c3d0822d3033a97$var$renderMatchPoints();
        $9c3d0822d3033a97$var$statusEl.textContent = "\u5DF2\u4FDD\u5B58\u3002";
        setTimeout(()=>{
            if ($9c3d0822d3033a97$var$statusEl.textContent === "\u5DF2\u4FDD\u5B58\u3002") $9c3d0822d3033a97$var$statusEl.textContent = `\u{5DF2}\u{767B}\u{5F55}\u{FF1A}${user.nickname}`;
        }, 1000);
    } catch (err) {
        $9c3d0822d3033a97$var$statusEl.textContent = `\u{4FDD}\u{5B58}\u{5931}\u{8D25}\u{FF1A}${String(err?.message ?? err)}`;
    } finally{
        $9c3d0822d3033a97$var$setUiEnabled(true);
    }
};
$9c3d0822d3033a97$var$avatarUploadBtn.onclick = ()=>{
    if ($9c3d0822d3033a97$var$uiBusy) return;
    $9c3d0822d3033a97$var$avatarUploadInput.click();
};
$9c3d0822d3033a97$var$avatarUploadInput.onchange = ()=>{
    const file = $9c3d0822d3033a97$var$avatarUploadInput.files?.[0] ?? null;
    if (!file) {
        $9c3d0822d3033a97$var$avatarUploadInput.value = '';
        return;
    }
    $9c3d0822d3033a97$var$uploadCustomAvatar(file);
};
$9c3d0822d3033a97$var$bindSecretToggle($9c3d0822d3033a97$var$loginTokenInput, $9c3d0822d3033a97$var$loginTokenVisibilityBtn, "\u767B\u5F55\u53E3\u4EE4");
$9c3d0822d3033a97$var$copyLoginBtn.onclick = async ()=>{
    const token = $9c3d0822d3033a97$var$loginTokenInput.value.trim();
    if (!token) return;
    await $9c3d0822d3033a97$var$copyText(token);
    $9c3d0822d3033a97$var$copyLoginBtn.textContent = "\u5DF2\u590D\u5236";
    setTimeout(()=>$9c3d0822d3033a97$var$copyLoginBtn.textContent = "\u590D\u5236", 900);
};
$9c3d0822d3033a97$var$resetApiBtn.onclick = async ()=>{
    if (!$9c3d0822d3033a97$var$currentUser) return;
    if (!confirm("\u786E\u5B9A\u8981\u91CD\u7F6E\u4EE4\u724C\u5417\uFF1F\u65E7\u4EE4\u724C\u5C06\u7ACB\u5373\u5931\u6548\u3002")) return;
    $9c3d0822d3033a97$var$setUiEnabled(false);
    $9c3d0822d3033a97$var$statusEl.textContent = "\u6B63\u5728\u91CD\u7F6E\u4EE4\u724C\u2026";
    try {
        const { apiToken: apiToken, user: user } = await (0, $8PAWz.resetApiToken)();
        $9c3d0822d3033a97$var$currentUser = user;
        $9c3d0822d3033a97$var$renderMatchPoints();
        $9c3d0822d3033a97$var$statusEl.textContent = "\u5DF2\u91CD\u7F6E\u4EE4\u724C\uFF08\u8BF7\u7ACB\u5373\u590D\u5236\u4FDD\u5B58\uFF09\u3002";
        $9c3d0822d3033a97$var$openModal("\u65B0\u7684\u4EE4\u724C", "\u8BE5\u4EE4\u724C\u4EC5\u5C55\u793A\u4E00\u6B21\uFF0C\u5173\u95ED\u540E\u65E0\u6CD5\u518D\u6B21\u67E5\u770B\u3002", $9c3d0822d3033a97$var$buildCopyField(apiToken, "\u4EE4\u724C"));
    } catch (err) {
        $9c3d0822d3033a97$var$statusEl.textContent = `\u{91CD}\u{7F6E}\u{5931}\u{8D25}\u{FF1A}${String(err?.message ?? err)}`;
    } finally{
        $9c3d0822d3033a97$var$setUiEnabled(true);
    }
};
$9c3d0822d3033a97$var$resetLoginBtn.onclick = async ()=>{
    if (!$9c3d0822d3033a97$var$currentUser) return;
    if (!confirm("\u786E\u5B9A\u8981\u91CD\u7F6E\u767B\u5F55\u53E3\u4EE4\u5417\uFF1F\u65E7\u53E3\u4EE4\u5C06\u7ACB\u5373\u5931\u6548\u3002")) return;
    $9c3d0822d3033a97$var$setUiEnabled(false);
    $9c3d0822d3033a97$var$statusEl.textContent = "\u6B63\u5728\u91CD\u7F6E\u767B\u5F55\u53E3\u4EE4\u2026";
    try {
        const { loginToken: loginToken, user: user } = await (0, $8PAWz.resetLoginToken)();
        (0, $8PAWz.setLoginToken)(loginToken);
        $9c3d0822d3033a97$var$currentUser = user;
        $9c3d0822d3033a97$var$renderMatchPoints();
        $9c3d0822d3033a97$var$loginTokenInput.value = loginToken;
        $9c3d0822d3033a97$var$statusEl.textContent = "\u5DF2\u91CD\u7F6E\u767B\u5F55\u53E3\u4EE4\uFF08\u8BF7\u7ACB\u5373\u590D\u5236\u4FDD\u5B58\uFF09\u3002";
        $9c3d0822d3033a97$var$openModal("\u65B0\u7684\u767B\u5F55\u53E3\u4EE4", "\u8BF7\u7ACB\u5373\u590D\u5236\u4FDD\u5B58\u3002\u65E7\u53E3\u4EE4\u5DF2\u5931\u6548\u3002", $9c3d0822d3033a97$var$buildCopyField(loginToken, "\u767B\u5F55\u53E3\u4EE4"));
    } catch (err) {
        $9c3d0822d3033a97$var$statusEl.textContent = `\u{91CD}\u{7F6E}\u{5931}\u{8D25}\u{FF1A}${String(err?.message ?? err)}`;
    } finally{
        $9c3d0822d3033a97$var$setUiEnabled(true);
    }
};
function $9c3d0822d3033a97$var$buildCopyField(value, label) {
    const wrap = document.createElement('div');
    wrap.className = 'field';
    if (label) {
        const t = document.createElement('div');
        t.className = 'sub';
        t.textContent = label;
        wrap.appendChild(t);
    }
    const input = document.createElement('input');
    input.readOnly = true;
    input.value = value;
    const inputWrap = document.createElement('div');
    inputWrap.className = 'secret-input-wrap';
    inputWrap.appendChild(input);
    inputWrap.appendChild($9c3d0822d3033a97$var$createSecretToggleButton(input, label ?? "\u53E3\u4EE4"));
    const row = document.createElement('div');
    row.className = 'row';
    const copy = document.createElement('button');
    copy.type = 'button';
    copy.className = 'btn-mini ghost';
    copy.textContent = "\u590D\u5236";
    copy.onclick = async ()=>{
        await $9c3d0822d3033a97$var$copyText(value);
        copy.textContent = "\u5DF2\u590D\u5236";
        setTimeout(()=>copy.textContent = "\u590D\u5236", 900);
    };
    row.appendChild(copy);
    wrap.appendChild(inputWrap);
    wrap.appendChild(row);
    return wrap;
}
function $9c3d0822d3033a97$var$buildCopyTextField(value, label) {
    const wrap = document.createElement('div');
    wrap.className = 'field';
    if (label) {
        const t = document.createElement('div');
        t.className = 'sub';
        t.textContent = label;
        wrap.appendChild(t);
    }
    const input = document.createElement('input');
    input.readOnly = true;
    input.value = value;
    wrap.appendChild(input);
    const row = document.createElement('div');
    row.className = 'row';
    const copy = document.createElement('button');
    copy.type = 'button';
    copy.className = 'btn-mini ghost';
    copy.textContent = "\u590D\u5236";
    copy.onclick = async ()=>{
        await $9c3d0822d3033a97$var$copyText(value);
        copy.textContent = "\u5DF2\u590D\u5236";
        setTimeout(()=>copy.textContent = "\u590D\u5236", 900);
    };
    row.appendChild(copy);
    wrap.appendChild(row);
    return wrap;
}
async function $9c3d0822d3033a97$var$copyText(text) {
    try {
        await navigator.clipboard.writeText(text);
        return;
    } catch  {
    // fallback
    }
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.style.position = 'fixed';
    ta.style.left = '-9999px';
    document.body.appendChild(ta);
    ta.select();
    try {
        document.execCommand('copy');
    } finally{
        document.body.removeChild(ta);
    }
}
function $9c3d0822d3033a97$var$renderOfficialModelOptions() {
    $9c3d0822d3033a97$var$aiOfficialModelOptionsEl.innerHTML = '';
    const normalizedOptions = $9c3d0822d3033a97$var$aiOfficialModelOptions.length > 0 ? $9c3d0822d3033a97$var$aiOfficialModelOptions : Array.from(new Set($9c3d0822d3033a97$var$aiOfficialModels.map((x)=>String(x ?? '').trim()).filter(Boolean))).map((modelId)=>({
            gatewayId: String($9c3d0822d3033a97$var$aiOfficial.gatewayId ?? '').trim(),
            gatewayName: '',
            modelId: modelId,
            isSystemDefault: false
        }));
    if (normalizedOptions.length === 0) {
        const empty = document.createElement('div');
        empty.className = 'sub';
        empty.textContent = "\u5F53\u524D\u6CA1\u6709\u53EF\u9009\u6A21\u578B\uFF0C\u8BF7\u5148\u5728\u540E\u53F0\u542F\u7528\u5E76\u9A8C\u8BC1\u6A21\u578B\u3002";
        $9c3d0822d3033a97$var$aiOfficialModelOptionsEl.appendChild(empty);
        return;
    }
    const currentGatewayId = String($9c3d0822d3033a97$var$aiOfficial.gatewayId ?? '').trim();
    const currentModel = String($9c3d0822d3033a97$var$aiOfficial.model ?? '').trim();
    const modelIdCount = new Map();
    for (const item of normalizedOptions)modelIdCount.set(item.modelId, (modelIdCount.get(item.modelId) ?? 0) + 1);
    const ordered = [
        ...normalizedOptions
    ].sort((a, b)=>{
        if (a.isSystemDefault && !b.isSystemDefault) return -1;
        if (!a.isSystemDefault && b.isSystemDefault) return 1;
        if (a.modelId < b.modelId) return -1;
        if (a.modelId > b.modelId) return 1;
        if (a.gatewayName < b.gatewayName) return -1;
        if (a.gatewayName > b.gatewayName) return 1;
        return 0;
    });
    for (const item of ordered){
        const modelId = item.modelId;
        const gatewayId = String(item.gatewayId ?? '').trim();
        const gatewayName = String(item.gatewayName ?? '').trim();
        const btn = document.createElement('button');
        btn.type = 'button';
        const sameGateway = !gatewayId || !currentGatewayId || gatewayId === currentGatewayId;
        const isCurrent = sameGateway && currentModel === modelId;
        btn.className = `ai-model-option${isCurrent ? ' is-selected' : ''}`;
        btn.disabled = $9c3d0822d3033a97$var$uiBusy;
        btn.onclick = async ()=>{
            if ($9c3d0822d3033a97$var$uiBusy) return;
            const sameModel = isCurrent;
            const usingOfficial = $9c3d0822d3033a97$var$aiDefault.source === 'official';
            const overrideModel = String($9c3d0822d3033a97$var$aiOfficial.overrideModel ?? '').trim();
            const hasStaleOverride = !!overrideModel && !!currentModel && overrideModel !== currentModel;
            if (sameModel && usingOfficial && !hasStaleOverride) {
                $9c3d0822d3033a97$var$statusEl.textContent = `\u{5F53}\u{524D}\u{5DF2}\u{5728}\u{4F7F}\u{7528} ${modelId}\u{3002}`;
                return;
            }
            await $9c3d0822d3033a97$var$applyOfficialModel(modelId, {
                switchToOfficialDefault: true,
                gatewayId: gatewayId || null
            });
        };
        const idEl = document.createElement('span');
        idEl.className = 'ai-model-id';
        const repeated = (modelIdCount.get(modelId) ?? 0) > 1;
        const modelLabel = repeated && gatewayName ? `${modelId} \xb7 ${gatewayName}` : modelId;
        idEl.textContent = isCurrent ? `${modelLabel}\u{FF08}\u{5728}\u{7528}\u{FF09}` : modelLabel;
        btn.appendChild(idEl);
        if (item.isSystemDefault) {
            const badge = document.createElement('span');
            badge.className = 'ai-model-default';
            badge.textContent = "\u7CFB\u7EDF\u9ED8\u8BA4";
            btn.appendChild(badge);
        }
        $9c3d0822d3033a97$var$aiOfficialModelOptionsEl.appendChild(btn);
    }
}
function $9c3d0822d3033a97$var$renderAiSettings() {
    const points = Number.isFinite($9c3d0822d3033a97$var$aiOfficial.points) ? Math.max(0, Math.trunc($9c3d0822d3033a97$var$aiOfficial.points)) : 0;
    $9c3d0822d3033a97$var$aiOfficialHintEl.textContent = `\u{5927}\u{6A21}\u{578B}\u{FF08}\u{8350}\u{724C}\u{70B9}\u{FF1A}${$9c3d0822d3033a97$var$formatPoints(points)}\u{FF09}`;
    $9c3d0822d3033a97$var$renderOfficialModelOptions();
}
async function $9c3d0822d3033a97$var$loadAiSettings() {
    const data = await (0, $7xapJ.fetchAiSettings)();
    $9c3d0822d3033a97$var$aiOfficialModelOptions = Array.isArray(data.officialModelOptions) ? data.officialModelOptions.map((it)=>({
            gatewayId: String(it?.gatewayId ?? '').trim(),
            gatewayName: String(it?.gatewayName ?? '').trim(),
            modelId: String(it?.modelId ?? '').trim(),
            isSystemDefault: !!it?.isSystemDefault
        })).filter((it)=>it.gatewayId && it.modelId) : [];
    $9c3d0822d3033a97$var$aiOfficialModels = $9c3d0822d3033a97$var$aiOfficialModelOptions.length > 0 ? Array.from(new Set($9c3d0822d3033a97$var$aiOfficialModelOptions.map((it)=>it.modelId))) : Array.isArray(data.models) ? data.models : [];
    $9c3d0822d3033a97$var$aiDefault = data.default ?? {
        source: 'official',
        profileId: null
    };
    const official = data.official ?? $9c3d0822d3033a97$var$aiOfficial;
    const rawPoints = typeof official.points === 'number' ? official.points : 0;
    const points = Number.isFinite(rawPoints) ? Math.trunc(rawPoints) : 0;
    $9c3d0822d3033a97$var$aiOfficial = {
        ...$9c3d0822d3033a97$var$aiOfficial,
        ...official,
        points: points
    };
    $9c3d0822d3033a97$var$aiSettingsLoaded = true;
    $9c3d0822d3033a97$var$renderAiSettings();
}
function $9c3d0822d3033a97$var$renderPaySection() {
    const hasPackages = $9c3d0822d3033a97$var$payPackages.length > 0;
    const availableChannels = new Set($9c3d0822d3033a97$var$payChannels);
    if (!$9c3d0822d3033a97$var$paySelectedPackageId || !$9c3d0822d3033a97$var$payPackages.some((pkg)=>pkg.id === $9c3d0822d3033a97$var$paySelectedPackageId)) $9c3d0822d3033a97$var$paySelectedPackageId = $9c3d0822d3033a97$var$payPackages[0]?.id ?? '';
    if (!availableChannels.has($9c3d0822d3033a97$var$paySelectedChannel)) {
        if (availableChannels.has('alipay')) $9c3d0822d3033a97$var$paySelectedChannel = 'alipay';
        else if (availableChannels.has('wechat_native')) $9c3d0822d3033a97$var$paySelectedChannel = 'wechat_native';
        else $9c3d0822d3033a97$var$paySelectedChannel = 'alipay';
    }
    if ($9c3d0822d3033a97$var$payConfigError) $9c3d0822d3033a97$var$setPayModeTip($9c3d0822d3033a97$var$payConfigError);
    else if ($9c3d0822d3033a97$var$payMode !== 'xorpay') $9c3d0822d3033a97$var$setPayModeTip("\u5F53\u524D\u4E3A\u624B\u52A8\u5145\u503C\uFF0C\u8BF7\u8054\u7CFB\u7BA1\u7406\u5458\u3002");
    else if (!hasPackages) $9c3d0822d3033a97$var$setPayModeTip("\u5DF2\u5F00\u542F XorPay\uFF0C\u4F46\u6682\u672A\u914D\u7F6E\u53EF\u552E\u5957\u9910\u3002");
    else if ($9c3d0822d3033a97$var$payChannels.length === 0) $9c3d0822d3033a97$var$setPayModeTip("\u5DF2\u5F00\u542F XorPay\uFF0C\u4F46\u672A\u914D\u7F6E\u53EF\u7528\u652F\u4ED8\u6E20\u9053\u3002");
    else $9c3d0822d3033a97$var$setPayModeTip('');
    const busy = $9c3d0822d3033a97$var$uiBusy || !$9c3d0822d3033a97$var$currentUser;
    const blocked = !!$9c3d0822d3033a97$var$payConfigError || $9c3d0822d3033a97$var$payMode !== 'xorpay' || !hasPackages;
    $9c3d0822d3033a97$var$payPackageOptionsEl.innerHTML = '';
    if (!hasPackages) {
        const empty = document.createElement('div');
        empty.className = 'sub';
        empty.textContent = "\u6682\u65E0\u53EF\u9009\u5957\u9910";
        $9c3d0822d3033a97$var$payPackageOptionsEl.appendChild(empty);
    } else for (const pkg of $9c3d0822d3033a97$var$payPackages){
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = `pay-option${pkg.id === $9c3d0822d3033a97$var$paySelectedPackageId ? ' is-selected' : ''}`;
        btn.setAttribute('data-pay-option', '1');
        btn.disabled = busy || blocked;
        btn.onclick = ()=>{
            if ($9c3d0822d3033a97$var$uiBusy || blocked) return;
            if ($9c3d0822d3033a97$var$paySelectedPackageId === pkg.id) return;
            $9c3d0822d3033a97$var$paySelectedPackageId = pkg.id;
            $9c3d0822d3033a97$var$renderPaySection();
        };
        const title = document.createElement('div');
        title.className = 'pay-option-title';
        title.textContent = pkg.title;
        btn.appendChild(title);
        const price = Number.isFinite(pkg.priceCents) ? (Math.trunc(pkg.priceCents) / 100).toFixed(2) : '0.00';
        const points = $9c3d0822d3033a97$var$formatPoints(pkg.points ?? 0);
        const meta = document.createElement('div');
        meta.className = 'pay-option-meta';
        meta.textContent = `${price} \u{5143} \xb7 ${points} \u{70B9}`;
        btn.appendChild(meta);
        $9c3d0822d3033a97$var$payPackageOptionsEl.appendChild(btn);
    }
    $9c3d0822d3033a97$var$payChannelOptionsEl.innerHTML = '';
    if ($9c3d0822d3033a97$var$payChannels.length === 0) {
        const empty = document.createElement('div');
        empty.className = 'sub';
        empty.textContent = "\u6682\u65E0\u53EF\u9009\u652F\u4ED8\u65B9\u5F0F";
        $9c3d0822d3033a97$var$payChannelOptionsEl.appendChild(empty);
    } else for (const ch of $9c3d0822d3033a97$var$payChannels){
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = `pay-option${ch === $9c3d0822d3033a97$var$paySelectedChannel ? ' is-selected' : ''}`;
        btn.setAttribute('data-pay-option', '1');
        btn.disabled = busy || blocked;
        btn.onclick = ()=>{
            if ($9c3d0822d3033a97$var$uiBusy || blocked) return;
            if ($9c3d0822d3033a97$var$paySelectedChannel === ch) return;
            $9c3d0822d3033a97$var$paySelectedChannel = ch;
            $9c3d0822d3033a97$var$renderPaySection();
        };
        const title = document.createElement('div');
        title.className = 'pay-option-title';
        title.textContent = $9c3d0822d3033a97$var$channelLabel(ch);
        btn.appendChild(title);
        const meta = document.createElement('div');
        meta.className = 'pay-option-meta';
        meta.textContent = ch === 'alipay' ? "\u652F\u4ED8\u5B9D\u652F\u4ED8" : "\u5FAE\u4FE1\u652F\u4ED8";
        btn.appendChild(meta);
        $9c3d0822d3033a97$var$payChannelOptionsEl.appendChild(btn);
    }
    if (!$9c3d0822d3033a97$var$payCurrentOrder) {
        $9c3d0822d3033a97$var$payOrderStatusEl.textContent = $9c3d0822d3033a97$var$payMode === 'xorpay' && !$9c3d0822d3033a97$var$payConfigError ? "\u5C1A\u672A\u521B\u5EFA\u8BA2\u5355" : "\u5F53\u524D\u65E0\u8BA2\u5355";
        $9c3d0822d3033a97$var$renderPayQrPanel(null);
    } else {
        const amount = Number.isFinite($9c3d0822d3033a97$var$payCurrentOrder.amountCents) ? (Math.trunc($9c3d0822d3033a97$var$payCurrentOrder.amountCents) / 100).toFixed(2) : '0.00';
        const points = $9c3d0822d3033a97$var$formatPoints($9c3d0822d3033a97$var$payCurrentOrder.points ?? 0);
        $9c3d0822d3033a97$var$payOrderStatusEl.textContent = `\u{8BA2}\u{5355} ${$9c3d0822d3033a97$var$payCurrentOrder.id} \xb7 ${$9c3d0822d3033a97$var$channelLabel($9c3d0822d3033a97$var$payCurrentOrder.channel)} \xb7 ${amount} \u{5143} / ${points} \u{70B9} \xb7 ${$9c3d0822d3033a97$var$payStatusLabel($9c3d0822d3033a97$var$payCurrentOrder.status)}`;
        $9c3d0822d3033a97$var$renderPayQrPanel($9c3d0822d3033a97$var$payCurrentOrder);
    }
    $9c3d0822d3033a97$var$payCreateOrderBtn.disabled = busy || blocked || !$9c3d0822d3033a97$var$paySelectedPackageId || !availableChannels.has($9c3d0822d3033a97$var$paySelectedChannel);
    $9c3d0822d3033a97$var$scheduleMeCanvasScale();
}
async function $9c3d0822d3033a97$var$refreshPayOrder(orderId) {
    const out = await (0, $7xapJ.fetchPayOrder)(orderId);
    $9c3d0822d3033a97$var$payCurrentOrder = out.order ?? null;
    $9c3d0822d3033a97$var$renderPaySection();
}
function $9c3d0822d3033a97$var$startPayPolling(orderId) {
    $9c3d0822d3033a97$var$stopPayPolling();
    let attempts = 0;
    $9c3d0822d3033a97$var$payPollingTimer = window.setInterval(async ()=>{
        attempts += 1;
        try {
            await $9c3d0822d3033a97$var$refreshPayOrder(orderId);
            if (!$9c3d0822d3033a97$var$payCurrentOrder || $9c3d0822d3033a97$var$payCurrentOrder.id !== orderId) {
                $9c3d0822d3033a97$var$stopPayPolling();
                return;
            }
            if ($9c3d0822d3033a97$var$isFinalPayStatus($9c3d0822d3033a97$var$payCurrentOrder.status)) {
                $9c3d0822d3033a97$var$stopPayPolling();
                if ($9c3d0822d3033a97$var$payCurrentOrder.status === 'credited') try {
                    await $9c3d0822d3033a97$var$loadAiBilling();
                } catch  {
                // ignore: user can still refresh billing manually
                }
            }
        } catch  {
            if (attempts >= 40) $9c3d0822d3033a97$var$stopPayPolling();
        }
    }, 3000);
}
async function $9c3d0822d3033a97$var$loadPayConfig() {
    const out = await (0, $7xapJ.fetchPayConfig)();
    $9c3d0822d3033a97$var$payConfigError = null;
    $9c3d0822d3033a97$var$payMode = out.paymentMode === 'xorpay' ? 'xorpay' : 'manual';
    $9c3d0822d3033a97$var$payPackages = Array.isArray(out.packages) ? out.packages.map((x)=>({
            id: String(x.id ?? '').trim(),
            title: String(x.title ?? '').trim(),
            priceCents: Math.max(0, Math.trunc(Number(x.priceCents) || 0)),
            priceCny: Number(x.priceCny ?? 0),
            points: Math.max(0, Math.trunc(Number(x.points) || 0)),
            enabled: !!x.enabled,
            sort: Math.trunc(Number(x.sort) || 0)
        })).filter((x)=>x.id && x.title && x.priceCents > 0 && x.points > 0) : [];
    $9c3d0822d3033a97$var$payChannels = Array.isArray(out.channels) ? out.channels.filter((x)=>x === 'alipay' || x === 'wechat_native') : [
        'alipay',
        'wechat_native'
    ];
    if ($9c3d0822d3033a97$var$payChannels.length === 0) $9c3d0822d3033a97$var$payChannels = [
        'alipay',
        'wechat_native'
    ];
    if ($9c3d0822d3033a97$var$payCurrentOrder && $9c3d0822d3033a97$var$isFinalPayStatus($9c3d0822d3033a97$var$payCurrentOrder.status)) $9c3d0822d3033a97$var$stopPayPolling();
    $9c3d0822d3033a97$var$payConfigLoaded = true;
    $9c3d0822d3033a97$var$renderPaySection();
    if ($9c3d0822d3033a97$var$aiSettingsLoaded) $9c3d0822d3033a97$var$renderAiSettings();
}
function $9c3d0822d3033a97$var$renderAiBilling() {
    $9c3d0822d3033a97$var$aiBillingPointsEl.textContent = $9c3d0822d3033a97$var$formatPoints($9c3d0822d3033a97$var$aiOfficial.points ?? 0);
    $9c3d0822d3033a97$var$aiBillingListEl.innerHTML = '';
    if ($9c3d0822d3033a97$var$aiBillingItems.length === 0) {
        const empty = document.createElement('div');
        empty.className = 'ai-item';
        empty.textContent = "\u6682\u65E0\u8BB0\u5F55";
        $9c3d0822d3033a97$var$aiBillingListEl.appendChild(empty);
        $9c3d0822d3033a97$var$scheduleMeCanvasScale();
        return;
    }
    const grouped = [
        {
            kind: 'recharge',
            title: "\u5145\u503C\u5165\u8D26",
            items: $9c3d0822d3033a97$var$aiBillingItems.filter((it)=>it.kind === 'recharge')
        },
        {
            kind: 'ai_charge',
            title: '',
            items: $9c3d0822d3033a97$var$aiBillingItems.filter((it)=>it.kind === 'ai_charge')
        },
        {
            kind: 'admin_adjust',
            title: "\u540E\u53F0\u8C03\u6574",
            items: $9c3d0822d3033a97$var$aiBillingItems.filter((it)=>it.kind === 'admin_adjust')
        }
    ].filter((g)=>g.items.length > 0);
    for (const group of grouped){
        const wrap = document.createElement('div');
        wrap.className = 'ai-group';
        if (group.title) {
            const groupTitle = document.createElement('div');
            groupTitle.className = 'ai-group-title';
            groupTitle.textContent = group.title;
            wrap.appendChild(groupTitle);
        }
        for (const it of group.items){
            const item = document.createElement('div');
            item.className = 'ai-item';
            const head = document.createElement('div');
            head.className = 'ai-item-head';
            const title = document.createElement('div');
            title.className = 'ai-alias';
            title.textContent = group.title ? `${$9c3d0822d3033a97$var$formatTime(it.createdAt)} \xb7 ${group.title}` : $9c3d0822d3033a97$var$formatTime(it.createdAt);
            head.appendChild(title);
            item.appendChild(head);
            const delta = Math.trunc(it.changePoints ?? 0);
            const deltaAbs = Math.abs(delta);
            const sign = delta >= 0 ? '+' : '-';
            const detail = document.createElement('div');
            detail.className = 'ai-meta';
            if (group.kind === 'ai_charge') detail.textContent = `\u{6A21}\u{578B} ${it.modelId ?? '-'} \xb7 input ${it.usageInputTokens ?? 0} \xb7 output ${it.usageOutputTokens ?? 0} \xb7 \u{6263} ${deltaAbs} \u{70B9}${it.fallbackCharged ? "\uFF08\u4FDD\u5E95\uFF09" : ''}`;
            else if (group.kind === 'recharge') detail.textContent = `\u{5145}\u{503C} ${sign}${deltaAbs} \u{70B9} \xb7 \u{6E20}\u{9053}\u{5907}\u{6CE8} ${it.note ?? '-'}`;
            else detail.textContent = `\u{53D8}\u{66F4} ${sign}${deltaAbs} \u{70B9}`;
            item.appendChild(detail);
            if (group.kind === 'ai_charge') {
                const req = document.createElement('div');
                req.className = 'ai-meta';
                req.textContent = `\u{8BF7}\u{6C42}ID ${it.requestId ?? '-'} \xb7 \u{573A}\u{666F} ${it.scene ?? '-'} \xb7 \u{4EF7}\u{683C}\u{7248}\u{672C} ${it.priceVersion ?? '-'}`;
                item.appendChild(req);
            } else if (group.kind === 'recharge') {
                const req = document.createElement('div');
                req.className = 'ai-meta';
                req.textContent = `\u{8BA2}\u{5355}\u{53F7} ${it.requestId ?? '-'} \xb7 \u{573A}\u{666F} ${it.scene ?? '-'}`;
                item.appendChild(req);
            }
            const bal = document.createElement('div');
            bal.className = 'ai-meta';
            bal.textContent = `\u{4F59}\u{989D} ${$9c3d0822d3033a97$var$formatPoints(it.balanceBefore ?? 0)} \u{2192} ${$9c3d0822d3033a97$var$formatPoints(it.balanceAfter ?? 0)}`;
            item.appendChild(bal);
            if (it.note && group.kind !== 'recharge') {
                const note = document.createElement('div');
                note.className = 'ai-meta';
                note.textContent = `\u{5907}\u{6CE8}\u{FF1A}${it.note}`;
                item.appendChild(note);
            }
            wrap.appendChild(item);
        }
        $9c3d0822d3033a97$var$aiBillingListEl.appendChild(wrap);
    }
    $9c3d0822d3033a97$var$scheduleMeCanvasScale();
}
async function $9c3d0822d3033a97$var$loadAiBilling() {
    const data = await (0, $7xapJ.fetchAiBilling)({
        limit: 50,
        offset: 0
    });
    $9c3d0822d3033a97$var$aiOfficial.points = Number.isFinite(data.officialPoints) ? Math.trunc(data.officialPoints) : $9c3d0822d3033a97$var$aiOfficial.points;
    $9c3d0822d3033a97$var$aiBillingItems = Array.isArray(data.items) ? data.items : [];
    $9c3d0822d3033a97$var$aiBillingLoaded = true;
    $9c3d0822d3033a97$var$renderAiSettings();
    $9c3d0822d3033a97$var$renderAiBilling();
}
async function $9c3d0822d3033a97$var$loadAiRules() {
    const data = await (0, $7xapJ.fetchAiRules)();
    $9c3d0822d3033a97$var$aiRules = {
        source: data.source,
        global: data.global ?? '',
        user: data.user ?? null
    };
    $9c3d0822d3033a97$var$aiRulesLoaded = true;
    $9c3d0822d3033a97$var$aiRulesSourceEl.textContent = data.source === 'user' ? "\u81EA\u5B9A\u4E49\uFF08\u4F18\u5148\uFF09" : "\u5168\u5C40";
    $9c3d0822d3033a97$var$aiRulesTextarea.value = $9c3d0822d3033a97$var$aiRules.user ?? $9c3d0822d3033a97$var$aiRules.global;
    $9c3d0822d3033a97$var$aiRulesSavedText = $9c3d0822d3033a97$var$aiRulesTextarea.value;
    $9c3d0822d3033a97$var$updateAiRulesDraftMeta();
}
async function $9c3d0822d3033a97$var$ensurePayTabLoaded() {
    if ($9c3d0822d3033a97$var$payConfigLoaded && $9c3d0822d3033a97$var$aiBillingLoaded) return;
    if ($9c3d0822d3033a97$var$payTabLoadPromise) {
        await $9c3d0822d3033a97$var$payTabLoadPromise;
        return;
    }
    $9c3d0822d3033a97$var$payTabLoadPromise = (async ()=>{
        const loadingText = "\u6B63\u5728\u52A0\u8F7D\u5145\u503C\u4FE1\u606F\u2026";
        const shouldToggleBusy = !$9c3d0822d3033a97$var$uiBusy;
        if (shouldToggleBusy) {
            $9c3d0822d3033a97$var$setUiEnabled(false);
            $9c3d0822d3033a97$var$statusEl.textContent = loadingText;
        }
        try {
            if (!$9c3d0822d3033a97$var$payConfigLoaded) try {
                await $9c3d0822d3033a97$var$loadPayConfig();
            } catch (err) {
                $9c3d0822d3033a97$var$payConfigError = `\u{52A0}\u{8F7D}\u{652F}\u{4ED8}\u{914D}\u{7F6E}\u{5931}\u{8D25}\u{FF1A}${String(err?.message ?? err)}`;
                $9c3d0822d3033a97$var$renderPaySection();
            }
            if (!$9c3d0822d3033a97$var$aiBillingLoaded) try {
                await $9c3d0822d3033a97$var$loadAiBilling();
            } catch  {
                $9c3d0822d3033a97$var$renderAiBilling();
            }
            $9c3d0822d3033a97$var$setLoginStatusIfIdle(loadingText);
        } finally{
            if (shouldToggleBusy) $9c3d0822d3033a97$var$setUiEnabled(true);
        }
    })();
    try {
        await $9c3d0822d3033a97$var$payTabLoadPromise;
    } finally{
        $9c3d0822d3033a97$var$payTabLoadPromise = null;
    }
}
function $9c3d0822d3033a97$var$openPracticeShareModal(url) {
    $9c3d0822d3033a97$var$openModal("\u5206\u4EAB\u7EC3\u4E60\u9898", "\u767B\u5F55\u540E\u5373\u53EF\u76F4\u63A5\u8FDB\u5165\uFF1B\u82E5\u5DF2\u6709\u672A\u5B8C\u6210\u7EC3\u4E60\u5C40\uFF0C\u5219\u4F18\u5148\u7EE7\u7EED\u3002", $9c3d0822d3033a97$var$buildCopyTextField(url, "\u5206\u4EAB\u94FE\u63A5"));
}
function $9c3d0822d3033a97$var$openPaipuShareModal(url) {
    $9c3d0822d3033a97$var$openModal("\u5206\u4EAB\u724C\u8C31", "\u5206\u4EAB\u94FE\u63A5\u957F\u671F\u6709\u6548\uFF1B\u767B\u5F55\u540E\u5373\u53EF\u67E5\u770B\u4E25\u683C\u672C\u4EBA\u89C6\u89D2\u724C\u8C31\u3002", $9c3d0822d3033a97$var$buildCopyTextField(url, "\u5206\u4EAB\u94FE\u63A5"));
}
function $9c3d0822d3033a97$var$applyReplayFiltersToButtons() {
    const roomButtons = [
        {
            btn: $9c3d0822d3033a97$var$replayFilterRoomAllBtn,
            on: $9c3d0822d3033a97$var$replayRoomFilter === 'all'
        },
        {
            btn: $9c3d0822d3033a97$var$replayFilterRoomNewbieBtn,
            on: $9c3d0822d3033a97$var$replayRoomFilter === 'newbie'
        },
        {
            btn: $9c3d0822d3033a97$var$replayFilterRoomFriendBtn,
            on: $9c3d0822d3033a97$var$replayRoomFilter === 'friend'
        }
    ];
    for (const item of roomButtons)item.btn.classList.toggle('filter-on', item.on);
    const variantButtons = [
        {
            btn: $9c3d0822d3033a97$var$replayFilterVariantAllBtn,
            on: $9c3d0822d3033a97$var$replayVariantFilter === 'all'
        },
        {
            btn: $9c3d0822d3033a97$var$replayFilterVariantXuezhanBtn,
            on: $9c3d0822d3033a97$var$replayVariantFilter === 'xuezhan'
        },
        {
            btn: $9c3d0822d3033a97$var$replayFilterVariantGuobiaoBtn,
            on: $9c3d0822d3033a97$var$replayVariantFilter === 'guobiao'
        }
    ];
    for (const item of variantButtons)item.btn.classList.toggle('filter-on', item.on);
    const shareButtons = [
        {
            btn: $9c3d0822d3033a97$var$replayFilterShareAllBtn,
            on: $9c3d0822d3033a97$var$replayShareFilter === 'all'
        },
        {
            btn: $9c3d0822d3033a97$var$replayFilterShareSharedBtn,
            on: $9c3d0822d3033a97$var$replayShareFilter === 'shared'
        },
        {
            btn: $9c3d0822d3033a97$var$replayFilterShareUnsharedBtn,
            on: $9c3d0822d3033a97$var$replayShareFilter === 'unshared'
        }
    ];
    for (const item of shareButtons)item.btn.classList.toggle('filter-on', item.on);
}
function $9c3d0822d3033a97$var$replayShareLabel(item) {
    return item.share.shared ? "\u5DF2\u5206\u4EAB" : "\u672A\u5206\u4EAB";
}
function $9c3d0822d3033a97$var$openPaipuDetail(gameId) {
    const basePath = (0, $iRbTC.getBasePath)();
    window.location.href = `${basePath}hand/?mode=paipu&gameId=${encodeURIComponent(gameId)}`;
}
function $9c3d0822d3033a97$var$replaceReplayShareState(gameId, shareId, createdAt, sharePath) {
    $9c3d0822d3033a97$var$replayRecords = $9c3d0822d3033a97$var$replayRecords.map((item)=>{
        if (item.gameId !== gameId) return item;
        return {
            ...item,
            share: {
                shared: true,
                shareId: shareId,
                shareCreatedAt: createdAt,
                sharePath: sharePath
            }
        };
    }).filter((item)=>{
        if ($9c3d0822d3033a97$var$replayShareFilter === 'shared') return item.share.shared;
        if ($9c3d0822d3033a97$var$replayShareFilter === 'unshared') return !item.share.shared;
        return true;
    });
}
function $9c3d0822d3033a97$var$removeReplayRecord(gameId) {
    $9c3d0822d3033a97$var$replayRecords = $9c3d0822d3033a97$var$replayRecords.filter((item)=>item.gameId !== gameId);
}
function $9c3d0822d3033a97$var$renderReplayRecords() {
    $9c3d0822d3033a97$var$applyReplayFiltersToButtons();
    if (!$9c3d0822d3033a97$var$replayRecordsLoaded) {
        $9c3d0822d3033a97$var$replayListEl.innerHTML = '<div class="practice-empty">\u9996\u6B21\u8FDB\u5165\u65F6\u52A0\u8F7D\u724C\u8C31\u3002</div>';
        $9c3d0822d3033a97$var$scheduleMeCanvasScale();
        return;
    }
    $9c3d0822d3033a97$var$replayListEl.innerHTML = '';
    const group = document.createElement('section');
    group.className = 'practice-group';
    const head = document.createElement('div');
    head.className = 'practice-group-head';
    group.appendChild(head);
    const titleWrap = document.createElement('div');
    titleWrap.className = 'practice-group-title-wrap';
    head.appendChild(titleWrap);
    const title = document.createElement('div');
    title.className = 'practice-group-title';
    title.textContent = "\u6211\u7684\u724C\u8C31\uFF08\u6BCF\u5C40\u7ED3\u675F\u540E\u81EA\u52A8\u6C89\u6DC0\uFF1B\u70B9\u51FB\u53EF\u8FDB\u5165\u4E25\u683C\u672C\u4EBA\u89C6\u89D2\u56DE\u653E\u3002\uFF09";
    titleWrap.appendChild(title);
    const count = document.createElement('div');
    count.className = 'practice-group-count';
    count.textContent = String($9c3d0822d3033a97$var$replayRecords.length);
    head.appendChild(count);
    if ($9c3d0822d3033a97$var$replayRecords.length <= 0) {
        const empty = document.createElement('div');
        empty.className = 'practice-empty';
        empty.textContent = "\u8FD8\u6CA1\u6709\u53EF\u67E5\u770B\u7684\u724C\u8C31\u3002";
        group.appendChild(empty);
        $9c3d0822d3033a97$var$replayListEl.appendChild(group);
        $9c3d0822d3033a97$var$scheduleMeCanvasScale();
        return;
    }
    for (const item of $9c3d0822d3033a97$var$replayRecords){
        const card = document.createElement('div');
        card.className = 'practice-item';
        const cardHead = document.createElement('div');
        cardHead.className = 'practice-head';
        card.appendChild(cardHead);
        const cardTitle = document.createElement('div');
        cardTitle.className = 'practice-title';
        cardTitle.textContent = `${$9c3d0822d3033a97$var$paipuVariantLabel(item.rules?.variant)} \xb7 ${$9c3d0822d3033a97$var$paipuRoomLabel(item.roomType)} \xb7 ${$9c3d0822d3033a97$var$formatTime(item.finishedAt)}`;
        cardHead.appendChild(cardTitle);
        const headSide = document.createElement('div');
        headSide.className = 'replay-card-head-side';
        cardHead.appendChild(headSide);
        const tags = document.createElement('div');
        tags.className = 'practice-tags replay-card-head-tags';
        headSide.appendChild(tags);
        const roomTag = document.createElement('div');
        roomTag.className = 'practice-tag';
        roomTag.textContent = $9c3d0822d3033a97$var$paipuRoomLabel(item.roomType);
        tags.appendChild(roomTag);
        const variantTag = document.createElement('div');
        variantTag.className = 'practice-tag';
        variantTag.textContent = $9c3d0822d3033a97$var$paipuVariantLabel(item.rules?.variant);
        tags.appendChild(variantTag);
        const shareTag = document.createElement('div');
        shareTag.className = 'practice-tag';
        shareTag.textContent = $9c3d0822d3033a97$var$replayShareLabel(item);
        tags.appendChild(shareTag);
        const status = document.createElement('div');
        status.className = 'practice-status';
        status.textContent = item.myResult.rank ? `\u{7B2C} ${item.myResult.rank} \u{540D}` : "\u5DF2\u7ED3\u675F";
        headSide.appendChild(status);
        const summary = document.createElement('div');
        summary.className = 'replay-card-summary';
        card.appendChild(summary);
        const meta = document.createElement('div');
        meta.className = 'practice-meta replay-card-summary-main';
        meta.textContent = [
            `\u{623F}\u{95F4}\u{FF1A}${$9c3d0822d3033a97$var$paipuRoomLabel(item.roomType)}`,
            `\u{5EA7}\u{4F4D}\u{FF1A}${item.mySeat + 1}\u{53F7}\u{4F4D}`,
            $9c3d0822d3033a97$var$paipuResultLabel(item)
        ].join(" \xb7 ");
        summary.appendChild(meta);
        const note = document.createElement('div');
        note.className = 'practice-note replay-card-summary-side replay-players-line';
        const playersLabel = document.createElement('span');
        playersLabel.className = 'replay-players-label';
        playersLabel.textContent = "\u53C2\u4E0E\u73A9\u5BB6\uFF1A";
        note.appendChild(playersLabel);
        const playersList = document.createElement('div');
        playersList.className = 'replay-players-list';
        for (const player of item.players){
            const name = player.nickname || `\u{73A9}\u{5BB6}${player.seat + 1}`;
            const chip = document.createElement('span');
            chip.className = 'replay-player-name';
            chip.textContent = name;
            chip.title = name;
            playersList.appendChild(chip);
        }
        note.appendChild(playersList);
        summary.appendChild(note);
        const actions = document.createElement('div');
        actions.className = 'practice-actions';
        card.appendChild(actions);
        const openBtn = document.createElement('button');
        openBtn.type = 'button';
        openBtn.className = 'btn-mini primary';
        openBtn.textContent = "\u67E5\u770B\u724C\u8C31";
        openBtn.disabled = $9c3d0822d3033a97$var$uiBusy;
        openBtn.onclick = ()=>{
            if ($9c3d0822d3033a97$var$uiBusy) return;
            $9c3d0822d3033a97$var$openPaipuDetail(item.gameId);
        };
        actions.appendChild(openBtn);
        const shareBtn = document.createElement('button');
        shareBtn.type = 'button';
        shareBtn.className = 'btn-mini ghost';
        shareBtn.textContent = item.share.shared ? "\u590D\u5236\u5206\u4EAB" : "\u5206\u4EAB";
        shareBtn.disabled = $9c3d0822d3033a97$var$uiBusy;
        shareBtn.onclick = async ()=>{
            if ($9c3d0822d3033a97$var$uiBusy) return;
            $9c3d0822d3033a97$var$setUiEnabled(false);
            $9c3d0822d3033a97$var$statusEl.textContent = "\u6B63\u5728\u51C6\u5907\u724C\u8C31\u5206\u4EAB\u94FE\u63A5\u2026";
            try {
                const out = await (0, $bmHMf.createPaipuShare)(item.gameId);
                $9c3d0822d3033a97$var$replaceReplayShareState(item.gameId, out.shareId, out.createdAt, out.sharePath);
                $9c3d0822d3033a97$var$renderReplayRecords();
                const shareUrl = $9c3d0822d3033a97$var$buildAppUrl(out.sharePath);
                await $9c3d0822d3033a97$var$copyText(shareUrl);
                $9c3d0822d3033a97$var$openPaipuShareModal(shareUrl);
                $9c3d0822d3033a97$var$statusEl.textContent = out.created ? "\u724C\u8C31\u5206\u4EAB\u94FE\u63A5\u5DF2\u521B\u5EFA\u5E76\u590D\u5236\u3002" : "\u724C\u8C31\u5206\u4EAB\u94FE\u63A5\u5DF2\u590D\u5236\u3002";
            } catch (err) {
                $9c3d0822d3033a97$var$statusEl.textContent = `\u{5206}\u{4EAB}\u{5931}\u{8D25}\u{FF1A}${String(err?.message ?? err)}`;
            } finally{
                $9c3d0822d3033a97$var$setUiEnabled(true);
            }
        };
        actions.appendChild(shareBtn);
        const deleteBtn = document.createElement('button');
        deleteBtn.type = 'button';
        deleteBtn.className = 'btn-mini danger';
        deleteBtn.textContent = "\u5220\u9664";
        deleteBtn.disabled = $9c3d0822d3033a97$var$uiBusy;
        deleteBtn.onclick = async ()=>{
            if ($9c3d0822d3033a97$var$uiBusy) return;
            if (!confirm("\u786E\u5B9A\u5220\u9664\u8FD9\u5C40\u724C\u8C31\u5417\uFF1F\u5220\u9664\u540E\u4EC5\u5BF9\u4F60\u81EA\u5DF1\u9690\u85CF\uFF0C\u4E14\u4F60\u751F\u6210\u8FC7\u7684\u5206\u4EAB\u94FE\u63A5\u4F1A\u5931\u6548\u3002")) return;
            $9c3d0822d3033a97$var$setUiEnabled(false);
            $9c3d0822d3033a97$var$statusEl.textContent = "\u6B63\u5728\u5220\u9664\u724C\u8C31\u2026";
            try {
                await (0, $bmHMf.deletePaipu)(item.gameId);
                $9c3d0822d3033a97$var$removeReplayRecord(item.gameId);
                $9c3d0822d3033a97$var$renderReplayRecords();
                $9c3d0822d3033a97$var$statusEl.textContent = "\u724C\u8C31\u5DF2\u5220\u9664\u3002";
            } catch (err) {
                $9c3d0822d3033a97$var$statusEl.textContent = `\u{5220}\u{9664}\u{5931}\u{8D25}\u{FF1A}${String(err?.message ?? err)}`;
            } finally{
                $9c3d0822d3033a97$var$setUiEnabled(true);
            }
        };
        actions.appendChild(deleteBtn);
        group.appendChild(card);
    }
    $9c3d0822d3033a97$var$replayListEl.appendChild(group);
    $9c3d0822d3033a97$var$scheduleMeCanvasScale();
}
async function $9c3d0822d3033a97$var$loadReplayRecords() {
    const out = await (0, $bmHMf.listMyPaipus)({
        roomType: $9c3d0822d3033a97$var$replayRoomFilter === 'all' ? null : $9c3d0822d3033a97$var$replayRoomFilter,
        variant: $9c3d0822d3033a97$var$replayVariantFilter === 'all' ? null : $9c3d0822d3033a97$var$replayVariantFilter,
        shared: $9c3d0822d3033a97$var$replayShareFilter === 'all' ? null : $9c3d0822d3033a97$var$replayShareFilter
    });
    $9c3d0822d3033a97$var$replayRecords = Array.isArray(out?.items) ? out.items : [];
    $9c3d0822d3033a97$var$replayRecordsLoaded = true;
    $9c3d0822d3033a97$var$renderReplayRecords();
}
async function $9c3d0822d3033a97$var$ensureReplayTabLoaded() {
    if ($9c3d0822d3033a97$var$replayRecordsLoaded) return;
    if ($9c3d0822d3033a97$var$replayTabLoadPromise) {
        await $9c3d0822d3033a97$var$replayTabLoadPromise;
        return;
    }
    $9c3d0822d3033a97$var$replayTabLoadPromise = (async ()=>{
        const loadingText = "\u6B63\u5728\u52A0\u8F7D\u724C\u8C31\u2026";
        const shouldToggleBusy = !$9c3d0822d3033a97$var$uiBusy;
        if (shouldToggleBusy) {
            $9c3d0822d3033a97$var$setUiEnabled(false);
            $9c3d0822d3033a97$var$statusEl.textContent = loadingText;
        }
        try {
            await $9c3d0822d3033a97$var$loadReplayRecords();
            $9c3d0822d3033a97$var$setLoginStatusIfIdle(loadingText);
        } finally{
            if (shouldToggleBusy) $9c3d0822d3033a97$var$setUiEnabled(true);
        }
    })();
    try {
        await $9c3d0822d3033a97$var$replayTabLoadPromise;
    } finally{
        $9c3d0822d3033a97$var$replayTabLoadPromise = null;
    }
}
function $9c3d0822d3033a97$var$openPracticeRecordEditor(item) {
    const body = document.createElement('div');
    body.className = 'field';
    const titleField = document.createElement('div');
    titleField.className = 'field';
    const titleLabel = document.createElement('label');
    titleLabel.textContent = "\u6807\u9898";
    const titleInput = document.createElement('input');
    titleInput.type = 'text';
    titleInput.maxLength = 80;
    titleInput.value = String(item.title ?? '');
    titleField.appendChild(titleLabel);
    titleField.appendChild(titleInput);
    body.appendChild(titleField);
    const noteField = document.createElement('div');
    noteField.className = 'field';
    const noteLabel = document.createElement('label');
    noteLabel.textContent = "\u5907\u6CE8";
    const noteInput = document.createElement('textarea');
    noteInput.maxLength = 500;
    noteInput.value = String(item.note ?? '');
    noteField.appendChild(noteLabel);
    noteField.appendChild(noteInput);
    body.appendChild(noteField);
    const row = document.createElement('div');
    row.className = 'row';
    const saveBtnEl = document.createElement('button');
    saveBtnEl.type = 'button';
    saveBtnEl.className = 'btn-mini primary';
    saveBtnEl.textContent = "\u4FDD\u5B58";
    const cancelBtnEl = document.createElement('button');
    cancelBtnEl.type = 'button';
    cancelBtnEl.className = 'btn-mini ghost';
    cancelBtnEl.textContent = "\u53D6\u6D88";
    cancelBtnEl.onclick = $9c3d0822d3033a97$var$closeModal;
    row.appendChild(saveBtnEl);
    row.appendChild(cancelBtnEl);
    body.appendChild(row);
    saveBtnEl.onclick = async ()=>{
        if ($9c3d0822d3033a97$var$uiBusy) return;
        $9c3d0822d3033a97$var$setUiEnabled(false);
        $9c3d0822d3033a97$var$statusEl.textContent = "\u6B63\u5728\u4FDD\u5B58\u7EC3\u4E60\u8BB0\u5F55\u2026";
        try {
            const out = await (0, $dru5x.patchPracticeRecord)(item.recordId, {
                title: titleInput.value.trim() || null,
                note: noteInput.value.trim() || null
            });
            $9c3d0822d3033a97$var$replacePracticeRecord(out.record);
            $9c3d0822d3033a97$var$renderPracticeRecords();
            $9c3d0822d3033a97$var$closeModal();
            $9c3d0822d3033a97$var$statusEl.textContent = "\u7EC3\u4E60\u8BB0\u5F55\u5DF2\u4FDD\u5B58\u3002";
        } catch (err) {
            $9c3d0822d3033a97$var$statusEl.textContent = `\u{4FDD}\u{5B58}\u{5931}\u{8D25}\u{FF1A}${String(err?.message ?? err)}`;
        } finally{
            $9c3d0822d3033a97$var$setUiEnabled(true);
        }
    };
    $9c3d0822d3033a97$var$openModal("\u7F16\u8F91\u7EC3\u4E60\u9898", "\u6807\u9898\u4E0E\u5907\u6CE8\u4EC5\u5F71\u54CD\u4F60\u81EA\u5DF1\u7684\u8BB0\u5F55\uFF1B\u82E5\u4F60\u5206\u4EAB\u8FD9\u9053\u9898\uFF0C\u5206\u4EAB\u6587\u6848\u4F1A\u540C\u6B65\u66F4\u65B0\u3002", body);
}
function $9c3d0822d3033a97$var$renderPracticeSection(params) {
    const section = document.createElement('section');
    section.className = 'practice-group';
    const head = document.createElement('div');
    head.className = 'practice-group-head';
    section.appendChild(head);
    const titleWrap = document.createElement('div');
    titleWrap.className = 'practice-group-title-wrap';
    head.appendChild(titleWrap);
    const title = document.createElement('div');
    title.className = 'practice-group-title';
    title.textContent = params.title;
    titleWrap.appendChild(title);
    if (params.subtitle.trim()) {
        const subtitle = document.createElement('div');
        subtitle.className = 'practice-group-sub';
        subtitle.textContent = params.subtitle;
        titleWrap.appendChild(subtitle);
    }
    const count = document.createElement('div');
    count.className = 'practice-group-count';
    count.textContent = String(params.items.length);
    head.appendChild(count);
    if (params.items.length <= 0) {
        const empty = document.createElement('div');
        empty.className = 'practice-empty';
        empty.textContent = params.emptyText;
        section.appendChild(empty);
        return section;
    }
    const list = document.createElement('div');
    list.className = 'practice-list';
    section.appendChild(list);
    for (const item of params.items){
        const card = document.createElement('div');
        card.className = 'practice-item';
        const head = document.createElement('div');
        head.className = 'practice-head';
        card.appendChild(head);
        const title = document.createElement('div');
        title.className = 'practice-title';
        title.textContent = (item.title ?? '').trim() || $9c3d0822d3033a97$var$practiceSceneLabel(item.scene);
        head.appendChild(title);
        const headSide = document.createElement('div');
        headSide.className = 'replay-card-head-side';
        head.appendChild(headSide);
        const shareTag = document.createElement('div');
        shareTag.className = 'practice-tag';
        shareTag.textContent = $9c3d0822d3033a97$var$practiceShareStateLabel(item.shareState);
        headSide.appendChild(shareTag);
        const status = document.createElement('div');
        status.className = 'practice-status';
        status.textContent = $9c3d0822d3033a97$var$practiceStatusLabel(item);
        headSide.appendChild(status);
        const meta = document.createElement('div');
        meta.className = 'practice-meta';
        meta.textContent = [
            `\u{6765}\u{6E90}\u{FF1A}${$9c3d0822d3033a97$var$practiceRoomLabel(item.sourceRoomType)} ${item.sourceGameId}`,
            `\u{7C7B}\u{578B}\u{FF1A}${$9c3d0822d3033a97$var$practiceSceneLabel(item.scene)}`,
            `\u{521B}\u{5EFA}\u{FF1A}${$9c3d0822d3033a97$var$formatTime(item.createdAt)}`
        ].join(" \xb7 ");
        card.appendChild(meta);
        if (item.templateStatus === 'disabled') {
            const tags = document.createElement('div');
            tags.className = 'practice-tags';
            const invalidTag = document.createElement('div');
            invalidTag.className = 'practice-tag danger';
            invalidTag.textContent = "\u5DF2\u5931\u6548";
            tags.appendChild(invalidTag);
            card.appendChild(tags);
        }
        if ((item.note ?? '').trim()) {
            const note = document.createElement('div');
            note.className = 'practice-note';
            note.textContent = String(item.note ?? '').trim();
            card.appendChild(note);
        }
        const actions = document.createElement('div');
        actions.className = 'practice-actions';
        card.appendChild(actions);
        const enterBtn = document.createElement('button');
        enterBtn.type = 'button';
        enterBtn.className = 'btn-mini primary';
        enterBtn.textContent = $9c3d0822d3033a97$var$practiceEnterLabel(item);
        enterBtn.disabled = $9c3d0822d3033a97$var$uiBusy || !$9c3d0822d3033a97$var$practiceCanEnter(item);
        enterBtn.onclick = async ()=>{
            if ($9c3d0822d3033a97$var$uiBusy) return;
            $9c3d0822d3033a97$var$setUiEnabled(false);
            $9c3d0822d3033a97$var$statusEl.textContent = "\u6B63\u5728\u8FDB\u5165\u7EC3\u4E60\u9898\u2026";
            try {
                const out = await (0, $dru5x.enterPracticeRecord)(item.recordId);
                const basePath = (0, $iRbTC.getBasePath)();
                window.location.href = `${basePath}hand/?gameId=${encodeURIComponent(out.gameId)}`;
            } catch (err) {
                const active = $9c3d0822d3033a97$var$normalizeActiveGame(err?.data?.activeGame);
                if (active) {
                    $9c3d0822d3033a97$var$statusEl.textContent = "\u5F53\u524D\u5DF2\u6709\u8FDB\u884C\u4E2D\u7684\u724C\u5C40\u3002";
                    $9c3d0822d3033a97$var$openPracticeActiveGameModal(active);
                } else $9c3d0822d3033a97$var$statusEl.textContent = `\u{8FDB}\u{5165}\u{5931}\u{8D25}\u{FF1A}${String(err?.message ?? err)}`;
            } finally{
                $9c3d0822d3033a97$var$setUiEnabled(true);
            }
        };
        actions.appendChild(enterBtn);
        const shareBtn = document.createElement('button');
        shareBtn.type = 'button';
        shareBtn.className = 'btn-mini ghost';
        shareBtn.textContent = item.shareState === 'shared' ? "\u590D\u5236\u5206\u4EAB" : "\u5206\u4EAB";
        shareBtn.disabled = $9c3d0822d3033a97$var$uiBusy || !$9c3d0822d3033a97$var$practiceCanShare(item);
        shareBtn.onclick = async ()=>{
            if ($9c3d0822d3033a97$var$uiBusy) return;
            $9c3d0822d3033a97$var$setUiEnabled(false);
            $9c3d0822d3033a97$var$statusEl.textContent = "\u6B63\u5728\u51C6\u5907\u5206\u4EAB\u94FE\u63A5\u2026";
            try {
                const out = await (0, $dru5x.sharePracticeRecord)(item.recordId);
                $9c3d0822d3033a97$var$replacePracticeRecord(out.record);
                $9c3d0822d3033a97$var$renderPracticeRecords();
                $9c3d0822d3033a97$var$openPracticeShareModal($9c3d0822d3033a97$var$buildAppUrl(out.sharePath));
                $9c3d0822d3033a97$var$statusEl.textContent = "\u5206\u4EAB\u94FE\u63A5\u5DF2\u5C31\u7EEA\u3002";
            } catch (err) {
                $9c3d0822d3033a97$var$statusEl.textContent = `\u{5206}\u{4EAB}\u{5931}\u{8D25}\u{FF1A}${String(err?.message ?? err)}`;
            } finally{
                $9c3d0822d3033a97$var$setUiEnabled(true);
            }
        };
        actions.appendChild(shareBtn);
        const editBtn = document.createElement('button');
        editBtn.type = 'button';
        editBtn.className = 'btn-mini ghost';
        editBtn.textContent = "\u7F16\u8F91";
        editBtn.disabled = $9c3d0822d3033a97$var$uiBusy;
        editBtn.onclick = ()=>$9c3d0822d3033a97$var$openPracticeRecordEditor(item);
        actions.appendChild(editBtn);
        const deleteBtn = document.createElement('button');
        deleteBtn.type = 'button';
        deleteBtn.className = 'btn-mini danger';
        deleteBtn.textContent = "\u5220\u9664";
        deleteBtn.disabled = $9c3d0822d3033a97$var$uiBusy;
        deleteBtn.onclick = async ()=>{
            if ($9c3d0822d3033a97$var$uiBusy) return;
            $9c3d0822d3033a97$var$setUiEnabled(false);
            $9c3d0822d3033a97$var$statusEl.textContent = "\u6B63\u5728\u5220\u9664\u7EC3\u4E60\u8BB0\u5F55\u2026";
            try {
                await (0, $dru5x.deletePracticeRecord)(item.recordId);
                $9c3d0822d3033a97$var$removePracticeRecord(item.recordId);
                $9c3d0822d3033a97$var$renderPracticeRecords();
                $9c3d0822d3033a97$var$statusEl.textContent = "\u7EC3\u4E60\u8BB0\u5F55\u5DF2\u5220\u9664\u3002";
            } catch (err) {
                $9c3d0822d3033a97$var$statusEl.textContent = `\u{5220}\u{9664}\u{5931}\u{8D25}\u{FF1A}${String(err?.message ?? err)}`;
            } finally{
                $9c3d0822d3033a97$var$setUiEnabled(true);
            }
        };
        actions.appendChild(deleteBtn);
        list.appendChild(card);
    }
    return section;
}
function $9c3d0822d3033a97$var$renderPracticeRecords() {
    if (!$9c3d0822d3033a97$var$practiceRecordsLoaded) {
        $9c3d0822d3033a97$var$practiceListEl.innerHTML = '<div class="practice-empty">\u9996\u6B21\u8FDB\u5165\u65F6\u52A0\u8F7D\u7EC3\u4E60\u9898\u3002</div>';
        $9c3d0822d3033a97$var$scheduleMeCanvasScale();
        return;
    }
    $9c3d0822d3033a97$var$practiceListEl.innerHTML = '';
    $9c3d0822d3033a97$var$practiceListEl.appendChild($9c3d0822d3033a97$var$renderPracticeSection({
        title: "\u6211\u7684\u7EC3\u4E60\u5206\u652F\uFF08\u4ECE\u539F\u724C\u5C40\u521B\u5EFA\u7684\u4E2A\u4EBA\u7EC3\u4E60\u8BB0\u5F55\uFF1B\u5206\u4EAB\u540E\u4ECD\u4FDD\u7559\u5728\u8FD9\u91CC\u3002\uFF09",
        subtitle: '',
        items: $9c3d0822d3033a97$var$practiceRecordsMine,
        emptyText: "\u8FD8\u6CA1\u6709\u81EA\u5DF1\u7684\u7EC3\u4E60\u5206\u652F\u3002"
    }));
    $9c3d0822d3033a97$var$practiceListEl.appendChild($9c3d0822d3033a97$var$renderPracticeSection({
        title: "\u5171\u4EAB\u7EC3\u4E60\u9898\uFF08\u901A\u8FC7\u5206\u4EAB\u94FE\u63A5\u6536\u85CF\u7684\u9898\u76EE\uFF1B\u82E5\u6709\u672A\u5B8C\u6210\u7EC3\u4E60\u5C40\uFF0C\u5C06\u4F18\u5148\u7EE7\u7EED\u3002\uFF09",
        subtitle: '',
        items: $9c3d0822d3033a97$var$practiceRecordsShared,
        emptyText: "\u8FD8\u6CA1\u6709\u6536\u85CF\u5171\u4EAB\u7EC3\u4E60\u9898\u3002"
    }));
    $9c3d0822d3033a97$var$scheduleMeCanvasScale();
}
async function $9c3d0822d3033a97$var$loadPracticeRecords() {
    const out = await (0, $dru5x.listPracticeRecords)();
    $9c3d0822d3033a97$var$practiceRecordsMine = Array.isArray(out?.mine) ? out.mine : [];
    $9c3d0822d3033a97$var$practiceRecordsShared = Array.isArray(out?.shared) ? out.shared : [];
    $9c3d0822d3033a97$var$practiceRecordsLoaded = true;
    $9c3d0822d3033a97$var$renderPracticeRecords();
}
async function $9c3d0822d3033a97$var$ensurePracticeTabLoaded() {
    if ($9c3d0822d3033a97$var$practiceRecordsLoaded) return;
    if ($9c3d0822d3033a97$var$practiceTabLoadPromise) {
        await $9c3d0822d3033a97$var$practiceTabLoadPromise;
        return;
    }
    $9c3d0822d3033a97$var$practiceTabLoadPromise = (async ()=>{
        const loadingText = "\u6B63\u5728\u52A0\u8F7D\u7EC3\u4E60\u9898\u2026";
        const shouldToggleBusy = !$9c3d0822d3033a97$var$uiBusy;
        if (shouldToggleBusy) {
            $9c3d0822d3033a97$var$setUiEnabled(false);
            $9c3d0822d3033a97$var$statusEl.textContent = loadingText;
        }
        try {
            await $9c3d0822d3033a97$var$loadPracticeRecords();
            $9c3d0822d3033a97$var$setLoginStatusIfIdle(loadingText);
        } finally{
            if (shouldToggleBusy) $9c3d0822d3033a97$var$setUiEnabled(true);
        }
    })();
    try {
        await $9c3d0822d3033a97$var$practiceTabLoadPromise;
    } finally{
        $9c3d0822d3033a97$var$practiceTabLoadPromise = null;
    }
}
async function $9c3d0822d3033a97$var$ensureSecurityTabLoaded() {
    if ($9c3d0822d3033a97$var$aiSettingsLoaded && $9c3d0822d3033a97$var$aiRulesLoaded) return;
    if ($9c3d0822d3033a97$var$securityTabLoadPromise) {
        await $9c3d0822d3033a97$var$securityTabLoadPromise;
        return;
    }
    $9c3d0822d3033a97$var$securityTabLoadPromise = (async ()=>{
        const loadingText = "\u6B63\u5728\u52A0\u8F7D\u767B\u5F55\u4E0E\u5927\u6A21\u578B\u4FE1\u606F\u2026";
        const shouldToggleBusy = !$9c3d0822d3033a97$var$uiBusy;
        if (shouldToggleBusy) {
            $9c3d0822d3033a97$var$setUiEnabled(false);
            $9c3d0822d3033a97$var$statusEl.textContent = loadingText;
        }
        try {
            if (!$9c3d0822d3033a97$var$aiSettingsLoaded) try {
                await $9c3d0822d3033a97$var$loadAiSettings();
            } catch (err) {
                $9c3d0822d3033a97$var$statusEl.textContent = `\u{52A0}\u{8F7D}\u{5931}\u{8D25}\u{FF1A}${String(err?.message ?? err)}`;
            }
            if (!$9c3d0822d3033a97$var$aiRulesLoaded) try {
                await $9c3d0822d3033a97$var$loadAiRules();
            } catch  {
                $9c3d0822d3033a97$var$aiRulesSourceEl.textContent = "\u52A0\u8F7D\u5931\u8D25";
            }
            $9c3d0822d3033a97$var$setLoginStatusIfIdle(loadingText);
        } finally{
            if (shouldToggleBusy) $9c3d0822d3033a97$var$setUiEnabled(true);
        }
    })();
    try {
        await $9c3d0822d3033a97$var$securityTabLoadPromise;
    } finally{
        $9c3d0822d3033a97$var$securityTabLoadPromise = null;
    }
}
async function $9c3d0822d3033a97$var$switchMeTab(tab, opts) {
    $9c3d0822d3033a97$var$activeTab = tab;
    $9c3d0822d3033a97$var$renderMeTabs(tab);
    if (opts?.syncHash !== false) {
        const hash = $9c3d0822d3033a97$var$tabHash(tab);
        if (window.location.hash !== hash) window.history.replaceState(null, '', hash);
    }
    if (tab === 'pay') {
        await $9c3d0822d3033a97$var$ensurePayTabLoaded();
        $9c3d0822d3033a97$var$scheduleMeCanvasScale();
        return;
    }
    if (tab === 'replay') {
        await $9c3d0822d3033a97$var$ensureReplayTabLoaded();
        $9c3d0822d3033a97$var$scheduleMeCanvasScale();
        return;
    }
    if (tab === 'practice') {
        await $9c3d0822d3033a97$var$ensurePracticeTabLoaded();
        $9c3d0822d3033a97$var$scheduleMeCanvasScale();
        return;
    }
    if (tab === 'security') await $9c3d0822d3033a97$var$ensureSecurityTabLoaded();
    $9c3d0822d3033a97$var$scheduleMeCanvasScale();
}
function $9c3d0822d3033a97$var$initializeTabs() {
    if ($9c3d0822d3033a97$var$tabsInitialized) return;
    $9c3d0822d3033a97$var$tabsInitialized = true;
    $9c3d0822d3033a97$var$meTabAccountBtn.onclick = ()=>{
        $9c3d0822d3033a97$var$switchMeTab('account');
    };
    $9c3d0822d3033a97$var$meTabPayBtn.onclick = ()=>{
        $9c3d0822d3033a97$var$switchMeTab('pay');
    };
    $9c3d0822d3033a97$var$meTabReplayBtn.onclick = ()=>{
        $9c3d0822d3033a97$var$switchMeTab('replay');
    };
    $9c3d0822d3033a97$var$meTabPracticeBtn.onclick = ()=>{
        $9c3d0822d3033a97$var$switchMeTab('practice');
    };
    $9c3d0822d3033a97$var$meTabSecurityBtn.onclick = ()=>{
        $9c3d0822d3033a97$var$switchMeTab('security');
    };
    window.addEventListener('hashchange', ()=>{
        const tab = $9c3d0822d3033a97$var$parseMeTabFromHash();
        if (tab !== $9c3d0822d3033a97$var$activeTab) $9c3d0822d3033a97$var$switchMeTab(tab, {
            syncHash: false
        });
    });
    $9c3d0822d3033a97$var$renderMeTabs($9c3d0822d3033a97$var$activeTab);
}
$9c3d0822d3033a97$var$practiceRefreshBtn.onclick = async ()=>{
    $9c3d0822d3033a97$var$setUiEnabled(false);
    $9c3d0822d3033a97$var$statusEl.textContent = "\u6B63\u5728\u5237\u65B0\u7EC3\u4E60\u9898\u2026";
    try {
        await $9c3d0822d3033a97$var$loadPracticeRecords();
        $9c3d0822d3033a97$var$statusEl.textContent = "\u7EC3\u4E60\u9898\u5DF2\u5237\u65B0\u3002";
    } catch (err) {
        $9c3d0822d3033a97$var$statusEl.textContent = `\u{5237}\u{65B0}\u{5931}\u{8D25}\u{FF1A}${String(err?.message ?? err)}`;
    } finally{
        $9c3d0822d3033a97$var$setUiEnabled(true);
    }
};
$9c3d0822d3033a97$var$replayRefreshBtn.onclick = async ()=>{
    $9c3d0822d3033a97$var$setUiEnabled(false);
    $9c3d0822d3033a97$var$statusEl.textContent = "\u6B63\u5728\u5237\u65B0\u724C\u8C31\u2026";
    try {
        await $9c3d0822d3033a97$var$loadReplayRecords();
        $9c3d0822d3033a97$var$statusEl.textContent = "\u724C\u8C31\u5DF2\u5237\u65B0\u3002";
    } catch (err) {
        $9c3d0822d3033a97$var$statusEl.textContent = `\u{5237}\u{65B0}\u{5931}\u{8D25}\u{FF1A}${String(err?.message ?? err)}`;
    } finally{
        $9c3d0822d3033a97$var$setUiEnabled(true);
    }
};
async function $9c3d0822d3033a97$var$applyReplayFilters(params) {
    if (params.room) $9c3d0822d3033a97$var$replayRoomFilter = params.room;
    if (params.variant) $9c3d0822d3033a97$var$replayVariantFilter = params.variant;
    if (params.shared) $9c3d0822d3033a97$var$replayShareFilter = params.shared;
    $9c3d0822d3033a97$var$replayRecordsLoaded = false;
    $9c3d0822d3033a97$var$renderReplayRecords();
    $9c3d0822d3033a97$var$setUiEnabled(false);
    $9c3d0822d3033a97$var$statusEl.textContent = "\u6B63\u5728\u7B5B\u9009\u724C\u8C31\u2026";
    try {
        await $9c3d0822d3033a97$var$loadReplayRecords();
        $9c3d0822d3033a97$var$statusEl.textContent = "\u724C\u8C31\u7B5B\u9009\u5DF2\u66F4\u65B0\u3002";
    } catch (err) {
        $9c3d0822d3033a97$var$statusEl.textContent = `\u{7B5B}\u{9009}\u{5931}\u{8D25}\u{FF1A}${String(err?.message ?? err)}`;
    } finally{
        $9c3d0822d3033a97$var$setUiEnabled(true);
    }
}
$9c3d0822d3033a97$var$replayFilterRoomAllBtn.onclick = ()=>void $9c3d0822d3033a97$var$applyReplayFilters({
        room: 'all'
    });
$9c3d0822d3033a97$var$replayFilterRoomNewbieBtn.onclick = ()=>void $9c3d0822d3033a97$var$applyReplayFilters({
        room: 'newbie'
    });
$9c3d0822d3033a97$var$replayFilterRoomFriendBtn.onclick = ()=>void $9c3d0822d3033a97$var$applyReplayFilters({
        room: 'friend'
    });
$9c3d0822d3033a97$var$replayFilterVariantAllBtn.onclick = ()=>void $9c3d0822d3033a97$var$applyReplayFilters({
        variant: 'all'
    });
$9c3d0822d3033a97$var$replayFilterVariantXuezhanBtn.onclick = ()=>void $9c3d0822d3033a97$var$applyReplayFilters({
        variant: 'xuezhan'
    });
$9c3d0822d3033a97$var$replayFilterVariantGuobiaoBtn.onclick = ()=>void $9c3d0822d3033a97$var$applyReplayFilters({
        variant: 'guobiao'
    });
$9c3d0822d3033a97$var$replayFilterShareAllBtn.onclick = ()=>void $9c3d0822d3033a97$var$applyReplayFilters({
        shared: 'all'
    });
$9c3d0822d3033a97$var$replayFilterShareSharedBtn.onclick = ()=>void $9c3d0822d3033a97$var$applyReplayFilters({
        shared: 'shared'
    });
$9c3d0822d3033a97$var$replayFilterShareUnsharedBtn.onclick = ()=>void $9c3d0822d3033a97$var$applyReplayFilters({
        shared: 'unshared'
    });
async function $9c3d0822d3033a97$var$applyOfficialModel(modelId, opts) {
    const id = String(modelId ?? '').trim();
    if (!id) return;
    const gatewayId = String(opts?.gatewayId ?? '').trim();
    const shouldSwitchToOfficial = opts?.switchToOfficialDefault === true && $9c3d0822d3033a97$var$aiDefault.source !== 'official';
    $9c3d0822d3033a97$var$setUiEnabled(false);
    $9c3d0822d3033a97$var$statusEl.textContent = "\u6B63\u5728\u66F4\u65B0\u5B98\u65B9\u6A21\u578B\u2026";
    if (shouldSwitchToOfficial) $9c3d0822d3033a97$var$statusEl.textContent = `\u{6B63}\u{5728}\u{5207}\u{6362}\u{5230}\u{5B98}\u{65B9}\u{5E76}\u{4F7F}\u{7528} ${id}\u{2026}`;
    else $9c3d0822d3033a97$var$statusEl.textContent = `\u{6B63}\u{5728}\u{5207}\u{6362}\u{5B98}\u{65B9}\u{6A21}\u{578B}\u{5230} ${id}\u{2026}`;
    try {
        await (0, $7xapJ.setAiOfficialModel)({
            modelId: id,
            gatewayId: gatewayId || undefined
        });
        if (shouldSwitchToOfficial) {
            await (0, $7xapJ.setAiDefault)({
                source: 'official',
                profileId: null
            });
            await $9c3d0822d3033a97$var$loadAiSettings();
            const activeModel = String($9c3d0822d3033a97$var$aiOfficial.model ?? '').trim();
            $9c3d0822d3033a97$var$statusEl.textContent = activeModel ? `\u{5DF2}\u{5207}\u{6362}\u{5230}\u{5B98}\u{65B9}\u{6765}\u{6E90}\u{5E76}\u{4F7F}\u{7528}\u{FF1A}${activeModel}` : `\u{5DF2}\u{5207}\u{6362}\u{5230}\u{5B98}\u{65B9}\u{6765}\u{6E90}\u{5E76}\u{5E94}\u{7528}\u{6A21}\u{578B}\u{FF1A}${id}`;
            return;
        }
        await $9c3d0822d3033a97$var$loadAiSettings();
        $9c3d0822d3033a97$var$statusEl.textContent = `\u{5DF2}\u{5207}\u{6362}\u{6A21}\u{578B}\u{FF1A}${id}`;
    } catch (err) {
        try {
            await $9c3d0822d3033a97$var$loadAiSettings();
        } catch  {
        // Ignore secondary refresh failure; preserve original update error.
        }
        $9c3d0822d3033a97$var$statusEl.textContent = `\u{66F4}\u{65B0}\u{5931}\u{8D25}\u{FF1A}${String(err?.message ?? err)}`;
    } finally{
        $9c3d0822d3033a97$var$setUiEnabled(true);
    }
}
$9c3d0822d3033a97$var$aiBillingRefreshBtn.onclick = async ()=>{
    $9c3d0822d3033a97$var$setUiEnabled(false);
    $9c3d0822d3033a97$var$statusEl.textContent = "\u6B63\u5728\u5237\u65B0\u8350\u724C\u8D26\u5355\u2026";
    $9c3d0822d3033a97$var$setPayActionStatus("\u6B63\u5728\u5237\u65B0\u8D26\u5355\u2026");
    try {
        await $9c3d0822d3033a97$var$loadAiBilling();
        $9c3d0822d3033a97$var$statusEl.textContent = "\u5DF2\u5237\u65B0\u8350\u724C\u8D26\u5355\u3002";
        $9c3d0822d3033a97$var$setPayActionStatus("\u8D26\u5355\u5DF2\u5237\u65B0\u3002");
    } catch (err) {
        $9c3d0822d3033a97$var$statusEl.textContent = `\u{5237}\u{65B0}\u{5931}\u{8D25}\u{FF1A}${String(err?.message ?? err)}`;
        $9c3d0822d3033a97$var$setPayActionStatus(`\u{8D26}\u{5355}\u{5237}\u{65B0}\u{5931}\u{8D25}\u{FF1A}${String(err?.message ?? err)}`);
    } finally{
        $9c3d0822d3033a97$var$setUiEnabled(true);
    }
};
$9c3d0822d3033a97$var$payCreateOrderBtn.onclick = async ()=>{
    if ($9c3d0822d3033a97$var$payConfigError) {
        $9c3d0822d3033a97$var$statusEl.textContent = $9c3d0822d3033a97$var$payConfigError;
        $9c3d0822d3033a97$var$setPayActionStatus($9c3d0822d3033a97$var$payConfigError);
        return;
    }
    if ($9c3d0822d3033a97$var$payMode !== 'xorpay') {
        $9c3d0822d3033a97$var$statusEl.textContent = "\u5F53\u524D\u4E3A\u624B\u52A8\u5145\u503C\u6A21\u5F0F\uFF1A\u8BF7\u8054\u7CFB\u7BA1\u7406\u5458\u3002";
        $9c3d0822d3033a97$var$setPayActionStatus("\u5F53\u524D\u4E3A\u624B\u52A8\u5145\u503C\u6A21\u5F0F\uFF0C\u8BF7\u8054\u7CFB\u7BA1\u7406\u5458\u3002");
        return;
    }
    const packageId = $9c3d0822d3033a97$var$paySelectedPackageId.trim();
    const channel = $9c3d0822d3033a97$var$paySelectedChannel;
    if (!packageId) {
        $9c3d0822d3033a97$var$statusEl.textContent = "\u8BF7\u5148\u9009\u62E9\u5145\u503C\u5957\u9910\u3002";
        $9c3d0822d3033a97$var$setPayActionStatus("\u8BF7\u9009\u62E9\u5145\u503C\u5957\u9910\u3002");
        return;
    }
    if (channel !== 'alipay' && channel !== 'wechat_native') {
        $9c3d0822d3033a97$var$statusEl.textContent = "\u8BF7\u9009\u62E9\u6709\u6548\u652F\u4ED8\u6E20\u9053\u3002";
        $9c3d0822d3033a97$var$setPayActionStatus("\u8BF7\u9009\u62E9\u6709\u6548\u652F\u4ED8\u6E20\u9053\u3002");
        return;
    }
    $9c3d0822d3033a97$var$setUiEnabled(false);
    $9c3d0822d3033a97$var$setPayCreateLoading(true, "\u6B63\u5728\u521B\u5EFA\u652F\u4ED8\u8BA2\u5355\u2026");
    $9c3d0822d3033a97$var$statusEl.textContent = "\u6B63\u5728\u521B\u5EFA\u652F\u4ED8\u8BA2\u5355\u2026";
    $9c3d0822d3033a97$var$setPayActionStatus("\u6B63\u5728\u521B\u5EFA\u652F\u4ED8\u8BA2\u5355\u2026");
    try {
        const out = await (0, $7xapJ.createPayOrder)({
            packageId: packageId,
            channel: channel
        });
        const order = out.order ?? null;
        if (!order) throw new Error("\u521B\u5EFA\u8BA2\u5355\u5931\u8D25");
        $9c3d0822d3033a97$var$payCurrentOrder = order;
        $9c3d0822d3033a97$var$renderPaySection();
        $9c3d0822d3033a97$var$statusEl.textContent = `\u{652F}\u{4ED8}\u{8BA2}\u{5355}\u{5DF2}\u{521B}\u{5EFA}\u{FF1A}${order.id}`;
        $9c3d0822d3033a97$var$setPayActionStatus(`\u{8BA2}\u{5355}\u{5DF2}\u{521B}\u{5EFA}\u{FF1A}${order.id}`);
        if (order.payUrl) {
            if (!$9c3d0822d3033a97$var$isDesktopPayView() && order.channel === 'alipay') window.open(order.payUrl, '_blank', 'noopener,noreferrer');
            else if (!$9c3d0822d3033a97$var$isDesktopPayView() && order.channel === 'wechat_native') {
                $9c3d0822d3033a97$var$statusEl.textContent = `\u{652F}\u{4ED8}\u{8BA2}\u{5355}\u{5DF2}\u{521B}\u{5EFA}\u{FF1A}${order.id}\u{FF08}\u{5FAE}\u{4FE1}\u{8BF7}\u{7528}\u{53E6}\u{4E00}\u{53F0}\u{8BBE}\u{5907}\u{626B}\u{7801}\u{FF09}`;
                $9c3d0822d3033a97$var$setPayActionStatus(`\u{8BA2}\u{5355}\u{5DF2}\u{521B}\u{5EFA}\u{FF1A}${order.id}\u{FF08}\u{5FAE}\u{4FE1}\u{8BF7}\u{7528}\u{53E6}\u{4E00}\u{53F0}\u{8BBE}\u{5907}\u{626B}\u{7801}\u{FF09}`);
            }
        }
        if (!$9c3d0822d3033a97$var$isFinalPayStatus(order.status)) $9c3d0822d3033a97$var$startPayPolling(order.id);
        try {
            await $9c3d0822d3033a97$var$loadAiBilling();
        } catch (billingErr) {
            console.warn('[pay] load billing after create failed', billingErr);
            $9c3d0822d3033a97$var$statusEl.textContent = `\u{652F}\u{4ED8}\u{8BA2}\u{5355}\u{5DF2}\u{521B}\u{5EFA}\u{FF1A}${order.id}\u{FF08}\u{8D26}\u{5355}\u{5237}\u{65B0}\u{5931}\u{8D25}\u{FF0C}\u{53EF}\u{7A0D}\u{540E}\u{624B}\u{52A8}\u{5237}\u{65B0}\u{FF09}`;
            $9c3d0822d3033a97$var$setPayActionStatus(`\u{8BA2}\u{5355}\u{5DF2}\u{521B}\u{5EFA}\u{FF1A}${order.id}\u{FF08}\u{8D26}\u{5355}\u{5237}\u{65B0}\u{5931}\u{8D25}\u{FF0C}\u{53EF}\u{624B}\u{52A8}\u{5237}\u{65B0}\u{FF09}`);
        }
    } catch (err) {
        $9c3d0822d3033a97$var$statusEl.textContent = `\u{521B}\u{5EFA}\u{8BA2}\u{5355}\u{5931}\u{8D25}\u{FF1A}${String(err?.message ?? err)}`;
        $9c3d0822d3033a97$var$setPayActionStatus(`\u{521B}\u{5EFA}\u{8BA2}\u{5355}\u{5931}\u{8D25}\u{FF1A}${String(err?.message ?? err)}`);
    } finally{
        $9c3d0822d3033a97$var$setPayCreateLoading(false);
        $9c3d0822d3033a97$var$setUiEnabled(true);
    }
};
$9c3d0822d3033a97$var$aiRulesSaveBtn.onclick = async ()=>{
    const text = $9c3d0822d3033a97$var$aiRulesTextarea.value;
    if (!text.trim()) {
        $9c3d0822d3033a97$var$statusEl.textContent = "\u4FDD\u5B58\u5931\u8D25\uFF1A\u89C4\u5219\u4E0D\u80FD\u4E3A\u7A7A\uFF08\u5982\u8981\u6062\u590D\u5168\u5C40\u89C4\u5219\uFF0C\u8BF7\u70B9\u201C\u6062\u590D\u8DDF\u968F\u5168\u5C40\u201D\uFF09\u3002";
        return;
    }
    $9c3d0822d3033a97$var$setUiEnabled(false);
    $9c3d0822d3033a97$var$aiRulesSaveBtn.disabled = true;
    $9c3d0822d3033a97$var$aiRulesResetBtn.disabled = true;
    $9c3d0822d3033a97$var$statusEl.textContent = "\u6B63\u5728\u4FDD\u5B58\u9EBB\u5C06\u89C4\u5219\u6A21\u677F\u2026";
    try {
        await (0, $7xapJ.setAiRules)(text);
        await $9c3d0822d3033a97$var$loadAiRules();
        $9c3d0822d3033a97$var$statusEl.textContent = "\u5DF2\u4FDD\u5B58\u9EBB\u5C06\u89C4\u5219\u6A21\u677F\uFF08\u81EA\u5B9A\u4E49\u4F18\u5148\uFF09\u3002";
    } catch (err) {
        $9c3d0822d3033a97$var$statusEl.textContent = `\u{4FDD}\u{5B58}\u{5931}\u{8D25}\u{FF1A}${String(err?.message ?? err)}`;
    } finally{
        $9c3d0822d3033a97$var$aiRulesSaveBtn.disabled = false;
        $9c3d0822d3033a97$var$aiRulesResetBtn.disabled = !$9c3d0822d3033a97$var$aiRules.user;
        $9c3d0822d3033a97$var$setUiEnabled(true);
    }
};
$9c3d0822d3033a97$var$aiRulesResetBtn.onclick = async ()=>{
    if (!confirm("\u786E\u5B9A\u6062\u590D\u8DDF\u968F\u5168\u5C40\u89C4\u5219\u5417\uFF1F\u4F60\u7684\u81EA\u5B9A\u4E49\u89C4\u5219\u6A21\u677F\u5C06\u88AB\u5220\u9664\uFF0C\u4E14\u65E0\u6CD5\u6062\u590D\u3002")) return;
    $9c3d0822d3033a97$var$setUiEnabled(false);
    $9c3d0822d3033a97$var$aiRulesSaveBtn.disabled = true;
    $9c3d0822d3033a97$var$aiRulesResetBtn.disabled = true;
    $9c3d0822d3033a97$var$statusEl.textContent = "\u6B63\u5728\u6062\u590D\u5168\u5C40\u89C4\u5219\u2026";
    try {
        await (0, $7xapJ.setAiRules)(null);
        await $9c3d0822d3033a97$var$loadAiRules();
        $9c3d0822d3033a97$var$statusEl.textContent = "\u5DF2\u6062\u590D\u8DDF\u968F\u5168\u5C40\u89C4\u5219\u3002";
    } catch (err) {
        $9c3d0822d3033a97$var$statusEl.textContent = `\u{6062}\u{590D}\u{5931}\u{8D25}\u{FF1A}${String(err?.message ?? err)}`;
    } finally{
        $9c3d0822d3033a97$var$aiRulesSaveBtn.disabled = false;
        $9c3d0822d3033a97$var$aiRulesResetBtn.disabled = !$9c3d0822d3033a97$var$aiRules.user;
        $9c3d0822d3033a97$var$setUiEnabled(true);
    }
};
$9c3d0822d3033a97$var$aiRulesTextarea.addEventListener('input', ()=>{
    $9c3d0822d3033a97$var$updateAiRulesDraftMeta();
});
window.addEventListener('beforeunload', (e)=>{
    $9c3d0822d3033a97$var$stopPayPolling();
    if ($9c3d0822d3033a97$var$aiRulesDirty) {
        e.preventDefault();
        e.returnValue = '';
    }
});
async function $9c3d0822d3033a97$var$bootstrap() {
    try {
        const existing = (0, $8PAWz.getLoginToken)();
        $9c3d0822d3033a97$var$statusEl.textContent = existing ? "\u6B63\u5728\u52A0\u8F7D\u8D26\u53F7\u4FE1\u606F\u2026" : "\u9996\u6B21\u8BBF\u95EE\uFF1A\u6B63\u5728\u4E3A\u4F60\u521B\u5EFA\u8D26\u53F7\u2026";
        $9c3d0822d3033a97$var$setUiEnabled(false);
        const { created: created, loginToken: loginToken, apiToken: apiToken, user: user } = await (0, $8PAWz.ensureUser)();
        $9c3d0822d3033a97$var$currentUser = user;
        $9c3d0822d3033a97$var$selectedAvatarIndex = $9c3d0822d3033a97$var$normalizePresetAvatarIndex(user.avatarIndex);
        $9c3d0822d3033a97$var$nickInput.value = user.nickname;
        $9c3d0822d3033a97$var$renderMatchPoints();
        $9c3d0822d3033a97$var$bgmEnabledInput.checked = user.bgmEnabled !== false;
        $9c3d0822d3033a97$var$sfxEnabledInput.checked = user.sfxEnabled !== false;
        $9c3d0822d3033a97$var$loginTokenInput.value = loginToken;
        $9c3d0822d3033a97$var$renderAvatarSection();
        $9c3d0822d3033a97$var$statusEl.textContent = created ? `\u{5DF2}\u{521B}\u{5EFA}\u{8D26}\u{53F7}\u{FF1A}${user.nickname}` : `\u{5DF2}\u{767B}\u{5F55}\u{FF1A}${user.nickname}`;
        $9c3d0822d3033a97$var$contentEl.style.display = 'block';
        $9c3d0822d3033a97$var$scheduleMeCanvasScale();
        if (created) $9c3d0822d3033a97$var$openModal("\u5DF2\u4E3A\u4F60\u521B\u5EFA\u8D26\u53F7", "\u8BF7\u7ACB\u5373\u590D\u5236\u4FDD\u5B58\u3002API Token \u4EC5\u5C55\u793A\u4E00\u6B21\uFF0C\u4E22\u5931\u53EA\u80FD\u91CD\u7F6E\u3002", (()=>{
            const wrap = document.createElement('div');
            wrap.className = 'field';
            wrap.appendChild($9c3d0822d3033a97$var$buildCopyField(loginToken, "\u767B\u5F55\u53E3\u4EE4"));
            if (apiToken) wrap.appendChild($9c3d0822d3033a97$var$buildCopyField(apiToken, "API Token\uFF08\u4EC5\u5C55\u793A\u4E00\u6B21\uFF09"));
            return wrap;
        })());
        $9c3d0822d3033a97$var$initializeTabs();
        const initialTab = $9c3d0822d3033a97$var$parseMeTabFromHash();
        await $9c3d0822d3033a97$var$switchMeTab(initialTab);
    } catch (err) {
        $9c3d0822d3033a97$var$statusEl.textContent = `\u{52A0}\u{8F7D}\u{5931}\u{8D25}\u{FF1A}${String(err?.message ?? err)}\u{FF08}\u{4F60}\u{53EF}\u{4EE5}\u{56DE}\u{5230}\u{9996}\u{9875}\u{91CD}\u{65B0}\u{767B}\u{5F55}\u{FF09}`;
        $9c3d0822d3033a97$var$contentEl.style.display = 'none';
    } finally{
        $9c3d0822d3033a97$var$setUiEnabled(true);
    }
}
$9c3d0822d3033a97$var$bootstrap();


//# sourceMappingURL=me.d0767ecb.js.map
